import { AfterContentInit, AfterViewInit, ComponentFactoryResolver, InjectFlags, Injectable } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { LocationService } from './location.service';
import { Location } from './location';
import { Plan } from '../plans/plan';
import { Customer } from '../customers/customers';
import { BehaviorSubject, EMPTY, Observable, Subject, combineLatest, empty, forkJoin, of } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter, mergeMap, catchError } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Contact } from '../contacts/contact';
import { Subdivision } from '../subdivisions/subdivision';
import { MatRipple } from '@angular/material/core';
import { MessagerComponent } from '../messager/messager/messager.component';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { AuthService } from '../auth.service';
import { LoggingService } from '../utils/logging.service';
import { ScheduleService } from '../schedule/schedule.service';
import { RatingPhotosDialogComponent } from '../schedule/rating-photos/ratingphotos.component';
import { RaterformComponent } from '../raterform/raterform/raterform.component';
import { io } from 'socket.io-client';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PlanService } from '../plans/plan.service';
import { CustomerService } from '../customers/customers.service';
import { GridEmailComponent } from '../utils/grid-email-component';
import { FormLogsComponent } from './formLogsModal/formLogs.component';
import { ConfirmationDialogComponent } from '../shared/dialoges/confirmation-dialog/confirmation-dialog.component';
import { MatAutocompleteTrigger, MatSnackBar, MatTabChangeEvent, MatTableDataSource } from '@angular/material';
import { DesignsEntity } from '../design/design.model';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import * as XLSX from 'xlsx';

//Font Awesome Icons
import { faEdit, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { faScroll } from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { GridDeleteComponent } from '../utils/grid-delete-component';
import { ContactsService } from '../contacts/contacts.service';
import { GlobalEmailService } from '../utils/globalemail.service';
import { EmployeeService } from '../employee/employee.service';
import { environment } from 'src/environments/environment';
import { animate, style, transition, trigger } from '@angular/animations';
import { UploadSnackBarComponent } from '../utils/uploadSnackbar/uploadSnackbar.component';
import { TagsDialogComponent } from './tags.component';
import { MatAutocomplete, MatChipInputEvent, MatTabGroup } from '@angular/material';
import { TagService } from '../utils/tags.service';
import { WarningPopupComponent } from '../utils/warning-popup/warning-popup.component';
import { AddNoteDialogComponent } from '../utils/add-note-dialog/add-note-dialog.component';
import * as moment from 'moment';
import { TimeCardDialogComponent } from '../schedule/schedule/timecard-dialog.component';
import { RaterFormService } from '../raterform/raterform.service';
import { SubdivisionService } from '../subdivisions/subdivision.service';
import { NewScopeDialogComponent } from '../subdivisions/subdivisions/subdivisions.component';
import { AdditionalworkComponent } from '../additionalwork/additionalwork.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { EDITING_MODE, ADDING_MODE, MANDATORY_JOB_TAG_ID, BARRIS_EMPLOYEE_ID, BARRIS_UNAVAILABLE_DAYS,
  BARRIS_UNAVAILABLE_TITLE, BARRIS_UNAVAILABLE_MSG, SQFT_REMINDER_CUSTOMER_IDS } from '../utils/constants';
import { isQIJob } from '../schedule/schedule-view';
import { convert_schedule_date_to_string_date, formatDateOnly, buildExtraNotesUrl, isSchedulingUser, isCapacityExemptUser } from '../utils/helpers';
import { JobTypeService } from '../jobs/jobtypes.service';
import { CustomerJobService } from '../customers/customerjobs.service';


// tslint:disable:no-console
export interface Region {
  value: string;
  viewValue: string;
}



export interface LocationDialogData {
  qa_review?: string;
  targetset: boolean;
  threetenrep: string;
  refrigpw: string;
  track: number;
  comptrack: number;
  premiseno: string;
  location_id: number;
  subdivision: number;
  subdivision_name: string;
  lot: string;
  street_address: string;
  city: string;
  state: string;
  zip: string;
  plan: number;
  plan_name: string;
  site_notes: any;
  cert_printed: boolean;
  hers_index: number;
  ratingtool: string;
  taxcred: boolean;
  ratingtypeuse: string;
  disclosuresent: boolean;
  hvac_design_id: number;
  permit_no: string;
  registryid: string;
  adminnotes: any;
  pdwdone: boolean;
  emailedbuilder: boolean;
  runnumber: number;
  jurs_id: number;
  taxparcel: string;
  hvac_contractor_id: number;
  customer_id: number;
  hvac_done: boolean;
  hvacnotes: string;
  hvacerrors: boolean;
  builder_done: boolean;
  builder_initials: string;
  tec_date?: string | null;
  hvacovrd: boolean;
  reviewcomplete: boolean;
  savings: string;
  elevback: string;
  elevfront: string;
  elevright: string;
  elevleft: string;
  closedate? : string | null;
  adminarchive: boolean;
  sbmt_dsn_id: number;
  hvacresubmt: boolean;
  rebate2: boolean;
  rebate1: boolean;
  rem_done: boolean;
  loclog: string;
  weatherloc: string;
  ekotrope_id: string;
  roughnotice: boolean;
  roughreport: boolean;
  finalnotice: boolean;
  finalreport: boolean;
  missinginfo: boolean;
  scope: string;
  contacts: string;
  permitdate?: string | null;
  final_done: boolean;
  cfsent: boolean;
  countyform: string;
  billing_notes: any;
  startdate?: string | null;
  folderid: string;
  mode: number;
  usernamee: string;
  buid: string;
  rebate3: boolean;
  gasutility: string;
  elecutility: string;
  premnochkd: boolean;
  prmnochkdat: string;
  qad: string;
  qatype: string;
  qadate?: string | null;
  qanotes: string;
  qareported: boolean;
  qad2: string;
  qatype2: string;
  qadate2?: string | null;
  qanotes2: string;
  qareported2: boolean;
  rebate2stat: string;
  auditorname: string;
  constage : string;
  nrgprogram : string;
  audtype :string;
  audnotes : string;
  ovlscore : number;
  audinspdate? : string | null;
  audreported : boolean;
  region : string;
  esmfnc : boolean;
  l_tags: number[];
  mfplanoverride: boolean;
  gasrebatedetails: any;
  electricrebatedetails: any;
  gasrebate: string;
  elecrebate: string;
  swppp : boolean;
  socketid : any;
  hvac_dr_request : boolean;
}

@Component({
  selector: 'app-view-fail-notes',
  templateUrl: './view-fail-notes.html',
  styleUrls: ['./location.component.css']
})
export class ViewFailNotesComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ViewFailNotesComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb:FormBuilder, public service: LocationService, private messager: MessagerComponent, public contactService: ContactsService) {}


  ngOnInit(){

  }

}

@Component({
  selector: 'app-hvac-review',
  templateUrl: './hvac-review-component.html',
  styleUrls: ['./hvac-review.component.css']
})
export class HVACreviewComponent implements OnInit, AfterContentInit {
  constructor(public dialogRef: MatDialogRef<HVACreviewComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private locationService: LocationService, private fb:FormBuilder, public service: LocationService, private messager: MessagerComponent, public contactService: ContactsService) {}


  currSystem;
  cooling;
  coolpct;
  difference;
  condenser;
  evaporator;
  furnace;
  name;
  raterwa;
  ratercfa;
  raternooc;
  ratershgc;
  ratergshgc
  ratervent;
  higher;
  ventRate;

  designeremail;

  form = new FormGroup({
    wa : new FormControl(this.data.submittedData[0]?.wa || 0),
    cfa : new FormControl(this.data.submittedData[0]?.cfa || 0),
    shgc : new FormControl(this.data.submittedData[0]?.shgc || 0),
    noocupants : new FormControl(this.data.submittedData[0]?.noocupants || 0),
    outdoortemplocation : new FormControl(this.data.submittedData[0]?.outdoortemplocation.trim() || ''),
    mechanicalvent : new FormControl(this.data.submittedData[0]?.mechanicalvent || 0)
  });


  ngOnInit(){

    //load RH plan data
    this.ventRate = this.data.submittedData[0].mechanicalvent;

    this.currSystem = 0;
    let realShgc = ( this.data.submittedData[0].shgc > 1 ? this.data.submittedData[0].shgc / 100 : this.data.submittedData[0].shgc ) || 0;
    this.form.get('shgc').setValue(realShgc);


    this.designeremail = this.data.submittedData[0].designeremail;
    //preload first system
    this.cooling = this.data.submittedData[this.currSystem].coolingsizinglimit;
    this.coolpct = this.data.submittedData[0].coolsizingpct;
    this.difference = this.data.submittedData[0].difference;
    this.name = this.data.submittedData[0].name;


    //make sure that the equipment IDs are matching

          let equipIndex = 0;

          //make sure the equipment IDs are matching. If not, find the correct equipment_id
          if(this.data.submittedData[0].og_eq_id != this.data.submittedData[0].equipment_id){


            //iterate through submittedData until you find the correct equipment_id

            for(let i = 0; i < this.data.submittedData.length; i++){
              if(this.data.submittedData[i].og_eq_id == this.data.submittedData[0].equipment_id){
                equipIndex = i;
              }
            }

          }


    this.locationService.getHVACequipValues(this.data.submittedData[equipIndex].sbmt_eq_id).subscribe(
      (res)=> {
        this.condenser = res.Equipment.condensermn;
        this.evaporator = res.Equipment.evapmn;
        this.furnace = res.Equipment.furnacemn || '(Not Listed)';
      },err => {
        this.messager.openSnackBar('Could not load equipment', '','errorAlert');
      }
    )


    //laod number of bedrooms from plan data
    this.locationService.getRaterHvacReview(this.data.submittedData.plan_id).subscribe(
      (res) => {
        //this.raterwa = res.Plan.windowarea;
        //this.ratercfa = res.Plan.cfa;
        this.raternooc = parseInt(res.Plan.bedrooms) + 1;
      },err => {
      }
    )

    this.locationService.getEkotropeProjectId(this.data.location_id).subscribe(
      res => {
        this.locationService.getEkoHvacReview(res.Data.ekotrope_id).subscribe(
          (res) => {
            this.raterwa = res.Data.window_area;
            this.ratercfa = res.Data.conditioned_area;
          }, err => {
          }
        )

      }
    )


    this.locationService.getLastRaterform(this.data.submittedData[0].location_id).subscribe(
      (res) => {
        this.ratergshgc = (res.FormData.glass_door_shgc > 1 ? res.FormData.glass_door_shgc / 100 : res.FormData.window_shgc) || 0;
        this.ratershgc = (res.FormData.window_shgc > 1 ? res.FormData.window_shgc / 100 : res.FormData.window_shgc ) || 0;
        this.ratervent = res.FormData.vent_rate_total;
        this.higher = Math.max(this.ratergshgc, this.ratershgc);

      },err=> {
      }
    )

    //set first system tab active
    //document.getElementById('system_1').className='tooltip tab-link active';

  } //onInit


  ngAfterContentInit() {
  }

  emailBuilder(designer) :void {

    let newObj = {
      designeremail : this.designeremail || 'no one',
      subdivision_name : this.data.subdivision_name,
      lot : this.data.lot,
      street_address : this.data.street_address,
      hvacnotes :	 (document.getElementById("emailnotes") as HTMLInputElement).value,
      hvac_dsn_descrpt : this.data.submittedData[0].hvac_dsn_descrpt,
    }



    this.locationService.submitHVACemail(newObj).subscribe(
      (res)=> {
        if(!res.Error){
          this.messager.openSnackBar('Email sent!', '', 'successAlert');
        }else {
          this.messager.openSnackBar('Email failed to send ' + res.Message, '', 'errorAlert');
        }
      },err => {
          this.messager.openSnackBar('Email failed to send ' + err, '', 'errorAlert');
      }
    )
  }

  completeReview(complete: boolean): void {


          var dated = new Date(Date.now());
							var dd = dated.getDate().toFixed(0);
							var mm = (dated.getMonth()+1).toFixed(0);

							var yyyy = dated.getFullYear();
							if(parseInt(dd)<10){
							    dd='0';
							}
							if(parseInt(mm)<10){
							    mm='0'+mm;
							}

							var today = mm+'-'+dd+'-'+yyyy;




					var newSubmit =
					{
						hvac_dsn_descrpt : this.data.submittedData[0].hvac_dsn_descrpt,
						hvaccfa : (document.getElementById("cfaInput") as HTMLInputElement).value,
						hvacwa	: (document.getElementById("waInput") as HTMLInputElement).value,
						hvacshgc : (document.getElementById("shgcInput") as HTMLInputElement).value,
						hvactemploc : (document.getElementById("outdoorInput") as HTMLInputElement).value,
						hvacnooc : (document.getElementById("noocInput") as HTMLInputElement).value,
            hvacvent : (document.getElementById("ventInput") as HTMLInputElement).value,
						reviewcomplete : complete,
						hvac_design_id : this.data.submittedData[0].hvac_design_id,
						date : today,
						location_id : this.data.submittedData[0].location_id,
						sbmt_dsn_id : this.data.submittedData[0].sbmt_dsn_id
					};


					if(this.data.submittedData[0].sbmt_dsn_id > 0){
						//alertify.success('called.');
						this.locationService.updateHVACBasics(this.data.submittedData[0].sbmt_dsn_id, newSubmit)
						.subscribe(
              (response) => {
							this.messager.openSnackBar('Updated on HVAC end.', '', 'successAlert');
						},err=>{
							this.messager.openSnackBar('Error, updating the basics.', '', 'successAlert');
            });
					} else {
              this.messager.openSnackBar('Successfully updated the preliminary data', '', 'errorAlert');
					}

          let newNotes = {
            hvacerrors 	: (document.getElementById('errorCheck') as HTMLInputElement).checked,
            hvacnotes 	: (document.getElementById("emailnotes") as HTMLInputElement)?.value || '',
            hvac_done : complete
          }


					this.locationService.hvacNotes(this.data.submittedData[0].location_id, newNotes)
					.subscribe((response)=>{
						this.locationService.designReview(newSubmit)
						.subscribe((response) =>{
							if(!response.Error)
							{
								if(complete = false)
								{
									this.locationService.resetDesign(this.data.submittedData[0].location_id)
									.subscribe((response) =>
									{
										setTimeout(() => {
                      this.messager.openSnackBar('This will be returned to the contractor', '', 'successAlert');
                      this.dialogRef.close();
                    }, 2000);
									},err => {
										this.messager.openSnackBar('An error occurred resetting the design, but review still saved.', '', 'errorAlert');
                  });
								} else{

                  setTimeout(() => {
                    this.messager.openSnackBar('Your review saved, and is complete!', '', 'successAlert');
                    this.dialogRef.close();
                  }, 1000);
                }
							}
							else{
								//this.messager.openSnackBar(response.Message, '', 'errorAlert');
							}
						}, err => {

            });

					},err => {
								//this.messager.openSnackBar('Error: submitting notes.', '', 'errorAlert');
          });




  }


  calcDiff(val1, val2): number {
    return Math.abs(val1 - val2);
  }

  changeSystem(evt, num): void {
    this.currSystem = num;
    this.cooling = this.data.submittedData[num].coolingsizinglimit;
    this.coolpct = this.data.submittedData[num].coolsizingpct;
    this.difference = this.data.submittedData[num].difference;
    this.name = this.data.submittedData[num].name;


    let equipIndex = num;

    //make sure the equipment IDs are matching. If not, find the correct equipment_id
    if(this.data.submittedData[num].og_eq_id != this.data.submittedData[num].equipment_id){


      //iterate through submittedData until you find the correct equipment_id

      for(let i = 0; i < this.data.submittedData.length; i++){
        if(this.data.submittedData[i].og_eq_id == this.data.submittedData[num].equipment_id){
          equipIndex = i;
        }
      }

    }

    //get Equipment using sbmt_dsn_id
    this.locationService.getHVACequipValues(this.data.submittedData[equipIndex].sbmt_eq_id).subscribe(
      (res)=> {
        this.condenser = res.Equipment.condensermn;
        this.evaporator = res.Equipment.evapmn;
        this.furnace = res.Equipment.furnacemn || '(Not Listed)';
      },err => {
        this.messager.openSnackBar('Could not load equipment', '','errorAlert');
      }
    )

    let tablink, i;
    tablink = document.getElementsByClassName("hvac-tab-link");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].class = tablink[i].class.replace(" active", "");
    }

    evt.currentTarget.class += " active";

  }

  getColor(icon): string {

    switch(icon){
      case 'cfa':
      if(this.form.get('cfa').value >= (this.ratercfa - 100) && this.form.get('cfa').value <= (parseInt(this.ratercfa) + 300) ){
        return 'fillGreen';
      }else{
        return 'fillRed';
      }
      case 'wa':
        if(this.raterwa < 500){
          if(this.form.get('wa').value >= (this.raterwa - 15) && this.form.get('wa').value <= (parseInt(this.raterwa) + 60) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'fillGreen';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'fillRed';
          }
        }else{
          if(this.form.get('wa').value >= (parseInt(this.raterwa) - (parseInt(this.raterwa) * 0.03)) && this.form.get('wa').value <= (parseInt(this.raterwa) + (parseInt(this.raterwa) * 0.12 ) ) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'fillGreen';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'fillRed';
          }
        }
      case 'noocupants':
        if(Math.abs(this.form.get('noocupants').value - this.raternooc) <= 2  ){
          document.getElementById('noocInput').style.color = "#44AC2A";
          return 'fillGreen';
        }else{
          document.getElementById('noocInput').style.color = "red";
          return 'fillRed';
        }
      case 'shgc':
        if(Math.abs(this.higher - this.form.get('shgc').value) < 0.1 ){
          document.getElementById('shgcInput').style.color = "#44AC2A";
          return 'fillGreen';
        }else{
          document.getElementById('shgcInput').style.color = "red";
          return 'fillRed';
        }
        case 'ventrate':
          // +- 15CFM or +- 15%
        if(  (Math.abs(this.form.get('mechanicalvent').value - this.ratervent) <= 15) || (Math.abs(this.form.get('mechanicalvent').value - this.ratervent) <= (this.form.get('mechanicalvent').value*0.15) )  ){
          return 'cfa-img filterGreen';
        }else {
          return 'cfa-img filterRed';
        }
      default:
      return 'fillGreen';

    }

  }



  getColorText(icon): string {

    switch(icon){
      case 'cfa':
        if(this.form.get('cfa').value >= (this.ratercfa - 100) && this.form.get('cfa').value <= (parseInt(this.ratercfa) + 300) ){
          document.getElementById('cfaInput').style.color = "#44AC2A";
          return 'cfa-txt';
        }else{
          document.getElementById('cfaInput').style.color = "red";
          return 'cfa-txt-err';
        }
      case 'wa':
        if(this.raterwa < 500){
          if(this.form.get('wa').value >= (this.raterwa - 15) && this.form.get('wa').value <= (parseInt(this.raterwa) + 60) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'cfa-txt-err';
          }
        }else{
          if(this.form.get('wa').value >= (parseInt(this.raterwa) - (parseInt(this.raterwa) * 0.03)) && this.form.get('wa').value <= (parseInt(this.raterwa) + (parseInt(this.raterwa) * 0.12 ) ) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'cfa-txt-err';
          }
        }
      case 'shgc':
          if(Math.abs(this.higher - this.form.get('shgc').value) < 0.1 ){
            document.getElementById('shgcInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('shgcInput').style.color = "red";
            return 'cfa-txt-err';
          }
      case 'noocupants':
        if(Math.abs(this.form.get('noocupants').value - this.raternooc) <= 2  ){
          document.getElementById('shgcInput').style.color = "#44AC2A";
          return 'cfa-txt';
        }else{
          document.getElementById('shgcInput').style.color = "red";
          return 'cfa-txt-err';
        }
      case 'ventrate':
          // +- 15CFM or +- 15%
        if(  (Math.abs(this.form.get('mechanicalvent').value - this.ratervent) <= 15) || (Math.abs(this.form.get('mechanicalvent').value - this.ratervent) <= (this.form.get('mechanicalvent').value*0.15) )  ){
          document.getElementById('ventInput').style.color = "#44AC2A";
          return 'cfa-txt'
        }else {
          document.getElementById('ventInput').style.color = "red";
          return 'cfa-txt-err';
        }
      default:
      return 'cfa-txt';

    }

  }


  navigateTo(page):void {

    var i, pages;

    //set all pages to display none
    pages = document.getElementsByClassName("page");
    for (i = 0; i < pages.length; i++) {
      pages[i].style.display = "none";
    }

    document.getElementById(page).style.display = "block";
    document.getElementById('system_1').setAttribute('class','hvac-tab-link active');

    //evt.currentTarget.className += " active";

  }



}







@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-edit-job',
  templateUrl: './edit-job-dialog.html',
  styleUrls: ['./location.component.css']
})

export class EditJobDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('technitian', { static: false }) technitian: ElementRef<HTMLInputElement>;
  @ViewChild('autoTrigger', { static: false }) autoTrigger: MatAutocompleteTrigger;

  readonly EDITING_MODE = EDITING_MODE;
  readonly ADDING_MODE = ADDING_MODE;
  readonly formatDateOnly = formatDateOnly;

  payhold: boolean = false;
  tags: any[] = [];
  inputTags: any[] = [];
  newTags: any[] = [];
  fatags = faTags;

  // MF / SF / GPS tag-type filter. Empty = show all.
  tagTypeFilter: string[] = [];
  get visibleTags(): any[] { return this.tagService.filterByTypes(this.tags, this.tagTypeFilter); }
  toggleTagType(t: string): void {
    this.tagService.toggleType(this.tagTypeFilter, t);
    // filteredTags is driven off tagControl.valueChanges, so nudge it to re-run
    // the autocomplete filter against the newly-visible set.
    const c = this.form.get('tagControl');
    if (c && c.value) { c.setValue(c.value); }
  }
  inheritedTagsSubdivision: boolean = false;
  inheritedCustomerJobsTags: boolean = false;
  @ViewChild('modalContent') modalContent: ElementRef;
  bamboo_id: any;
  timeOffShow: boolean;
  timeOffMessage: string;
  capacityHours: any;
  totalHoursScheduled: any;
  capacityCategory: any = null;
  // Informational day-load shown beside Schedule Date. Kept separate from
  // capacityHours/capacityCategory above, which drive the over-capacity save
  // gate -- populating those on dialog open would change which jobs trip it.
  hoursLoading = false;
  hoursInfo: any = null;
  private hoursRequestSeq = 0;
  initialStatus: string = '';
  statusDirty: boolean = false;
  scheduleDateDirty: boolean = false;
  // Meritage CHA/CSTL compliance: locmain.startdate + builder id, prefetched on
  // dialog open so a PendInfo -> Scheduled change before the start date schedules
  // onto the start date (which drives the modeler_duedate + turnaround recompute).
  complianceStartDate: any = null;
  complianceCustomerId: any = null;
  readonly MERITAGE_COMPLIANCE_CUSTOMERS: number[] = [254, 1272]; // CHA, CSTL
  track_id: number = 0;
  selectedJobObj: any;
  manager: any;
  contactSelected : boolean = false;
  activeTabIndex: number = 0;
  employeetype: string = '';
  updateTech: number = 2;

    jobCerts = [];
    empCreds = [];

  employeeNgModel$: Observable<any[]>; // ngModel-based autocomplete
  employeeInputSubject = new Subject<any>();
  subdivisionJobsFound: boolean = false;
  prodCustText: string = '';

  individualAudits: Array<{ employee_name: string; score: number; employee_id: number }> = [];
  previousIndivAudits: Array<{ employee_name: string; score: number; employee_id: number }> = [];
  newAudit: { employee: any; score: number; employee_id: number } = { employee: null, score: null, employee_id: null };

  auditID: number = 0;
  fromPage: string = 'Locations';
  certStatus: {  text: string, color: string } = { text: '', color: '' };
  modalActive: boolean = false;
  subdivision_obj:any;
  // Subdivision consultant name, shown read-only under the Manager field.
  consultantName: string = '';
  sitevisitreqd: boolean = false;
  isSunday: boolean = false;
  tripMode: boolean = false; // set it to always true for testing;
  availableJobs: any[] = [];
  isEditTrip: boolean = false;
  selectedJobs: any[] = [];
  selectedJobIds: number[] = []; // This is what you'll pass to your form control
  carryOverJobs: any[] = [];
  carryOverJobIds: number[] = []; // Track IDs from carryover separately
  previousTripId: number = null;
  // Edit mode: Trip? ticked on a standalone job (new parent on save, this job pinned as primary).
  convertToTrip: boolean = false;
  initialTripTaskIds: number[] = [];
  initialTaskNotes: Map<number, string> = new Map();
  readonly TRIP_OPEN_STATUSES = ['Scheduled', 'Projected'];
  isManualJobtype: boolean = false;

  // 'Mandatory Job' (tag 57) lock. Only scheduling may move such a job to
  // another date, or add/remove the tag itself.
  readonly MANDATORY_JOB_TAG_ID = MANDATORY_JOB_TAG_ID;   // template access
  readonly MANDATORY_LOCK_MSG =
    'This job is tagged "Mandatory Job" and can only be moved by scheduling. Please contact scheduling to reschedule it.';
  isScheduler: boolean = false;
  // Silences the over-capacity modal and snackbars for specific logins. Capacity
  // accounting is untouched: the job still counts and the date is still flagged.
  capacityExempt: boolean = false;
  // Whether the job ALREADY carried tag 57 when the dialog opened. Snapshotted so
  // a non-scheduler cannot dodge the lock by stripping the tag in the same edit.
  wasMandatoryOnOpen: boolean = false;

  // Trip? is live for a new job, or an open standalone job edited from the Locations/truck pages.
  get canToggleTrip(): boolean {
    if (this.mode != EDITING_MODE) { return true; }
    if (this.isEditTrip || this.data.fetchedJob?.trip_id || this.fromPage.toLowerCase().includes('schedule')) { return false; }
    return this.TRIP_OPEN_STATUSES.includes((this.form.get('job_status')?.value || '').toString().trim());
  }

  get tripToggleTooltip(): string {
    if (this.canToggleTrip) { return ''; }
    if (this.isEditTrip) { return 'This job is already a trip'; }
    if (this.data.fetchedJob?.trip_id) { return 'This job is already a task on trip ' + this.data.fetchedJob.trip_id; }
    if (this.fromPage.toLowerCase().includes('schedule')) { return 'Turn a job into a trip from the Locations page'; }
    return 'Only a Scheduled or Projected job can be turned into a trip';
  }

  // Drives the disabled datepicker. A brand new job (ADDING_MODE) is never locked.
  get moveLocked(): boolean {
    return this.mode == EDITING_MODE && this.wasMandatoryOnOpen && !this.isScheduler;
  }

  // Shows the read-only Modeler Due Date under Due Date. Gated on jobtype rather
  // than on the value, because some field jobs carry a stray modeler_duedate.
  // Load-calc jobtypes (Manual*, Block*, Lot Specific JSD) are included because
  // the backend Priority-tag rule (job_rules.applyPriorityDueDates) writes a
  // modeler date onto them; the matcher mirrors job_rules.isLoadCalcJobtype.
  get showModelerDueDate(): boolean {
    const cjt = this.form.get('customer_jobtype').value;
    return !this.isAudit &&
      (this.usesComplianceStati(cjt) || this.isManualJobtype || this.isLoadCalcJobtype(cjt));
  }

  // Mirror of backend job_rules.isLoadCalcJobtype: all Manual and Block jobtypes
  // plus Lot Specific JSD; "Maintenance Manual_MF" is MF maintenance, not a load calc.
  isLoadCalcJobtype(customerJobtype: string): boolean {
    const cjt = (customerJobtype || '').toLowerCase().trim();
    if (!cjt || cjt.includes('maintenance manual')) { return false; }
    return cjt.includes('manual') || cjt.includes('block') || cjt === 'lot specific jsd';
  }



  constructor(public dialog: MatDialog, public auth: AuthService, public dialogRef: MatDialogRef<EditJobDialogComponent>, public schedService: ScheduleService, @Inject(MAT_DIALOG_DATA) public data: any, private fb:FormBuilder, public employeeService: EmployeeService, public planService: PlanService, public jtservice: JobTypeService, public service: LocationService, public messager: MessagerComponent, public contactService: ContactsService, public customerservice: CustomerService, public log: LoggingService, public snackbar: MatSnackBar, public ges: GlobalEmailService, public tagService: TagService, public subdivisionService: SubdivisionService, public customerJobService: CustomerJobService) {}



  form = new FormGroup({
    job_id : new FormControl(this.data.fetchedJob.job_id || 0),
    customer_job : new FormControl(this.data.fetchedJob.customer_job || 0),
    customer_jobtype : new FormControl(this.data.fetchedJob.customer_jobtype || ''),
    technitian: new FormControl(this.data.fetchedJob.technitian || 0),
    contact_name: new FormControl(this.data.fetchedJob.contact_name || 0),
    contact_e_mail: new FormControl(this.data.fetchedJob.contact_e_mail || ''),
    contact_phone: new FormControl(this.data.fetchedJob.contact_phone || ''),
    flex_start_date: new FormControl({value: this.data.fetchedJob.flex_start_date || null, disabled: true}),
    modeler_duedate: new FormControl({value: this.data.fetchedJob.modeler_duedate || null, disabled: true}),
    schedule_date: new FormControl(this.data.fetchedJob.schedule_date  || null),
    job_status: new FormControl(this.data.fetchedJob.job_status? this.data.fetchedJob.job_status.trim() : 'Scheduled'),
    po_number: new FormControl(this.data.fetchedJob.po_number || ''),
    invoice_number: new FormControl(this.data.fetchedJob.invoice_number || ''),
    job_notes: new FormControl(this.data.fetchedJob.job_notes || ''),
    billing_note: new FormControl(this.data.fetchedJob.billing_note || ''),
    location_id: new FormControl(this.data.fetchedJob.location_id || this.data.location.location_id ),
    invoice_amount: new FormControl(this.data.fetchedJob.invoice_amount || ''),
    mftemplate: new FormControl(this.data.fetchedJob.mftemplate || null),
    firststop: new FormControl(this.data.fetchedJob.firststop || false),
    estimatedtime : new FormControl(this.data.fetchedJob.estimatedtime || null),
    tagControl: new FormControl(),
    auditorname : new FormControl(''),
    audtype : new FormControl(''),
    audnotes : new FormControl(''),
    ovlscore : new FormControl(0),
    audinspdate : new FormControl(null),
    audreported : new FormControl(false),
    isaudit: new FormControl(false),
    constage : new FormControl(''),
    region: new FormControl(''),
    nrgprogram: new FormControl(''),
    estimateno: new FormControl(this.data.fetchedJob.estimateno || ''),
    newCaption: new FormControl(''),
    indivEmployee : new FormControl(''),
    indivScore : new FormControl(''),
    gasrebate : new FormControl(this.data.gasrebatedetails?.gasrebate || null),
    gas_rebate1 : new FormControl(this.data.gasrebatedetails?.gas_rebate1 || false),
    gas_rebate2 : new FormControl(this.data.gasrebatedetails?.gas_rebate2 || false),
    gas_rebate_2_status : new FormControl(this.data.gasrebatedetails?.gas_rebate_2_status || null),
    elecrebate : new FormControl(this.data.gasrebatedetails?.elecrebate || null),
    electric_rebate1 : new FormControl(this.data.electricrebatedetails?.electric_rebate1 || false),
    electric_rebate2 : new FormControl(this.data.electricrebatedetails?.electric_rebate2 || false),
    electric_rebate_2_status : new FormControl(this.data.electricrebatedetails?.electric_rebate_2_status || null),
    email_sent : new FormControl(this.data.fetchedJob.email_sent || false),
    istrip: new FormControl(this.data.fetchedJob.istrip || false),

  });



  @ViewChild('refname', {read: false, static: false})
  refNameInputRef: ElementRef;
  mode = this.data.mode;
  isAudit = this.data.isAudit;
  isLoading = false;
  json = JSON.stringify(this.data);
  customerjob$: Observable<any[]>;
  employee$: Observable<any[]>;
  indivemployee$: Observable<any[]>;
  location$: Observable<any>;
  contact$: Observable<any[]>;
  subdivision_id = this.data.location.subdivision;
  employee_name;
  initials;
  customer_name;
  oldForm;
  schedDateChanged = false;
  // Set from onSelectEmployee() (only fires on an actual autocomplete pick, unlike the
  // control's own .dirty state which onSelectEmployee's own setValue() wouldn't mark true) —
  // used to decide whether to cascade the technician onto this trip's child jobs on save.
  technitianChanged = false;
  // Same idea for the manager: set on an autocomplete pick or a clear. Typed edits to the
  // phone/email inputs are caught via the controls' .dirty state in tripFollowFields().
  contactChanged = false;
  // Blackout date override state: tracks whether we've prompted the scheduler
  // about saving on a blackout date, and whether they chose to schedule anyway.
  blackoutChecked = false;
  overrideBlackout = false;
  // Re-entrancy guard for the sampling-application warning, same pattern as blackoutChecked.
  samplingChecked = false;
  // Trip-task edit: has the scheduler been asked about the rest of the trip, and their answer
  // ('trip' = apply to whole trip, 'detach' = leave the trip, null = nothing). Applied after save.
  tripMoveChecked = false;
  tripMoveChoice: 'trip' | 'detach' | null = null;
  // Which of schedule_date / technitian / contact the trip should take from the task.
  tripMoveFields: string[] = [];
  // Re-entrancy guard for the square-footage reminder, same pattern as samplingChecked.
  sqftReminderChecked = false;
  scope;
  filterOverride : boolean = false;
  showShowAllJobs : boolean = true;
  template$;
  dropdownStatus = this.data.dd;
  customerJobs = this.data.cj;
  generator;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTags: Observable<any[]>;
  passedFinal: boolean = false;
  /*
   * Card tQPtadd5 - true when this location has a Pass/Complete pre-drywall job.
   * Fetched in ADDING_MODE only. Defaults to TRUE so a slow or failed lookup can
   * never produce a false "not eligible for rebate" scare; the popup is advisory.
   */
  completedPdw: boolean = true;

  //newCaption: string = '';
  newPhoto: File | null = null;
  photoTable: { photo: string, caption: string }[] = [];
  dataSource = new MatTableDataSource(this.photoTable);
  previewUrl: string | null = null;
  displayedColumns: string[] = ['photo', 'caption', 'actions'];


  @ViewChild('managerphoneRipple', { read: MatRipple}) managerphoneRipple: MatRipple;
  @ViewChild('manageremailRipple', { read: MatRipple}) manageremailRipple: MatRipple;
  @ViewChild('scheduledateRipple', { read: MatRipple}) scheduledateRipple: MatRipple;
  @ViewChild('flexstartdateRipple', { read: MatRipple}) flexstartdateRipple: MatRipple;
  @ViewChild('estimatedtimeRipple', { read: MatRipple}) estimatedtimeRipple: MatRipple;

  defaultStati = [
    {value: 'Scheduled', viewValue: 'Scheduled'},
    {value: 'Canceled', viewValue: 'Canceled'},
    {value: 'EPO hold', viewValue: 'EPO hold'},
    {value: 'On hold', viewValue: 'On hold'},
    {value: 'Pass', viewValue: 'Pass'},
    {value: 'Fail', viewValue: 'Fail'},
    {value: 'Fail-NR', viewValue: 'Fail-NR'},
    {value: 'Fail-EPO', viewValue: 'Fail-EPO'},
    {value: 'Fail-RIS', viewValue: 'Fail-RIS'},
    {value: 'Complete', viewValue: 'Complete'},
    {value: 'UnderRev', viewValue: 'Under Review'},
    {value: 'Projected', viewValue: 'Projected'},
  ];
  stati = [...this.defaultStati];

  tripStati = [
    {value: 'Projected', viewValue: 'Projected'},
    {value: 'Scheduled', viewValue: 'Scheduled'},
    {value: 'On hold', viewValue: 'On hold'},
    {value: 'Complete', viewValue: 'Complete'},
  ];

  get availableStati() {
    return this.form?.get('istrip')?.value ? this.tripStati : this.stati;
  }

  reportStati =[
    {value: 'Scheduled', viewValue: 'Scheduled'},
    {value: 'Canceled', viewValue: 'Canceled'},
    {value: 'PendInfo', viewValue: 'Pending Info'},
    {value: 'PendPaym', viewValue: 'Pending Payment'},
    {value: 'EngStamp', viewValue: 'Engineer Stamp'},
    {value: 'Rea4Review', viewValue: 'Ready for Review'},
    {value: 'Complete', viewValue: 'Complete'}
    ];

  // Job types whose status dropdown is the compliance/report list (reportStati)
  // instead of the field Pass/Fail list. Matched with includes() against the
  // job's customer_jobtype, so Re_ variants are covered too.
  //
  // NOTE: this is deliberately NOT the same set as the schedule-date-jumps-to-today
  // gate in setStatusDirty() (which is narrower and also carries 'manual'), nor the
  // schedule page's own gate in schedule.component.html (which omits 'tradeoff
  // modeling' - a known pre-existing bug carried on its own card). Do not unify them.
  //
  // 'prelim_mf' / 'prelim updates_mf' are deliberately narrow: a bare 'prelim'
  // would swallow Prelim/Prelim_cust/Prelim HERO-* (4,877 live job rows) and, worse,
  // the site-visit job Preliminary Testing_MF, stripping Pass/Fail from a field job.
  COMPLIANCE_STATUS_KEYWORDS = [
    'report', 'n/s', 'rescheck', 'tradeoff modeling', 'modeling_mf',
    'model updates', 'prelim_mf', 'prelim updates_mf', 'sampling application'
  ];

  // Job types that must never have flex_start_date / modeler_duedate written or
  // cleared by this dialog. 'manual' (HVAC Design - Existing Customers) fixes its
  // modeler date at creation; the MF model-update/prelim jobtypes get compliance
  // statuses but are explicitly not treated as compliance work for due dates.
  DUE_DATE_EXEMPT_KEYWORDS = ['manual', 'model updates', 'prelim_mf', 'prelim updates_mf', 'sampling application'];


  axisStati =[
    {value: 'PendRouQA', viewValue: 'Pending Rough QA'},
    {value: 'PendFinlQA', viewValue: 'Pending Final QA'},
    {value: 'Certified', viewValue: 'Certified'},
    {value: 'Abandoned', viewValue: 'Abandoned'}
    ];

  manualStati = [
    {value: 'NotStarted', viewValue: 'Not Started'},
    {value: 'InQueue', viewValue: 'In Queue'},
    {value: 'Pending', viewValue: 'Pending'},
    {value: 'Complete', viewValue: 'Complete'},
    {value: 'InProcess', viewValue: 'In Process'},
    {value: 'On hold', viewValue: 'On hold'},
    {value: 'Scheduled', viewValue: 'Scheduled'}
    ];

  regions: Region[] = [
    {value: 'ASH', viewValue: 'ASH'},
    {value: 'ATL', viewValue: 'ATL'},
    {value: 'AUG', viewValue: 'AUG'},
    {value: 'CBS', viewValue: 'CBS'},
    {value: 'CHS', viewValue: 'CHS'},
    {value: 'CIN', viewValue: 'CIN'},
    {value: 'CLT', viewValue: 'CLT'},
    {value: 'COL', viewValue: 'COL'},
    {value: 'CSTL', viewValue: 'CSTL'},
    {value: 'GRV', viewValue: 'GRV'},
    {value: 'KNX', viewValue: 'KNX'},
    {value: 'MEM', viewValue: 'MEM'},
    {value: 'MF', viewValue: 'MF'},
    {value: "NOOG", viewValue: "NOOG" },
    {value: 'NSH', viewValue: 'NSH'},
    {value: 'RDU', viewValue: 'RDU'},
    {value: 'RIC', viewValue: 'RIC'},
    {value: 'TRI', viewValue: 'TRI'}
  ];

  bankHolidays = [
			'2026-01-01', // New Year's Day
			'2026-05-25', // Memorial Day
			'2026-07-03', // Independence Day (observed)
			'2026-09-07', // Labor Day
			'2026-11-26', // Thanksgiving
			'2026-11-27', // Day after Thanksgiving
			'2026-12-24', // Christmas Eve
			'2026-12-25'  // Christmas Day
  ];

  timeOffEmployees : any[] = [];
  ngAfterViewInit(){

    //set job notes to generator notes
    this.scrollToTop();

    this.service.getScope(this.data.location.subdivision).subscribe(
      res => {
        if(res.Error){
          this.scope = 'No Scope';
          this.filterOverride = true;
        }else {
          this.scope = res.Scope.scope;
          this.filterOverride = res.Scope.overridesc;
          if(res.Scope.overridesc == true){
            this.showShowAllJobs = false;
          }
        }
      }, err => {
        this.scope = 'Error pulling scope-' + err;

      }
    )
  }

  ngOnInit() {




    //pre-fill dropdowns here
    this.scrollToTop();
    this.availableJobs = this.data.availableJobs || [];
    this.isEditTrip = this.data.fetchedJob?.istrip || false;
    console.log(this.data);
    console.log(this.data.availableJobs);

    // If editing an existing trip, load its child jobs
    if (this.isEditTrip && this.data.fetchedJob?.job_id) {
      this.tripMode = true;
      this.form.get('customer_job').disable();
      this.service.getTripJobs(this.data.fetchedJob.job_id).subscribe(
        res => {
          if (res.Jobs) {
            this.selectedJobs = res.Jobs.map(job => ({
              job_id: job.job_id,
              customer_job: job.customer_job || this.data.fetchedJob.customer_job,
              customer_jobtype: job.customer_jobtype,
              customer_name: job.customer_name,
              job_status: job.job_status,
              schedule_date: job.schedule_date,
              estimatedtime: parseFloat(job.estimatedtime) || 0,
              job_notes: (job.job_notes || '').trim()
            }));
            this.initialTaskNotes = new Map(this.selectedJobs.map(j => [j.job_id, j.job_notes]));

            // getTripJobs orders by job_id, so index 0 (rendered as "Primary") isn't necessarily
            // the trip's persisted primary. Re-sort so the child matching the parent's customer_job is first.
            // customer_job comes back as a numeric-typed string from some queries (e.g.
            // getTripJobs) and a number from others (e.g. the job fetch that populated
            // fetchedJob) — compare numerically so a string/number mismatch can't silently
            // fail to find the primary.
            const parentCustomerJob = Number(this.data.fetchedJob.customer_job);
            const primaryIndex = this.selectedJobs.findIndex(j => Number(j.customer_job) === parentCustomerJob);
            if (primaryIndex > 0) {
              const [primaryJob] = this.selectedJobs.splice(primaryIndex, 1);
              this.selectedJobs.unshift(primaryJob);
            }

            this.selectedJobIds = this.selectedJobs.map(job => job.job_id);
            this.initialTripTaskIds = [...this.selectedJobIds];
            // Remove these jobs from availableJobs to avoid duplicates
            this.availableJobs = this.availableJobs.filter(
              aj => !this.selectedJobIds.includes(aj.job_id)
            );
            this.recomputeTripEstimatedTime();
          }
        },
        err => {
          this.messager.openSnackBar('Error loading trip jobs', '', 'errorAlert');
        }
      );
    }

    this.auth.employeetype$.subscribe(type => {
      this.employeetype = type;
      if(this.employeetype.includes('GPS') && !this.data.usernamee.includes('luisa')){
        this.bankHolidays = [];
      }

      //if(this.auth.getEmployeeName().includes('greenproserv') && !this.auth.getEmployeeName().includes('adrian')){
        //this.reportStati= this.reportStati.filter(item => !item.value.includes('Complete'));
      //}

    });

    this.auth.userProfile$.subscribe(profile => {
      // Fall back to the capitalized nickname the caller passed in (both the
      // Locations and Schedule entry points set it) if the profile hasn't
      // emitted yet -- isSchedulingUser lowercases before matching.
      this.isScheduler = isSchedulingUser(profile || this.data.usernamee);
      this.capacityExempt = isCapacityExemptUser(profile || this.data.usernamee);
    });

    this.auth.userProfile$.subscribe(profile => {
      // Fall back to the capitalized nickname the caller passed in (both the
      // Locations and Schedule entry points set it) if the profile hasn't
      // emitted yet -- isSchedulingUser lowercases before matching.
      this.isScheduler = isSchedulingUser(profile || this.data.usernamee);
      this.capacityExempt = isCapacityExemptUser(profile || this.data.usernamee);
    });

    // fetchedJob is the full `SELECT * from jobs` row on both entry points, so it
    // is the reliable source; data.job is a grid row on the Locations page.
    const _openTags = this.data.fetchedJob?.tags || this.data.job?.tags || [];
    this.wasMandatoryOnOpen = _openTags.map(Number).includes(MANDATORY_JOB_TAG_ID);


    this.subdivisionService.getOneSubdivision(this.data.location.subdivision).subscribe(
      res => {
        this.subdivision_obj = res.Subdivision;
        // Show the subdivision's consultant (read-only) below the Manager field.
        const _consultant = res.Subdivision && res.Subdivision.consultant ? Number(res.Subdivision.consultant) : 0;
        if(_consultant > 0){
          this.employeeService.getOneEmployee(_consultant).subscribe(
            emp => { this.consultantName = emp && emp.employee_name ? emp.employee_name.trim() : ''; },
            err => {}
          );
        }
      }
    )



    this.initialStatus = this.data.fetchedJob?.job_status?.trim() || '';
    this.fromPage = this.data.fromPage || 'Locations';
    //see if this job has a contact on the subdivision
    if(this.data.job.contact_name == 0 || this.data.job.contact_name == null){
      this.service.getSubdivisionContact(this.data.location.location_id).subscribe(
        res => {
          if(res.Contact){
            this.form.get('contact_name').setValue(res.Contact.id);
            this.form.get('contact_e_mail').setValue(res.Contact.email);
            this.form.get('contact_phone').setValue(res.Contact.phone);
            this.data.job.name = res.Contact.name;
          }
        }, err => {
           //do nothing.
        }
      )
    }

    //see if this location is apart of a single family track
    this.service.getTrack(this.data.location.location_id).subscribe(
      res => {
        this.track_id = res.Tracks.track;
      }, err => {
        this.track_id = 0;
      });

    if(this.data.mode == ADDING_MODE){
      //check to see if this location has a final passed:
      this.service.getFinalPassed(this.data.location.location_id).subscribe(
        res => {
          this.passedFinal = res.FinalCount[0].count > 0 ? true : false;
        });

      //check to see if this location has a completed pre-drywall (card tQPtadd5)
      this.service.getPdwCompleted(this.data.location.location_id).subscribe(
        res => {
          if(!res.Error){
            this.completedPdw = !!res.PdwCompleted;
          }
        }, err => {
          this.completedPdw = true;   //fail open - never warn off a failed lookup
        });
    }

    if(this.data.mode == EDITING_MODE){
      if(this.data.fetchedJob){
        if(this.usesComplianceStati(this.data.fetchedJob.customer_jobtype)){
          this.stati = this.reportStati;

          // Prefetch start info (by job_id, so it works from both the location and
          // schedule pages) so setStatusDirty() can schedule a Meritage CHA/CSTL
          // PendInfo->Scheduled change onto the start date, and so the due-date
          // recompute on save gets the real customer_id.
          this.service.getComplianceStartInfo(this.data.fetchedJob.job_id).subscribe(
            res => {
              const info = res && res.StartInfo ? res.StartInfo : null;
              if(info){
                this.complianceCustomerId = info.customer_id != null ? Number(info.customer_id) : null;
                if(info.startdate){
                  const p = info.startdate.split('-'); // 'YYYY-MM-DD'
                  this.complianceStartDate = new Date(+p[0], +p[1] - 1, +p[2]); // local midnight, no tz drift
                }
              }
            }, err => {
              // non-fatal: fall back to the existing today-based behavior
            }
          );
        }

        if(this.data.fetchedJob.customer_jobtype.toLowerCase().includes('axis ngbs submission status_mf')){
          this.stati = this.axisStati;
        }

        // Allow due date editing for 'manual' customer jobtypes
        if(this.data.fetchedJob.customer_jobtype.toLowerCase().includes('manual')){
          this.isManualJobtype = true;
          this.stati = this.reportStati;
          this.form.get('flex_start_date').enable();
        }

        if(this.data.fetchedJob.customer_jobtype.toLowerCase().includes('axis ngbs submission status_mf')){
          this.stati = this.axisStati;
        }

        // Allow due date editing for 'manual' customer jobtypes
        if(this.data.fetchedJob.customer_jobtype.toLowerCase().includes('manual')){
          this.isManualJobtype = true;
          this.stati = this.reportStati;
          this.form.get('flex_start_date').enable();
        }
      }
      this.checkPayHold();
    }

    if(this.isAudit){
      this.toggleOverride();
      if(this.data.mode == EDITING_MODE){
        //load individual audits
        this.service.getIndividualAudits(this.data.job.job_id).subscribe(
          res => {
            this.previousIndivAudits = res.Audits.map(item => {
              return {
                employee_name: item.employee_name,
                score: item.score,
                employee_id: item.employee_id
              };
            });
          }, err => {
            this.messager.openSnackBar('Could not load individual audits.', '', 'errorAlert');
          });

        this.service.getAuditForJobID(this.data.job.job_id).subscribe(
          res => {

              this.auditID = res.Audit.audit_id;
              this.form.get('auditorname').setValue(res.Audit.auditorname),
              this.form.get('audtype').setValue(res.Audit.audtype),
              this.form.get('audnotes').setValue(res.Audit.audnotes),
              this.form.get('ovlscore').setValue(res.Audit.ovlscore),
              this.form.get('audinspdate').setValue(res.Audit.audinspdate),
              this.form.get('audreported').setValue(res.Audit.audreported),
              this.form.get('constage').setValue(res.Audit.constage),
              this.form.get('region').setValue(res.Audit.region),
              this.form.get('nrgprogram').setValue(res.Audit.nrgprogram)

              this.parseAuditPhotoData(res.Audit.additionalpics);

              // Update dataSource with parsed photoTable data
              this.dataSource.data = [...this.photoTable];
          });

      }else {
        this.form.get('region').setValue(this.data.location.region);
      }
    }

    //see who's out
    this.service.getTimeOff().subscribe(
      res => {
        this.timeOffEmployees = res.Data.map(item => {
          return {
            employeeId: item.employeeId,
            startDate: item.start,
            name:  item.name,
            endDate: item.end
        };
        });
      });



    if(this.data.mode == EDITING_MODE){
      this.oldForm = JSON.parse(JSON.stringify(this.form.value));
      this.oldForm.name = typeof this.data.job.name === "undefined" || this.data.job.name === null ? '' : this.data.job.name.toString();

      this.employee_name = this.data.job.employee_name;
      this.initials = this.data.job.initials;
      console.log(this.data);
      this.customer_name = this.data.job.customer_name;

      const customerJobId = this.form.get('customer_job').value;
      if (customerJobId) {
        this.customerJobService.getOne(customerJobId).subscribe(
          res => {
            if (!res.Error && res.CustomerJob && res.CustomerJob.job_type) {
              this.checkIsSiteVisitReqd(res.CustomerJob.job_type);
            }
          },
          err => {
            console.error('Error fetching customer job:', err);
          }
        );
      }

    }

      this.customerjob$ = this.service.getSubdivisionJobs(this.data.location.subdivision).pipe(
        switchMap((res) => {
          if (res.Jobs?.length > 0 && this.data.location.subdivision != 0) {
            return of(res.Jobs); // Return the jobs directly as an observable
          } else {
            return this.form.get('customer_job').valueChanges.pipe(
              debounceTime(400),
              tap(() =>{
                this.isLoading = true;
              }) ,
              switchMap(value =>
                value.length > 0 ? this.service.getCustomerJobsDropdown(value as string, 0, this.filterOverride,this.scope? this.scope : '') : empty()
                .pipe(
                  tap((res) => {
                    this.isLoading = false;
                  }),
                  finalize(() => this.isLoading = false)
                  )
              )
            );
          }
        }),
        catchError((err) => {
          return this.form.get('customer_job').valueChanges.pipe(
            debounceTime(400),
            switchMap((value) =>
              value?.length > 0
                ? this.service.getCustomerJobsDropdown(value as string, 0, this.filterOverride,this.scope? this.scope : '' )
                : EMPTY
            ),
            finalize(() => (this.isLoading = false))
          );
        })
      );



    //load tags
    this.service.getTags().subscribe(
      res => {
        this.tags = res.data;
      });

     if(this.data.mode == ADDING_MODE){

      this.tagService.getSubdivisionTags(parseInt(this.data.location.subdivision)).subscribe(
        res => {

          if(res.Tags.s_tags.length > 0){
            this.inheritedTagsSubdivision = true;
            res.Tags.s_tags.forEach(tag => {
                if(!this.data.job.tags){
                  this.data.job.tags = [];
                }
                if(!this.data.job.tags.includes(tag)){
                  this.data.job.tags.push(tag);
                }
            });
          }
          this.data.job?.tags?.forEach(tag => {
            this.service.getTag(tag).subscribe(
              res => {
                this.inputTags.push(res.data);
              });
          });
        });
     }else {
      // just load tags that are already selected
      this.data.job.tags?.forEach(tag => {
        this.service.getTag(tag).subscribe(
          res => {
            this.inputTags.push(res.data);
          }
        );
      });
     }

      this.filteredTags = this.form.get('tagControl').valueChanges.pipe(
        debounceTime(400),
        tap(value => {
        }),
        filter((tag: string | null) => tag && tag.length > 0),
        map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice())
      );

    this.template$ = this.form.get('mftemplate').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
      }),
      switchMap(value =>
        value.length > 0 ? this.service.getMultifamilyTemplates(value as string) : empty()
      )
    );

    this.service.getMfTemplateName(this.data.job.mftemplate).subscribe(
      res => {
        this.data.mftemplateName = res.Template?.name || null;
      }, err => {
      }
    );


    // New Bern, NC locations default the technician to WIL Unassigned (340) on new jobs
    if(this.data.mode == ADDING_MODE && this.data.location
        && (this.data.location.city || '').trim().toLowerCase() === 'new bern'
        && /^(nc|north carolina)$/i.test((this.data.location.state || '').trim())){
      this.data.job.technitian = 340;
      this.form.get('technitian').setValue(340);
    }

    //get employee name:
    this.employeeService.getOneEmployee(this.data.job.technitian).subscribe(
      res => {
        this.employee_name = res.employee_name;
      }, err => {
      }
    )

    if(this.data.job.schedule_date){
    let sdate = new Date(this.data.job.schedule_date) ;

    const day = sdate.getUTCDate();
    const month = sdate.getUTCMonth() + 1; // Return Value is 0 indexed
    const year = sdate.getUTCFullYear();
    this.form.get('schedule_date').setValue(new Date(month + '/' + day + '/' + year));

  }

    this.loadScheduledHours();

    this.employee$ = this.form.get('technitian').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.service.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.indivemployee$ = this.form.get('technitian').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.service.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.indivemployee$ = this.form.get('indivEmployee').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.service.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

        // For ngModel input (newAudit.employee)
        this.employeeNgModel$ = this.employeeInputSubject.pipe(
          debounceTime(400),
          tap(() => (this.isLoading = true)),
          switchMap((value: string) =>
            value && value.trim().length > 0
              ? this.service.getEmployeesDropdown(value) // API call to fetch employees
              : of([]) // Return an empty array when input is empty
          ),
          finalize(() => (this.isLoading = false))
        );




    this.contact$ = this.form.get('contact_name').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getContactsDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );




  }

  addTag(event: MatChipInputEvent, tag?: any): void {

    const input = event.input;

    // Only scheduling may put a job on the 'Mandatory Job' tag. Applies in add
    // mode too, so a new job cannot be created already tagged.
    if(tag && tag.id === MANDATORY_JOB_TAG_ID && !this.isScheduler){
      this.messager.openSnackBar(
        'Only scheduling can add the "Mandatory Job" tag. Please contact scheduling.',
        'Close', 'errorAlert');
      // The tag palette calls this with a MouseEvent, which has no `input`.
      if(input){ input.value = ''; }
      return;
    }

    // Only add tag if it is not already selected
    if(tag){
      if (this.inputTags) {
        const tagIds = this.inputTags.map(existingTag => existingTag.id);
        if (!tagIds.includes(tag.id)) {
          this.inputTags.push(tag);
          this.newTags.push(tag);
          this.log.info(this.data.usernamee + ' added tag#' + tag.id + ' (named: ' + tag.displayname + ') to the ' + this.data.job.customer_jobtype + '@ '+ this.data.job.street_address + ' with id: ' + this.data.job.job_id );
        }
      }
    }
    input.value = '';

  }


  sendAuditEmail(): void {
    this.messager.openSnackBar('Sending audit email...', '', 'successAlert');
    //save Current Data:
    if(this.mode == EDITING_MODE)
    {
      this.service.sendAuditEmail(this.data.job.location_id, this.data.job.job_id).subscribe(
        res => {
          this.form.get('audreported').setValue(true);
          this.messager.openSnackBar('Audit email sent!', '', 'successAlert');
        }
      );

    }else if(this.mode == ADDING_MODE)
    {
      this.form.get('audreported').setValue(true);
      this.add(true);
    }


  }



  removeTag(tag: any): void {

    if(tag && tag.id === MANDATORY_JOB_TAG_ID && !this.isScheduler){
      this.messager.openSnackBar(
        'Only scheduling can remove the "Mandatory Job" tag. Please contact scheduling.',
        'Close', 'errorAlert');
      return;
    }

    const index = this.inputTags.indexOf(tag);
    const newTagIndex = this.newTags.indexOf(tag);

    if (index >= 0) {
      this.inputTags.splice(index, 1);
      this.log.info(this.data.usernamee + ' removed tag#' + tag.id + ' (named: ' + tag.displayname + ') from the ' + this.data.job.customer_jobtype + '@ '+ this.data.job.street_address + ' with id: ' + this.data.job.job_id );
    }

    if (newTagIndex >= 0) {
      this.newTags.splice(newTagIndex, 1);
    }

  }

  // Customer request: tags 56 & 57 render red on the edit job dialog so they stand out.
  isRedTag(tag: any): boolean {
    return !!tag && (tag.id === 56 || tag.id === 57);
  }

  private scrollToTop() {
    if (this.modalContent) {
      document.getElementById('maindiv').scrollTop = 0;
    }
  }


  checkPayHold(){
    this.service.getPaymentHold(this.data.job?.customer_name?.trim()).subscribe
    (
      res => {
        if(res.Error){
          this.payhold = false;
        }else{
          this.payhold = res.PaymentHold;
          if(this.payhold && this.data.mode == EDITING_MODE){
            this.stati = this.stati.filter(s => s.value !== 'Scheduled');
          }
        }
      }, err => {
      }
    );
  }

  multiFamilySelected(template){
    this.data.mftemplateName = template.name;
    this.data.job.mftemplate = template.id;
    this.form.get('mftemplate').setValue(template.id);
  }

  displayFunctionMF(obj: any){
    if (obj) {return obj.name; }
  }

  setStatusDirty(): void {
    this.statusDirty = true;
    // Status changed, so re-run the sampling-application warning on the next save.
    this.samplingChecked = false;
    //unless job type changes (i.e. editing mode), this won't need to be checked. 
    if(this.selectedJobObj){
      this.checkIsSiteVisitReqd(this.selectedJobObj.job_type);
    }

    //update scheudle date to today's date if the current job type includes rescheck, performance report, unassigned compliance report, N/S report, tradeoff modeling, Modeling_MF (MF Billing Track), manual (HVAC Design - Existing Customers track), or the MF model-update/prelim jobtypes
    //NOTE: this list is intentionally NARROWER than COMPLIANCE_STATUS_KEYWORDS (no bare 'report'/'n/s') - do not swap it for usesComplianceStati()
    const jobTypeLower = this.form.get('customer_jobtype').value.toLowerCase();
    if(jobTypeLower.includes('rescheck') || jobTypeLower.includes('performance report') || jobTypeLower.includes('unassigned compliance') || jobTypeLower.includes('n/s report') || jobTypeLower.includes('tradeoff modeling') || jobTypeLower.includes('modeling_mf') || jobTypeLower.includes('manual') || jobTypeLower.includes('model updates') || jobTypeLower.includes('prelim_mf') || jobTypeLower.includes('prelim updates_mf')){

      // Meritage CHA/CSTL: if this is a PendInfo -> Scheduled change happening
      // BEFORE the location's start date, schedule onto the start date instead of
      // today. On save this drives the modeler_duedate + flex_start_date recompute.
      // Every other case (incl. missing start date, or today >= start date) keeps
      // the existing "schedule to today" behavior.
      const newStatus = (this.form.get('job_status').value || '').toLowerCase();
      const isPendInfoToScheduled = this.initialStatus.toLowerCase().includes('pendinfo') && newStatus.includes('scheduled');
      const isMeritageCompliance = this.MERITAGE_COMPLIANCE_CUSTOMERS.includes(this.complianceCustomerId);

      let useStartDate = false;
      if(isMeritageCompliance && isPendInfoToScheduled && this.complianceStartDate){
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        useStartDate = this.complianceStartDate.getTime() > today.getTime(); // start date is in the future
      }

      if(useStartDate){
        this.form.get('schedule_date').setValue(this.complianceStartDate);
        this.messager.openSnackBar('Schedule date set to the start date (' + moment(this.complianceStartDate).format('MM/DD/YYYY') + ').', '', 'successAlert');
      }else{
        this.form.get('schedule_date').setValue(new Date());
        this.messager.openSnackBar("Schedule date updated to today's date.", '', 'successAlert');
      }
      this.schedDateChanged = true;
      this.longRipple(this.scheduledateRipple);
    }

    // A job created as PendPaym must not carry a due date. setDueDate() stamps
    // flex_start_date/modeler_duedate off the JOBTYPE and never looks at status,
    // so by the time the user picks PendPaym the dates are already sitting in the
    // form. Clear them here so the (disabled) date fields show what will actually
    // be saved. add() strips them again at send, because setDueDate() can re-run
    // after this point (jobtype or schedule date changed later) with no knowledge
    // of the status.
    // EDIT mode is deliberately left alone: save() sends form.value, which omits
    // these disabled controls, so blanking them here would only make the dialog
    // contradict the due dates still stored on the job.
    if(this.mode == ADDING_MODE && (this.form.get('job_status').value || '').toLowerCase().includes('pendpaym')){
      this.form.get('flex_start_date').setValue(null);
      this.form.get('modeler_duedate').setValue(null);
    }

  }

  onNoClick(): void {

    if(this.data.mode == EDITING_MODE) {
      this.data.job.job_id = this.oldForm.job_id;
      this.data.job.customer_job = this.oldForm.customer_job;
      this.data.job.customer_jobtype = this.oldForm.customer_jobtype;
      this.data.job.name = this.oldForm.name;
      this.manager = this.oldForm.name;
      this.data.job.technitian = this.oldForm.technitian;
      this.data.job.contact_name = this.oldForm.contact_name;
      this.data.job.contact_e_mail = this.oldForm.contact_e_mail;
      this.data.job.contact_phone = this.oldForm.contact_phone;
      this.data.job.flex_start_date = this.oldForm.flex_start_date;
      this.data.job.schedule_date = this.oldForm.schedule_date;
      this.data.job.job_status = this.oldForm.job_status;
      this.data.job.po_number = this.oldForm.po_number;
      this.data.job.invoice_number = this.oldForm.invoice_number;
      this.data.job.invoice_amount = this.oldForm.invoice_amount;
      this.data.job.job_notes = this.oldForm.job_notes;
      this.data.job.billing_note = this.oldForm.billing_note;
      this.data.job.location_id = this.oldForm.location_id;
      this.data.job.employee_name = this.employee_name;
      this.data.job.initials = this.initials;
      this.data.job.customer_name = this.customer_name;
    }

    //check for over capacity



    this.dialogRef.close();
  }

  // Capacity only matters for days that can still be scheduled: a job sitting
  // on a past date (e.g. being marked Pass/Fail after the visit) must never
  // trigger the at-capacity indicator, snackbars or the Over Capacity gate.
  // Accepts the moment/Date/string the schedule_date control may hold.
  isPastScheduleDate(date: any): boolean {
    if(!date){ return false; }
    const m = moment(date);
    return m.isValid() && m.startOf('day').isBefore(moment().startOf('day'));
  }

  // Markets where the over-capacity gate is enforced. CIN/LOU also have
  // regioncaps rows but have never been gated here -- leaving them out keeps
  // today's behaviour.
  capacityRegions = ['NOOG', 'ASH', 'CHS', 'RDU', 'TRI'];
  capacityRegion = '';

  capacityEnforced(region): boolean {
    let r = (region || '').toString().trim().toUpperCase();
    return this.capacityRegions.some(x => r.includes(x));
  }

  // Resolves the backend's capacity verdict for this job, or null if it could
  // not be evaluated. The region comes back on the response: it is resolved
  // server-side from the location, not from the assigned technician.
  checkCapacity(date): Promise<any> {

    // Past dates are never at capacity for scheduling purposes: skip the
    // round-trip so no snackbar fires and save() sees no gate. Read the raw
    // control rather than `date`, which save() passes pre-formatted as MM-DD-YY.
    const rawSchedDate = this.form.get('schedule_date') ? this.form.get('schedule_date').value : null;
    if(this.isPastScheduleDate(rawSchedDate)){
      return Promise.resolve(null);
    }

    let formattedDate = moment(date).format('MM-DD-YY');
    // The candidate job's context so the backend can scope the check to a
    // job-type category (e.g. RDU's Energy cap) -- the "would this push us
    // over" math is done server-side because only it knows the category.
    let locationId = this.form.get('location_id') ? this.form.get('location_id').value : null;
    let customerJob = this.form.get('customer_job') ? this.form.get('customer_job').value : null;
    let estimatedtime = parseFloat(this.form.get('estimatedtime').value) || 0;

    return new Promise((resolve, reject) => {
      this.service.checkCapacity(formattedDate, locationId, customerJob, estimatedtime).subscribe(
        res => {
          if (res.Error) {
            this.messager.openSnackBar('Error checking capacity', '', 'errorAlert');
            resolve(null);
          } else {
            this.capacityHours = res.Capacity;
            this.totalHoursScheduled = res.TotalTime;
            this.capacityCategory = res.Category || null;
            this.capacityRegion = res.Region || '';
            // A PDWI counts toward the total but is never warned about, so it
            // gets no snackbar either. Exempt logins get no snackbar at all.
            let warn = this.capacityEnforced(res.Region) && !res.Pdwi && !this.capacityExempt;
            if (warn && res.Overcapacity) {
              let msg = this.capacityCategory
                ? this.capacityRegion + ' is over capacity for ' + this.capacityCategory + ' work on this date.'
                : 'This region is over capacity on this date.';
              this.messager.openSnackBar(msg, '', 'errorAlert');
            } else if (warn && res.WouldBeOver) {
              let difference = (parseFloat(res.TotalTime) + estimatedtime) - parseFloat(res.Capacity);
              let msg = this.capacityCategory
                ? 'This would place ' + this.capacityRegion + ' over capacity for ' + this.capacityCategory + ' work on this date.'
                : 'This would place this region over capacity on this date by ' + difference + ' hours.';
              this.messager.openSnackBar(msg, '', 'errorAlert');
            }
            resolve(res);
          }
        },
        err => {
          this.log.error('Error checking capacity: ' + err);
          reject(err);
        }
      );
    });
  }


  setCapacity(date){

    let newDate = moment(date).format('MM-DD-YY');
    let locationId = this.form.get('location_id') ? this.form.get('location_id').value : null;
    let customerJob = this.form.get('customer_job') ? this.form.get('customer_job').value : null;
    let estimatedtime = parseFloat(this.form.get('estimatedtime').value) || 0;

    this.service.setCapacity(newDate, locationId, customerJob, estimatedtime).subscribe(
      res => {
      }, err => {
      })
  }


  // Day-load hint beside Schedule Date. Purely informational: any failure just
  // hides the indicator, it must never interfere with saving a job.
  loadScheduledHours(): void {
    const raw = this.form.get('schedule_date') ? this.form.get('schedule_date').value : null;
    if(!raw){
      this.hoursInfo = null;
      this.hoursLoading = false;
      return;
    }

    // convert_schedule_date_to_string_date() only handles the moment object the
    // datepicker emits; on dialog open the control holds a plain Date, so go
    // through moment() the way checkCapacity() does.
    const date = moment(raw).format('YYYY-MM-DD');
    if(!date || date === 'Invalid date'){
      this.hoursInfo = null;
      this.hoursLoading = false;
      return;
    }

    const locationId = this.form.get('location_id') ? this.form.get('location_id').value : null;
    // Read the id off data.job rather than the form: the customer-job control
    // holds free text while its autocomplete is being typed into, and data.job
    // only ever carries a resolved id.
    const customerJob = Number((this.data.job ? this.data.job.customer_job : 0)
      || (this.form.get('customer_job') ? this.form.get('customer_job').value : 0)) || 0;

    const seq = ++this.hoursRequestSeq;
    this.hoursLoading = true;
    this.service.getScheduledHours(date, locationId, customerJob).subscribe(
      res => {
        if(seq !== this.hoursRequestSeq){ return; }   // a newer request already won
        this.hoursLoading = false;
        this.hoursInfo = (res && !res.Error) ? res.Data : null;
        // A past day shows its hours for reference only: no "/ cap" and no red.
        if(this.hoursInfo && this.isPastScheduleDate(raw)){
          this.hoursInfo = { ...this.hoursInfo, capacity: null };
        }
      },
      err => {
        if(seq !== this.hoursRequestSeq){ return; }
        this.hoursLoading = false;
        this.hoursInfo = null;
      });
  }

  get hoursOverCapacity(): boolean {
    return !!(this.hoursInfo && this.hoursInfo.capacity != null
      && Number(this.hoursInfo.hours) >= Number(this.hoursInfo.capacity));
  }

  get hoursTooltip(): string {
    if(!this.hoursInfo){ return ''; }
    const b = this.hoursInfo.breakdown || {};
    return 'Region ' + this.hoursInfo.region + ' (from the location) on ' + this.hoursInfo.date
      + ' — Energy: ' + (b.Energy || 0) + 'hr, QI: ' + (b.QI || 0) + 'hr, Other: ' + (b.Other || 0) + 'hr'
      + ', Total: ' + this.hoursInfo.totalHours + 'hr'
      + ' (' + this.hoursInfo.jobCount + ' jobs; Scheduled only)';
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.activeTabIndex = event.index;
  }

  addIndividualAudit(): void {
    if (!this.newAudit.employee || !this.newAudit.score) {
      alert('Please fill in both Employee and Score.');
      return;
    }

    const audit = {
      employee_name: this.newAudit.employee,
      score: this.newAudit.score,
      employee_id: this.newAudit.employee_id
    };
    this.individualAudits.push(audit);

    // Reset the form for the next entry
    this.newAudit = { employee: null, score: null, employee_id: null };
    this.form.get('indivEmployee').setValue('');
    this.form.get('indivScore').setValue('');
  }

  saveAllAudits(job_id, audit_id): void {
    this.individualAudits.forEach((audit) => {
      // Call the save function for each individual audit
      this.saveAudit(audit, job_id, audit_id);
    });
  }

  saveAudit(obj: any, job_id: number, audit_id: number): void {
    // Replace with actual service call to save the audit
    obj.audit_id = audit_id;

    this.service.saveIndividualAudit(obj, job_id).subscribe(
      res =>{
      }, err => {
      }
    )
  }

  removeAudit(index: number, isPrevious: boolean = false, obj: any = {}): void {
    if (isPrevious) {
      // Call API function to remove
      const removedAudit = this.previousIndivAudits.splice(index, 1);
      this.service.removeIndividualAudit(removedAudit[0].employee_id, this.data.job.job_id).subscribe(
        res => {
//          //console.log('Removed previous audit:', removedAudit);
        }, err => {
  //        console.error('Error removing previous audit:', err);
        }
      )
      //console.log('Removed previous audit:', removedAudit);
    } else {
      // Remove from individualAudits
      const removedAudit = this.individualAudits.splice(index, 1);
      //console.log('Removed audit:', removedAudit);
    }
  }


  displayFunction(obj: any){
    if (obj) {return obj.job_name; }
  }

  displayFunctionEmployee(obj: any){
    if(obj) { return obj.employee_name}
  }

  displayFunctionIndivEmployee(obj: any){
    if(obj) { return obj.employee_name}
  }

  resetContactName(data){
    data.job.name='';
    this.manager = '';
    data.job.contact_name = 0;
    this.form.get('contact_name').setValue(0);
    this.contactChanged = true;
    this.tripMoveChecked = false;
    this.tripMoveChoice = null;
  }

  toggleOverride(){
    this.filterOverride = !this.filterOverride;

    this.customerjob$ = this.form.get('customer_job').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.service.getCustomerJobsDropdown(value as string, 0, this.filterOverride,this.scope? this.scope : '') : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

  }


  //upload an audit photo
  private uploadPhoto(file: File, partialFileName: string, urlc: string, fullFileName: string, position: number) {
      this.service.uploadAuditPhoto(file, partialFileName).subscribe(
        () => {
          this.messager.openSnackBar('Successfully uploaded!', '', 'successAlert');
        },
        error => this.messager.openSnackBar('Failed: ' + error, '', 'errorAlert')
      )
  }

  resetEmployeeName(data){
    data.job.employee_name = '';
    data.job.technitian = 0;
  }

  onSelectEmployee(obj: any){
    this.employee_name = obj.employee_name;
    this.data.job.employee_name = obj.employee_name;
    this.data.job.initials = obj.initials;
    this.data.job.technitian = obj.employee_id;
    this.form.get('technitian').setValue(obj.employee_id);
    this.technitianChanged = true;
    // Employee changed, so re-ask about the rest of the trip on the next save.
    this.tripMoveChecked = false;
    this.tripMoveChoice = null;
    this.bamboo_id = obj.bamboo_id;
    // No hours refetch here: the indicator is keyed on the location's region.
    this.checkEmployeeOff(this.bamboo_id, this.form.get('schedule_date').value);
    this.checkBarrisAvailability();

    this.data.job.phone = obj.phone;
    this.data.job.e_mail = obj.e_mail;

    this.checkCredentials();
    let warningDialog;

    if(!obj.employee_name.toLowerCase().includes('unassigned') &&
    this.form.get('customer_jobtype').value.toLowerCase().includes('pdwi') &&
    !this.form.get('customer_jobtype').value.toLowerCase().includes('re') &&
    this.mode == EDITING_MODE &&
    this.track_id > 0 &&
    !this.fromPage.includes('Schedule')){
      setTimeout(() => {
      warningDialog = this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
          warning_title: 'Update Techs',
          warning_description: 'Update Inspector for other jobs on the track?',
          warning_sub: '',
          confirmText: 'Yes',
          cancelText: 'No',
          showCancelButton: true
        }
        }).afterClosed().subscribe(result => {
          if (result !== 1) {
            this.updateTech = 1;
          }else {
            this.updateTech = 2;
          }

          if (this.technitian) {
            this.technitian.nativeElement.blur();
          }

          if (this.autoTrigger) {
            this.autoTrigger.closePanel();
          }
        });
      }, 300);
    }

  }

  onSelectIndivEmployee(obj: any){
    this.newAudit.employee = obj.employee_name;
    this.newAudit.employee_id = obj.employee_id;
    this.form.get('indivEmployee').setValue(obj.employee_name);
    //console.log(this.form.get('indivEmployee').value);
    //console.log(obj);
  }

  updateScore(): void {
    this.newAudit.score = this.form.get('indivScore').value;
  }

  checkEmployeeOff(bamboo_id, date?){

    //////console.log(date);
      // Check if obj.bamboo_id is in this.timeOffEmployees
      const timeOff = this.timeOffEmployees.find(employee => employee.employeeId === bamboo_id);
      //////console.log(timeOff);
      if (timeOff) {

        //get the date
        if(date){
          //see if the date is before the timeOff.endDate. if so throw the message.
          const inputDate = new Date(date);
          const startDate = new Date(timeOff.startDate);
          const endDate = new Date(timeOff.endDate);

          // Check if the input date is before the timeOff.endDate
          if (inputDate >= startDate && inputDate <= endDate) {
              //////console.log('Employee is off from ' + timeOff.startDate + ' to ' + timeOff.endDate + '.');
              this.timeOffShow = true;
              this.timeOffMessage = 'NOTE: Employee is off from ' + timeOff.startDate + ' to ' + timeOff.endDate + '.';
          }else {
            this.timeOffShow = false;
          }
          //this.messager.openSnackBar('NOTE: This employee is off until ' + timeOff.endDate, '', 'errorAlert');
        } else {
          this.timeOffShow = false;
          //this.messager.openSnackBar('NOTE: This employee is off until ' + timeOff.endDate, '', 'errorAlert');
        }
      }
  }

  /*
   * Advisory only: single Ok, nothing blocked and neither field reverted. Called from
   * both selection handlers because either half of the pair can be picked first.
   */
  checkBarrisAvailability(): void {

    if(Number(this.form.get('technitian').value) !== BARRIS_EMPLOYEE_ID){ return; }

    // A plain Date once the dialog has loaded a job, a moment straight off the
    // picker, and '' when another guard has just rejected the date.
    const picked = this.form.get('schedule_date').value;
    if(!picked){ return; }

    const d = moment(picked);
    if(!d.isValid() || !BARRIS_UNAVAILABLE_DAYS.includes(d.day())){ return; }

    this.dialog.open(WarningPopupComponent, {
      width: '500px',
      data: {
        warning_title: BARRIS_UNAVAILABLE_TITLE,
        warning_description: BARRIS_UNAVAILABLE_MSG,
        warning_sub: '',
        confirmText: 'Ok',
        showCancelButton: false
      }
    });

    // The 'location_id: <id>' token is what puts this line in the location's App Log modal.
    this.log.warn(this.data.usernamee + ' was warned: scheduling Barris Coleman on '
      + d.format('dddd MM/DD/YYYY') + ' location_id: ' + this.form.get('location_id').value);
  }

  isBankHolidayConflict(date): boolean {

    let non_sitevisitrqd_jobs = ['performance', 'rescheck', 'n/s', 'unassigned compliance', 'compliance', 'report', 'audit', 'tradeoff modeling'];

    if(this.bankHolidays.includes(date) && (this.customer_name == null || !this.customer_name.includes('GPS'))
      &&  !non_sitevisitrqd_jobs.some(job => this.form.get('customer_jobtype').value.toLowerCase().includes(job))){

        this.messager.openSnackBar('Cannot schedule on this date (holiday). Please select another date.', '', 'errorAlert');
        return true;
        //this.form.get('schedule_date').setValue('');
    }

    return false;

  }




  onSelectDate(type: string, event: MatDatepickerInputEvent<Date>){

    // 'Mandatory Job' lock. The picker is already disabled for these users; this
    // reverts the value in case some other path reaches the manual date change.
    if(this.moveLocked){
      this.form.get('schedule_date').setValue(this.data.fetchedJob.schedule_date || null);
      this.messager.openSnackBar(this.MANDATORY_LOCK_MSG, 'Close', 'errorAlert');
      return;
    }

    //going to check for most common non site visit required jobs
    let non_sitevisitrqd_jobs = ['performance', 'rescheck', 'n/s', 'unassigned compliance', 'compliance', 'report', 'audit', 'tradeoff modeling'];
    
    const job_status = this.form.get('job_status') ? this.form.get('job_status').value.toLowerCase() : '';

    let date = convert_schedule_date_to_string_date(this.form.get('schedule_date').value);
    console.log('Selected date: ' + date);
    console.log('Job status: ' + job_status);

    if(this.sitevisitreqd && event.value) {
      const selectedDate = new Date(event.value);
      const dayOfWeek = selectedDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
      
      if(dayOfWeek === 0 && job_status != 'canceled' && job_status != 'on hold') { // Sunday
        this.messager.openSnackBar(`Sundays cannot be selected for jobs that require a site visit, unless selected job status is 'Canceled' or 'On hold' `, '', 'errorAlert');
        this.form.get('schedule_date').setValue('');
        this.isSunday = true;
        this.hoursInfo = null;   // date was cleared, so the hint no longer applies
        return;
      }else{
        this.isSunday = false;
      }
    }

    if(this.isBankHolidayConflict(date)){
      this.form.get('schedule_date').setValue('');
    }else{
      this.data.job.schedule_date = date;
    }


    this.checkEmployeeOff(this.bamboo_id,date);
    var note = this.form.get('job_notes').value;
    note.indexOf('Rescheduled to') > 0 ?
      this.form.get('job_notes').setValue(this.updateNote(note)) :
      '';

    if(this.form.get('job_status').value.includes('Projected')){
      this.form.get('job_status').setValue('Scheduled');
    }
    this.schedDateChanged = true;
    // Date changed, so re-run the blackout-date prompt on the next save.
    this.blackoutChecked = false;
    this.overrideBlackout = false;
    this.tripMoveChecked = false;
    this.tripMoveChoice = null;
    this.sqftReminderChecked = false;

    if(this.mode == ADDING_MODE){
        this.setDueDate();
    }

    this.loadScheduledHours();

    // Last, so a date the bank-holiday guard above just cleared cannot warn --
    // several bank holidays are Mondays.
    this.checkBarrisAvailability();
  }

  updateNote(theString): string{
    var arr = theString.split('Rescheduled to')
    return (arr[0] + arr[1].substring(8));
  }


  onSelectFlexDate(type: string, event: MatDatepickerInputEvent<Date>){
    //this.data.job.schedule_date = date;
    let year = this.form.get('flex_start_date').value._i.year;
    let month = this.form.get('flex_start_date').value._i.month;
    month = month + 1;


    if (month < 10) {
      month = '0' + month;
    }

    let stringMonth = '0' + month;

    let day = this.form.get('flex_start_date').value._i.date;
    if (day < 10) {
      day = '0' + day;
    }
    this.data.job.flex_start_date = year + '-' + month + '-' + day;

  }




  longRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen',
      animation: {
        enterDuration : 1000,
        exitDuration : 2000
      }
    });
    ripRef.fadeOut();
  }

  longRippleError(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'red',
      animation: {
        enterDuration : 1000,
        exitDuration : 2500
      }
    });
    ripRef.fadeOut();
  }

  onSelectContact(contact: Contact){
    this.data.job.contact_name = contact.id;
    this.data.job.name = contact.name;
    this.manager = contact.name;
    this.contactChanged = true;
    this.tripMoveChecked = false;
    this.tripMoveChoice = null;
    this.data.job.contact_e_mail = contact.email.trim();

    this.form.get('contact_e_mail').setValue(contact.email.trim());
    this.form.get('contact_name').setValue(contact.id);
    if(contact.email.trim().length > 1){
      this.longRipple(this.manageremailRipple);
    }else {
      this.longRippleError(this.manageremailRipple);
    }


    this.data.job.contact_phone = contact.phone;
    this.form.get('contact_phone').setValue(contact.phone);

    if(contact.phone.trim().length > 1){
      this.longRipple(this.managerphoneRipple);
    }else {
      this.longRippleError(this.managerphoneRipple);
    }

    if(this.form.get('contact_name').value == 895){
      this.form.get('job_notes')
      .setValue(this.form.get('job_notes').value + '\n' + 'AM REQUEST!');
    }

  }

  async enableTripMode(){
    if (this.mode == EDITING_MODE && !this.isEditTrip) { return this.toggleConvertToTrip(); }
    this.tripMode = !this.tripMode;

    if (this.tripMode == true) {
      // Set job type to Trip and disable the control
      this.form.get('istrip').setValue(true);
      this.form.get('customer_job').setValue(14775);
      this.form.get('customer_jobtype').setValue('Performance Point Trip');
      this.form.get('customer_job').disable();

      // Fetch available jobs for trip mode - wait for completion before showing carryover prompt
      if (!this.availableJobs || this.availableJobs.length == 0) {
        await this.fetchJobsForTripModeAsync();
      }

      await this.promptCarryOver();
    } else {
      // Re-enable the customer_job control when unchecking Trip
      this.form.get('istrip').setValue(false);
      this.form.get('customer_job').enable();
      this.carryOverJobs = [];
      this.carryOverJobIds = [];
      this.previousTripId = null;
    }
  }

  fetchJobsForTripMode(): void {
    this.service.getJobsForLocation(this.data.location.location_id).subscribe(
      res => {
        this.availableJobs = res.Jobs
          // Exclude other trip parents (istrip) and any job already pointed at a trip
          // (trip_id set) — a job can only belong to one trip at a time, and offering an
          // already-tripped job here would silently steal it onto this trip on save.
          .filter(job => job.istrip != true && !job.trip_id)
          .map(job => {
          return {
            job_id: job.job_id,
            customer_job: job.customer_job,
            customer_jobtype: job.customer_jobtype,
            customer_name: job.customer_name,
            schedule_date: job.schedule_date,
            estimatedtime: job.estimatedtime || 0
          }
        }).filter(j => j.job_id !== this.data.fetchedJob?.job_id);

        if (this.availableJobs.length == 0) {
          this.messager.openSnackBar('No available jobs found for this location.', '', 'errorAlert');
        }
      }, err => {
        this.availableJobs = [];
        this.messager.openSnackBar('Could not load jobs for trip mode.', '', 'errorAlert');
      }
    );
  }

  async fetchJobsForTripModeAsync(): Promise<void> {
    try {
      const res = await this.service.getJobsForLocation(this.data.location.location_id).toPromise();
      this.availableJobs = res.Jobs
        // See fetchJobsForTripMode() above — same exclusion rule.
        .filter(job => job.istrip != true && !job.trip_id)
        .map(job => {
        return {
          job_id: job.job_id,
          customer_job: job.customer_job,
          customer_jobtype: job.customer_jobtype,
          customer_name: job.customer_name,
          job_status: job.job_status,
          schedule_date: job.schedule_date,
          estimatedtime: job.estimatedtime || 0
        }
      }).filter(j => j.job_id !== this.data.fetchedJob?.job_id);

      if (this.availableJobs.length == 0) {
        this.messager.openSnackBar('No available jobs found for this location.', '', 'errorAlert');
      }
    } catch (err) {
      this.availableJobs = [];
      this.messager.openSnackBar('Could not load jobs for trip mode.', '', 'errorAlert');
    }
  }

  onFirstJobCheck(){
    this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + '**FIRST STOP!**');
  }

//**
// COMPLIANCE DATES
//  */
  setDueDate(): void {

    let obj = this.form.get('customer_jobtype').value;
    let cj = this.form.get('customer_job').value;

    let isTrue = this.customer_name.toLowerCase().includes('true');
    let isClassica = this.customer_name.toLowerCase().includes('classica');
    let isLennar = this.customer_name.toLowerCase().includes('lennar-ral');

    this.prodCustText = '';
    // Reset statuses to default, then apply jobtype-specific overrides
    this.stati = [...this.defaultStati];
    if(obj.toLowerCase().includes('manual')){
      this.stati = this.reportStati;
    } else if(this.usesComplianceStati(obj)){

      this.stati =[
      {value: 'Scheduled', viewValue: 'Scheduled'},
      {value: 'PendInfo', viewValue: 'Pending Info'},
      {value: 'PendPaym', viewValue: 'Pending Payment'},
      {value: 'EngStamp', viewValue: 'Engineer Stamp'},
      {value: 'Rea4Review', viewValue: 'Ready for Review'},
      {value: 'Complete', viewValue: 'Complete'}
      ];

      const newdate = new Date(this.form.get('schedule_date').value);
      const modeler_newdate = new Date(this.form.get('schedule_date').value);
      //set due dates

      //PERFORMANCE REPORTS
      // Modeling_MF matches none of these branches, so it gets the report status
      // list above with no due-date math.
      if (obj.toLowerCase().includes('performance')) {
         if (isTrue || isClassica ){
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,5));
            this.form.get('flex_start_date').setValue(newdate);
            if(obj.toLowerCase().includes('n/s')){
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,4));
            }else{
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,3));
            }
            this.form.get('modeler_duedate').setValue(modeler_newdate);
          }else{
            if(obj.toLowerCase().includes('cust') || isLennar){
              this.prodCustText = isLennar ? 'PROD' :  'CUST';
              newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,14));
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,11));
              this.form.get('flex_start_date').setValue(newdate);
              this.form.get('modeler_duedate').setValue(modeler_newdate)
            }else {
              this.prodCustText = 'PROD';
              newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,7));
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,4));
              this.form.get('flex_start_date').setValue(newdate);
              this.form.get('modeler_duedate').setValue(modeler_newdate);
            }
        }

      } else if (obj.toLowerCase().includes('rescheck')) {  //RES CHECKS

        //if it's Classica or True Homes
        if(isTrue || isClassica || isLennar) {
          newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,3));
          this.form.get('flex_start_date').setValue(newdate);
          modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,2));
          this.form.get('modeler_duedate').setValue(modeler_newdate);
        }else {
          if(obj.toLowerCase().includes('cust') || isLennar){
            this.prodCustText = isLennar ? 'PROD' :  'CUST';
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,5));
            modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,4));
          }else {
            this.prodCustText = 'PROD';
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,2));
            modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,1));
          }
        }
        // Set the updated date to flex_start_date
        this.form.get('flex_start_date').setValue(newdate);
        this.form.get('modeler_duedate').setValue(modeler_newdate);

      }else if (obj.toLowerCase().includes('unassigned')) { //UNASSIGNED COMPLIANCE REPORTS

          if (isTrue || isClassica || isLennar){
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,5));
            this.form.get('flex_start_date').setValue(newdate);
            modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,3));
            this.form.get('modeler_duedate').setValue(modeler_newdate);
          }else{

            if(obj.toLowerCase().includes('cust') || isLennar){
              this.prodCustText = isLennar ? 'PROD' :  'CUST';
              newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,14));
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,11));
              this.form.get('flex_start_date').setValue(newdate);
              this.form.get('modeler_duedate').setValue(modeler_newdate);
            }else {
              this.prodCustText = 'PROD';
              newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,7));
              modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,4));
              this.form.get('flex_start_date').setValue(newdate);
              this.form.get('modeler_duedate').setValue(modeler_newdate);
            }

          }
      }else if (obj.toLowerCase().includes('tradeoff modeling')) { //TRADEOFF MODELING
          if(obj.toLowerCase().includes('complex')){
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,14));
            modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,10));
          }else{
            newdate.setDate(newdate.getDate() + this.turnDaysIntoBusinessDays(newdate,7));
            modeler_newdate.setDate(modeler_newdate.getDate() + this.turnDaysIntoBusinessDays(modeler_newdate,5));
          }
          this.form.get('flex_start_date').setValue(newdate);
          this.form.get('modeler_duedate').setValue(modeler_newdate);
      }
   }

    // Prelim_MF / Prelim Updates_MF are exempt: they carry compliance statuses but
    // must not have due dates written from anywhere. Every other prelim jobtype
    // (Prelim, Prelim_cust, Prelim HERO-*, Preliminary Testing...) is unchanged.
    if(obj.toLowerCase().includes('prelim') && !this.isDueDateExempt(obj)){
      const schedDateB = new Date(this.form.get('schedule_date').value);
      schedDateB.setDate(schedDateB.getDate() + 14);
      this.form.get('flex_start_date').setValue(schedDateB);
    }

    if(this.form.get('flex_start_date').value < this.form.get('schedule_date').value){
      this.log.error('1970s date detected in new job entry:' + this.form.getRawValue());
    }
  }

  turnDaysIntoBusinessDays(fromDate,intendedBusinessDays) {
    // Get today's date and the current day of the week (Sunday = 0, Monday = 1, ..., Saturday = 6)
    //const today = new Date();
    const currentDayOfWeek = fromDate.getDay();

    let totalDays = 0; // Days to offset
    let countedBusinessDays = 0; // Track counted business days

    while (countedBusinessDays < intendedBusinessDays) {
      // Increment totalDays to check the next day
      totalDays++;

      // Determine the current day in the loop
      const projectedDayOfWeek = (currentDayOfWeek + totalDays) % 7;

      // Only count business days (Monday to Friday)
      if (projectedDayOfWeek !== 0 && projectedDayOfWeek !== 6) {
      countedBusinessDays++;
      }
    }
    return totalDays; // Return total days including skipped weekends
    }

  checkCredentials(){
    if(this.form.get('customer_job').value == 0 || this.form.get('customer_job').value == null ||
       this.form.get('technitian').value == 0 || this.form.get('technitian').value == null || this.isAudit){
      return;
    }else {
    var jobTypeCerts$ = this.service.getJobTypeCerts(this.form.get('customer_job').value);
    var employeeCred$ = this.service.getEmployeeCerts(this.form.get('technitian').value);


    forkJoin([jobTypeCerts$, employeeCred$]).subscribe(
      ([jobTypeCerts, employeeCred]) => {
        this.jobCerts = jobTypeCerts.Error ? [] : jobTypeCerts.Data.map(cert => cert.toLowerCase());
        this.empCreds = employeeCred.Error ? [] : employeeCred.Data.map(cert => cert.toLowerCase());

        if(this.jobCerts.length > 0){
          const meetsrequirements = this.jobCerts.every(cert => this.empCreds.includes(cert));
          if(meetsrequirements){
            this.certStatus = { text: 'All required certifications are met.', color: '#8cc63f'};
          }else{
            this.showModal();
            this.certStatus = { text: 'The employee selected does not have the required credential for this jobtype. Please select another employee.', color: 'red'};
          }
        }else {
          this.certStatus = { text: 'No listed certifications needed for this job type.' , color: '#8cc63f'};
          return;
        }
      },
      err => {
        this.jobCerts = [];
        this.empCreds = [];
      });
    }



  }

  fredAslaghiarRequest(): void {

    const job_note = this.form.get('job_notes').value;
    const coventrySub = 4850;

    if(!job_note.includes('AM REQUEST!')){
      if(this.form.get('contact_name').value == 895 || this.subdivision_id == coventrySub){
        this.form.get('job_notes')
        .setValue(job_note + '\n' + 'AM REQUEST!');
      }
    }
  }

  //passed the customer job type (cjt), subdivision id, and the array of tag ids
  notesRequests(cjt, subdivision_id, tagIds, type = ADDING_MODE): void {

    if(cjt.includes('hero') && cjt.includes('final')){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + 'Record Meter Photo via the Home Page of Raterform!');
    }

    if(subdivision_id == 4280){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + '_Leave Sticker on front top left of panel_');
    }

    if(subdivision_id == 4689){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + 'If this is a 2 story unit, PLEASE LEAVE THE STICKER IN THE MICROWAVE');
    }

    if(tagIds.includes(34)){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + 'EACH UNIT NEEDS A STICKER.');
    }

    //DO NOT PUSH JOB TAG CHECK (tag id 57) — must be completed today
    if(tagIds.includes(57)){
      if(!(this.form.get('job_notes').value || '').toLowerCase().includes('do not push job')){
        this.form.get('job_notes').setValue((this.form.get('job_notes').value || '') + '\n' + 'Do not push job, must be completed today.');
      }
    }

    const RED_CEDAR_CLT_DBBDCHECK_ID = 14339;
    if(this.form.get('customer_job').value == RED_CEDAR_CLT_DBBDCHECK_ID) {
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + 'If no panel, place sticker inside left-hand door on kitchen sink base.');
    }

    if(type == ADDING_MODE){
      if(tagIds.includes(7)){
        this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n ATTIC TENT REQUIRED. ');
      }
    }

    if(this.data.job.customer_name && this.data.job.customer_name.toLowerCase().includes('zurich') 
    && cjt.toLowerCase().includes('pdwi') ){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + '**SEAL TOP PLATES WITH LONG FOAM GUN**');
    }

  }

  showModal() : void {
    this.modalActive = true;
    const modal = document.getElementById('certmodal');
    if(modal){
      modal.style.display = 'block';
    }
  }

  closeModal(): void {
    this.modalActive = false;
    const modal = document.getElementById('certmodal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  /*
   * Card tQPtadd5 - job types that earn the Duke HERO rebate at the final visit.
   *
   * Matched on the job-type NAME because that is all onSelectJob receives, and the
   * catalog is inconsistent ('FinalHERO-Prod' has no space, others read
   * 'Final V3.1+IAP+HERO-Prod'). Re_ jobs are excluded: a re-final means a final
   * already happened, so the pre-drywall conversation is long over.
   *
   * DB&BD ...HERO is deliberately NOT included (owner's call): on dev 12,193 of the
   * 12,401 lots carrying a DB&BD HERO job also carry a Final HERO job, so including
   * it would just pop the same warning twice per lot.
   */
  isHeroFinalJobtype(jobTypeName: string): boolean {
    const jt = (jobTypeName || '').trim().toLowerCase();
    if(!jt.includes('hero')){ return false; }
    if(jt.startsWith('re_') || jt.startsWith('re ')){ return false; }
    return jt.startsWith('final');
  }

  onSelectJob(obj: any){

    this.selectedJobObj = obj;
    this.sqftReminderChecked = false;
    if(this.passedFinal && obj.job_type_name.toLowerCase().includes('final') && !(obj.customer_name.toLowerCase().includes('gps')) && !(obj.job_type_name.toLowerCase().includes('audit')) && this.subdivision_obj.ismultifamily == false ){

      const warningdialogRef =  this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
            warning_title: 'Duplicate Finals Warning',
            warning_description: '',
            warning_sub: 'You are attempting to create a duplicate final for a home in which the Final has already been marked Pass (and registered with Resnet). This is not recommended based upon our quality assurance standards.',
            confirmText: 'Ok',
            showCancelButton: false
        }
    }).afterClosed().subscribe(
      res => {
        if(res == 1){
          return;
        }else {
        }
      });
      //this.messager.openSnackBar('Cannot schedule a final inspection if the final has already passed.', '', 'errorAlert');
    }

    /*
     * Card tQPtadd5 - HERO final with no completed pre-drywall.
     * Advisory only: single Ok button, nothing is blocked and the selection is not
     * reverted. ADDING_MODE only, because completedPdw is only fetched there and
     * re-warning on every edit would be noise.
     */
    if(this.mode == ADDING_MODE && !this.completedPdw && this.isHeroFinalJobtype(obj.job_type_name)){

      this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
            warning_title: 'No Completed Pre-Drywall',
            warning_description: 'Hey, you\'re trying to add a ' + (obj.job_type_name || '').trim() + '.',
            warning_sub: 'This house has no completed pre-drywall inspection on record. The house will not be eligible for the rebate without a PDWI.',
            confirmText: 'Ok',
            showCancelButton: false
        }
      });

      this.log.warn(this.data.usernamee + ' was warned: adding ' + (obj.job_type_name || '').trim()
        + ' to location ' + this.data.location.location_id + ' with no completed PDWI.');
    }

    this.data.job.customer_job = obj.customerjob_id;
    this.data.job.customer_name = obj.customer_name;
    this.customer_name = obj.customer_name;
    this.data.job.customer_jobtype = obj.job_type_name;
    this.form.get('customer_job').setValue(obj.customerjob_id);
    this.form.get('customer_jobtype').setValue(obj.job_type_name);
    this.loadScheduledHours();   // Energy <-> QI change re-groups the number


    console.log('Selected job type: ', obj); 
    // Reset statuses to default, then apply jobtype-specific overrides
    this.stati = [...this.defaultStati];


    let fetchedcustomerJobtype = this.data.fetchedJob ? this.data.fetchedJob.customer_jobtype?.toLowerCase() : '';
    if(fetchedcustomerJobtype && this.usesComplianceStati(fetchedcustomerJobtype)){
      this.stati = this.reportStati;
    }

    if(this.form.get('customer_jobtype').value.toLowerCase().includes('axis ngbs submission status_mf')){
      this.stati = this.axisStati;
    }

    this.checkPayHold();

    // Enable/disable due date editing based on whether jobtype contains 'manual'
    if(obj.job_type_name.toLowerCase().includes('manual')){

      console.log('Enabling flex start date for manual job type.');
      this.isManualJobtype = true;
      this.stati = this.reportStati;;
      this.form.get('flex_start_date').enable();
    } else {
      this.isManualJobtype = false;
      this.form.get('flex_start_date').disable();
    }

    let date = convert_schedule_date_to_string_date(this.form.get('schedule_date').value);

    if(this.isBankHolidayConflict(date)){
      this.form.get('schedule_date').setValue('');
    }
    this.checkIsSiteVisitReqd(obj.job_type);
    this.checkCredentials();
    //get tags for customerjob_id
    this.tagService.getCustomerjobsTags(obj.customerjob_id).subscribe(
      res => {
        if(res.Tags.cjtags?.length > 0){
          this.inheritedCustomerJobsTags = true;
        }

        res.Tags.cjtags?.forEach(tag => {
            if(!this.data.job.tags){
              this.data.job.tags = [];
            }
            if(!this.data.job.tags.includes(tag)){
              this.data.job.tags.push(tag);
            }
        });

        this.data.job?.tags?.forEach(tag => {
          this.service.getTag(tag).subscribe(
            res => {
              this.inputTags.push(res.data);
            }
          );
        });

      }, err => {
        this.messager.openSnackBar('Error getting tags for customerjob_id: ' + obj.customerjob_id, '', 'errorAlert');
      });
    //check if generator is needed + add to notes
    if(this.data.generator == true){
      if(obj.job_type_name.toLowerCase().includes('db&bd') || obj.job_type_name.toLowerCase().includes('db') || (obj.job_type_name.toLowerCase().includes('final') && (obj.job_type_name.toLowerCase().includes('hvg') )) ){
        this.form.get('job_notes').setValue( this.form.get('job_notes').value + '\n' + 'Generator required');
      }
    }
    //set estimated job time if available (but not if in trip mode with jobs already selected)
    if (!this.tripMode || this.selectedJobs.length === 0) {
      if(obj.estimatedtime > 0)
      {
        this.form.get('estimatedtime').setValue(obj.estimatedtime);
        this.longRipple(this.estimatedtimeRipple);
      }else {
        this.longRipple(this.estimatedtimeRipple);
      }
    }
    // If in trip mode with jobs selected, keep the accumulated time
    //add QI + Drain Cam for certain Job types DR Horton South RDU
    if(obj.customerjob_id == 4856 ||
      obj.customerjob_id == 4857 ||
       obj.customerjob_id == 5014 ||
       obj.customerjob_id == 4860 ||
       obj.customerjob_id == 4861 ||
       obj.customer_name.trim().toLowerCase() == 'dr horton south rdu')
    {
      this.form.get('job_notes').setValue( this.form.get('job_notes').value + '\n' + 'QI + Drain Cam');
    }

    //add 'Test Ducts!' to certain DR Horton RIC jobs
    if(obj.customerjob_id == 2107 ||
      obj.customerjob_id == 2108)
    {
       this.form.get('job_notes').setValue( this.form.get('job_notes').value + '\n' + 'Test Ducts!');
    }
    //////////////////////////////////////////////////////////////////
    // Temporary solution for true homes and their subdivisions:
    // VCB Villages at Cramerton Mills TH
    // VCB Villages at Cramerton Mills
    // SHY
    //////////////////////////////////////////////////////////////////
    const trueHomesSubs = [4540, 4796,2688];

    if(trueHomesSubs.includes(this.subdivision_id)){
       this.form.get('job_notes')
       .setValue( this.form.get('job_notes').value + '\n' + 'Bring generator. ' + '\n'+ '⛔⛔ MUST USE CONSTRUCTION ENTRANCE OR WILL INCUR $500 FINE! ⛔⛔');
    }


    //HERO Mandatory tag
    if(this.customer_name.trim().toLowerCase().includes('true homes')){
      //check the climate zone and utility for subdivision
      this.service.getClimateZone(this.data.location.location_id).subscribe(
        res => {
          if(res.Error){
            this.messager.openSnackBar('Error getting climate zone for location.', '', 'errorAlert');
          }else {
            if(res.ClimateInfo.cz && res.ClimateInfo.elecutility){
              if(res.ClimateInfo.cz.trim() == '4' && res.ClimateInfo.elecutility.trim() == 'DEC'){
                this.messager.openSnackBar('HERO Mandatory tag added. ', '', 'successAlert');
                this.inputTags.push({id: 23, displayname: 'Hero Mandatory'});
                this.form.get('tagControl').setValue(this.inputTags.map(tag => tag.id));
              }
          }
        }
        }, err => {
          this.messager.openSnackBar('Error getting climate zone for location.', '', 'errorAlert');
        }
      );
    }


    // Disable/enable billing fields based on billable status
    if (obj.billable === false) {
      this.form.get('invoice_number').disable();
      this.form.get('po_number').disable();
      this.form.get('billing_note').disable();
    } else {
      this.form.get('invoice_number').enable();
      this.form.get('po_number').enable();
      this.form.get('billing_note').enable();
    }

    if(this.mode == ADDING_MODE){
        this.setDueDate();
    }

  }


  isComplianceJob(jobTypeName: string): boolean {
    const complianceKeywords = ['compliance', 'rescheck', 'report', 'tradeoff modeling'];
    return complianceKeywords.some(keyword => jobTypeName.includes(keyword));
  }

  // True when this job's status dropdown should be the compliance/report list.
  // Single source of truth for the three gates in this component that share
  // COMPLIANCE_STATUS_KEYWORDS (ngOnInit, setDueDate, onSelectJob).
  usesComplianceStati(customerJobtype: string): boolean {
    const cjt = (customerJobtype || '').toLowerCase();
    return this.COMPLIANCE_STATUS_KEYWORDS.some(keyword => cjt.includes(keyword));
  }

  // True when this job's due dates (flex_start_date / modeler_duedate) must be
  // left alone by this dialog - no recompute, no reset, no prelim +14.
  isDueDateExempt(customerJobtype: string): boolean {
    const cjt = (customerJobtype || '').toLowerCase();
    return this.DUE_DATE_EXEMPT_KEYWORDS.some(keyword => cjt.includes(keyword));
  }



  parseAuditPhotoData(data: { [key: string]: string }): void {
    // Determine how many photos and captions are in the data
    const numPhotos = Object.keys(data).filter(key => key.startsWith('photo_')).length;

    for (let i = 1; i <= numPhotos; i++) {
      const photoKey = `photo_${i}`;
      const captionKey = `caption_${i}`;

      if (data[photoKey] && data[captionKey]) {
        this.photoTable.push({
          photo: data[photoKey],
          caption: data[captionKey]
        });
      }
    }
  }

  cancel(){

    this.data.job.job_id = this.data.fetchedJob.get('job_id').value;
    this.data.job.customer_job = this.data.fetchedJob.get('customer_job').value;
    this.data.job.customer_jobtype = this.data.fetchedJob.get('customer_jobtype').value;
    this.data.job.technitian = this.data.fetchedJob.get('technitian').value;
    this.data.job.contact_name = this.data.fetchedJob.get('contact_name').value;
    this.data.job.contact_e_mail = this.data.fetchedJob.get('contact_e_mail').value;
    this.data.job.contact_phone = this.data.fetchedJob.get('contact_phone').value;
    this.data.job.flex_start_date = this.data.fetchedJob.get('flex_start_date').value;
    this.data.job.schedule_date = this.data.fetchedJob.get('schedule_date').value;
    this.data.job.job_status = this.data.fetchedJob.get('job_status').value;
    this.data.job.po_number = this.data.fetchedJob.get('po_number').value;
    this.data.job.invoice_number = this.data.fetchedJob.get('invoice_number').value;
    this.data.job.job_notes = this.data.fetchedJob.get('job_notes').value;
    this.data.job.billing_note = this.data.fetchedJob.get('billing_note').value;
    this.data.job.location_id = this.data.fetchedJob.get('location_id').value;
    this.data.job.invoice_amount = this.data.fetchedJob.get('invoice_amount').value;

  }

  removePhoto(index:number): void {
    this.photoTable.splice(index, 1);
    this.dataSource.data = [...this.photoTable]; // Update the data source
    //this.photoTable = this.photoTable.filter(item => item !== photoData);
  }

  //put photos in json format.
  savePhotos(): any {
    const photosJson = this.photoTable.reduce((result, item, index) => {
      result[`photo_${index + 1}`] = item.photo;
      result[`caption_${index + 1}`] = item.caption;
      return result;
    }, {});
    //console.log('Photos JSON:', JSON.stringify(photosJson));
    // Save JSON object or pass it to a function
    return JSON.stringify(photosJson);
  }

  updateNotes(){
    this.data.job.billing_note = this.form.get('billing_note').value;
    this.data.job.job_notes = this.form.get('job_notes').value;
  }

  // Opens the shared Add Note popup; on Done, prepends the stamped line to Job Notes.
  // Direct typing in the textarea is unaffected. Persists with the dialog's normal Save.
  openAddJobNote(){
    this.dialog.open(AddNoteDialogComponent, {
      width: '400px',
      data: { usernamee: this.data.usernamee }
    }).afterClosed().subscribe(stamped => {
      if(!stamped){ return; }
      const existing = this.form.get('job_notes').value;
      const updated = stamped + (existing ? '\n' + existing : '');
      this.form.get('job_notes').setValue(updated);
      this.updateNotes();
    });
  }

  processTags(){

    //loop through all tags, grab the id and push to id array;
    let idArray = [];
    this.inputTags.forEach(element => idArray.push(element.id));
    //call API function to update tag use count:
    this.service.updateTagUseCount(idArray).subscribe();
  }


  openWarningSnackBar(version: number) {
    const snackBarRef = this.snackbar.open(
      'Warning: You did not enter a contact for this job.',
      'Proceed',
      {
        duration: null,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['custom-snackbar']
      }
    );

    // Attach action to the "Proceed" button
    snackBarRef.onAction().subscribe(() => {
      this.proceedWithSaving(version);
    });
  }


  async saveClick(version: number) {

    // 'Mandatory Job' lock. Checked ahead of every other save side effect (status
    // cascade, emails, generator job creation) so nothing fires on a rejected edit.
    // Only the tag is checked here -- the schedule date is covered by the disabled
    // picker and the onSelectDate revert, and comparing dates would wrongly block
    // the compliance PendInfo -> Scheduled auto-move, which is allowed.
    if(version == 2 && this.wasMandatoryOnOpen && !this.isScheduler
       && !this.inputTags.some(t => t.id === MANDATORY_JOB_TAG_ID)){
      this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
          warning_title: 'Mandatory Job',
          warning_description: 'Only scheduling can remove the "Mandatory Job" tag. Please contact scheduling.',
          warning_sub: '',
          confirmText: 'Ok',
          showCancelButton: false
        }
      });
      this.log.warn(this.data.usernamee + ' was blocked from removing the Mandatory Job tag from job_id ' + this.data.job.job_id);
      return;
    }

    let warningDialog;
  if((this.form.get('contact_name').value == 0 || this.form.get('contact_name').value == null) && (!this.isAudit) && ( this.customer_name && !(this.customer_name?.toLowerCase().includes('gps')) && !(this.customer_name?.toLowerCase().includes('performance'))) ){
      warningDialog = this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
          warning_title: 'No Contact Selected',
          warning_description: 'You did not choose a contact for this job.',
          warning_sub: '',
          confirmText: 'Proceed',
          cancelText: 'Return to Form',
          showCancelButton: true
        }
        }).afterClosed().subscribe(result => {
          //console.log(result);
          if (result !== 1) {
            //console.log('User clicked Cancel');
            this.proceedWithSaving(version);
          }else {
            //console.log('returning');
            return;
          }
        });
  }else {
        try {
            let date = this.form.get('schedule_date').value;
            let formattedDate = moment(date).format('MM-DD-YY');
            // The region is resolved from the location by the backend, so the
            // check runs first and its verdict decides whether to gate.
            let res = await this.checkCapacity(formattedDate);
            let over = !!(res && this.capacityEnforced(res.Region) && (res.Overcapacity || res.WouldBeOver));
            if (over && this.capacityExempt) {
                // Exempt login: never gated. The date is still flagged so
                // everyone else keeps seeing the warning.
                this.setCapacity(formattedDate);
                this.proceedWithSaving(version);
            } else if (over && res.Pdwi) {
                // PDWI consumes capacity and can flag the date, but never
                // blocks the save.
                this.setCapacity(formattedDate);
                this.proceedWithSaving(version);
            } else if (over) {
                await this.handleOverCapacity(formattedDate, version);
            } else {
                this.proceedWithSaving(version);
            }
        } catch (error) {
            console.error('An error occurred: ', error);
        }
  }



}

async handleOverCapacity(formattedDate, version) {
    const warningdialogRef = this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
            warning_title: 'Over Capacity',
            warning_description: 'This region will be over capacity on this date. Would you like to proceed with scheduling?',
            warning_sub: '[Region]: ' + this.capacityRegion + (this.capacityCategory ? '\n [Work type]: ' + this.capacityCategory : '') + '\n [Date]: ' + formattedDate + '\n [Capacity]: ' + this.capacityHours + '\n [Current Hours Scheduled]: ' + parseFloat(this.totalHoursScheduled),
            confirmText: 'Yes',
            cancelText: 'No',
            showCancelButton: true
        }
    });

    const result = await warningdialogRef.afterClosed().toPromise();
    if (result !== 1) {
        // Proceed with save or add
        this.proceedWithSaving(version);
        this.setCapacity(formattedDate);
    }
}

checkIsSiteVisitReqd(jt_id): void {
  this.jtservice.jobIsSiteVisitReqd(jt_id).subscribe(
    res =>{
      this.sitevisitreqd = res.siteVisitReqd;
      console.log('Site visit required: ' + this.sitevisitreqd);
      
      if (this.sitevisitreqd === true) {
        const scheduleDateValue = this.form.get('schedule_date').value;
        if (scheduleDateValue) {
          let selectedDate: Date;
          
          if (scheduleDateValue instanceof Date) {
            selectedDate = scheduleDateValue;
          } else if (scheduleDateValue._d) {
            selectedDate = new Date(scheduleDateValue._d);
          } else if (typeof scheduleDateValue === 'string') {
            selectedDate = new Date(scheduleDateValue);
          } else {
            selectedDate = new Date(scheduleDateValue);
          }
          
          if (selectedDate && !isNaN(selectedDate.getTime())) {
            const dayOfWeek = selectedDate.getDay();

            const job_status = this.form.get('job_status') ? this.form.get('job_status').value.toLowerCase() : '';
            if (dayOfWeek === 0 && job_status !== 'cancelled' && job_status !== 'on hold') { // Sunday

              this.messager.openSnackBar(`Sundays cannot be selected for jobs that require a site visit, unless selected job status is 'Cancelled' or 'On hold' `, '', 'errorAlert');
              this.form.get('schedule_date').setValue('');
              this.data.job.schedule_date = null;
            }
          }
        }
      }
    }
  );
}

// Date filter function to disable Sundays when site visit is required
sundayDateFilter = (date: Date | null): boolean => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return true;
  }
  if (this.sitevisitreqd === true) {
    const day = date.getDay();
    const isAllowed = day !== 0;
    return isAllowed;
  }
  
  return true;
}

 //Specific helper function to add job note to True Charlotte jobs.
 //Appends (once) rather than replacing, so the scheduler's own notes survive.
trueCharlotteWestFunction(): void {
  const NOTE = 'FAIL IF NOT GRADE 1 NSULATION!';
  const existing = this.form.get('job_notes').value || '';
  if(!existing.includes(NOTE)){
    this.form.get('job_notes').setValue(existing ? existing + '\n' + NOTE : NOTE);
  }
}

proceedWithSaving(version) {
    version == 2 ? this.save() : this.add();
}

// Checks whether the selected schedule date is a blackout date for this
// location's region. If so, prompts the scheduler to confirm whether they
// still want to schedule on that date. The provided callback re-runs the
// originating save/add flow once the check (and any prompt) resolves.
//  - "Yes" sets overrideBlackout = true  -> backend keeps the blackout date.
//  - "No"  leaves overrideBlackout false -> backend relocates per the rule.
runBlackoutCheck(proceed: () => void): void {
    const schedDateVal = this.form.get('schedule_date').value;
    const locationId = this.form.get('location_id').value;

    if(!schedDateVal || !locationId){
      this.overrideBlackout = false;
      this.blackoutChecked = true;
      proceed();
      return;
    }

    const dateStr = moment.utc(schedDateVal).format('YYYY-MM-DD');
    const technitian = this.form.get('technitian').value;
    // Passing the selected customer job lets the backend skip the warning for
    // jobtypes that aren't subject to blackout dates (office/compliance, audit,
    // and specialist jobtypes).
    const customerJob = this.form.get('customer_job').value;

    this.service.checkBlackoutDate(locationId, dateStr, technitian, customerJob).subscribe(
      res => {
        if(res && !res.Error && res.isBlackout){
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '420px',
            data: {
              title: 'Blackout Date',
              message: `The selected date (${moment.utc(schedDateVal).format('MM/DD/YYYY')}) is a blackout date`
                + (res.region ? ` for the ${res.region} region` : '')
                + (res.category ? ` (${res.category} work)` : '')
                + `. Would you still like to schedule this job on this date?`,
              confirmText: 'Schedule anyway',
              cancelText: 'Cancel'
            }
          });
          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            this.overrideBlackout = !!confirmed;
            this.blackoutChecked = true;
            proceed();
          });
        } else {
          this.overrideBlackout = false;
          this.blackoutChecked = true;
          proceed();
        }
      },
      err => {
        // On a check failure, proceed with the normal (rule-applies) behavior.
        this.overrideBlackout = false;
        this.blackoutChecked = true;
        proceed();
      }
    );
}

// Which of the task's employee/manager fields changed in this edit and should follow onto the
// trip when the scheduler says so. 'contact' covers manager name, phone and email together.
tripFollowFields(): string[] {
    const fields: string[] = [];
    if (this.technitianChanged) { fields.push('technitian'); }
    if (this.contactChanged || this.form.get('contact_e_mail').dirty || this.form.get('contact_phone').dirty) { fields.push('contact'); }
    return fields;
}

// When a trip TASK (a job with trip_id) is being moved to a date other than its trip's, or its
// employee/manager changed, ask the scheduler whether the whole trip should follow. The answer
// lands in tripMoveChoice and is applied by save() once the task itself is saved. Dismissing
// the prompt (Esc / clicking outside) goes back to the dialog without saving.
runTripTaskMoveCheck(proceed: () => void): void {
    const done = (choice: 'trip' | 'detach' | null, fields: string[] = []) => {
      this.tripMoveChoice = choice;
      this.tripMoveFields = choice === 'trip' ? fields : [];
      this.tripMoveChecked = true;
      proceed();
    };

    const schedDateVal = this.form.get('schedule_date').value;
    const dateEdited = this.schedDateChanged && !!schedDateVal;
    const followFields = this.tripFollowFields();
    if(!this.data.fetchedJob?.trip_id || (!dateEdited && followFields.length === 0)){
      done(null);
      return;
    }

    this.service.getTripTaskMoveInfo(this.data.job.job_id).subscribe(
      res => {
        const trip = res?.Trip;
        if(!trip || res.Error){
          done(null);
          return;
        }

        const newDate = dateEdited ? moment.utc(schedDateVal).format('YYYY-MM-DD') : trip.schedule_date;
        const dateMoves = dateEdited && trip.schedule_date !== newDate;
        const fmt = (d: string) => d ? moment(d, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'no date';
        const tripName = (trip.customer_jobtype || 'Trip') + ' trip (' + fmt(trip.schedule_date) + ')';
        const others = res.OtherMovableTasks || 0;
        const tripIsOpen = ['Scheduled', 'Projected'].includes(trip.job_status);
        const followText = followFields.length === 0 ? '' :
          ' This task\'s new ' + followFields.map(f => f === 'contact' ? 'manager' : 'employee').join(' and ')
          + ' will also be applied to the trip and its open tasks.';

        // Employee/manager-only change on a task whose date is staying put: offer to apply it
        // to the rest of the trip. Nothing moved, so "This task only" leaves it attached.
        if(!dateMoves){
          if(!tripIsOpen || followFields.length === 0){
            done(null);
            return;
          }
          this.dialog.open(WarningPopupComponent, {
            width: '520px',
            data: {
              warning_title: 'This Task Is Part of a Trip',
              warning_description: 'This task belongs to the ' + tripName + '. Apply the new '
                + followFields.map(f => f === 'contact' ? 'manager' : 'employee').join(' and ') + ' to the whole trip?',
              warning_sub: '"Apply to whole trip" updates the trip and its ' + others + ' other open task(s); completed tasks are left alone. '
                + '"This task only" changes just this task and keeps it on the trip. '
                + 'Click outside this box to go back without saving.',
              confirmText: 'Apply to whole trip',
              cancelText: 'This task only',
              showCancelButton: true
            }
          }).afterClosed().subscribe(answer => {
            if(answer === 2){ done('trip', followFields); }
            else if(answer === 1){ done(null); }
            // anything else: back to the dialog, nothing saved
          });
          return;
        }

        this.dialog.open(WarningPopupComponent, {
          width: '520px',
          data: tripIsOpen ? {
            warning_title: 'This Task Is Part of a Trip',
            warning_description: 'This task belongs to the ' + tripName + '. Move the whole trip to ' + fmt(newDate) + '?',
            warning_sub: '"Move whole trip" moves the trip and its ' + others + ' other open task(s); completed tasks keep their dates.' + followText + ' '
              + '"This task only" removes this task from the trip and moves it by itself. '
              + 'Click outside this box to go back without saving.',
            confirmText: 'Move whole trip',
            cancelText: 'This task only',
            showCancelButton: true
          } : {
            warning_title: 'This Task Is Part of a Trip',
            warning_description: 'This task belongs to the ' + tripName + ', which is ' + (trip.job_status || 'not open') + ' and will stay on its date.',
            warning_sub: 'Saving removes this task from that trip and moves it to ' + fmt(newDate) + ' by itself.',
            confirmText: 'Move this task',
            cancelText: 'Go back',
            showCancelButton: true
          }
        }).afterClosed().subscribe(answer => {
          if(tripIsOpen && answer === 2){ done('trip', ['schedule_date'].concat(followFields)); }
          else if(tripIsOpen ? answer === 1 : answer === 2){ done('detach'); }
          // anything else: back to the dialog, nothing saved
        });
      },
      // On a lookup failure the task still saves on its own, as before.
      err => done(null)
    );
}

// Warns, never blocks, when the first site-visit job on an ESMF multifamily project is
// scheduled before its sampling application is done. The backend owns every gate.
runSamplingApplicationCheck(proceed: () => void): void {
    const newStatus = (this.form.get('job_status').value || '').toString().toLowerCase();
    const wasScheduled = (this.initialStatus || '').toLowerCase().includes('scheduled');
    const locationId = this.form.get('location_id').value;

    // Only on a transition into Scheduled, and only for jobtypes needing a site visit.
    if(!newStatus.includes('scheduled') || wasScheduled || !this.sitevisitreqd || !locationId){
      this.samplingChecked = true;
      proceed();
      return;
    }

    this.service.checkSamplingApplication(locationId, this.form.get('job_id').value,
                                          this.form.get('customer_job').value).subscribe(
      res => {
        this.samplingChecked = true;
        if(res && !res.Error && res.needsFlag){
          this.log.warn(this.data.usernamee + ' was warned that the sampling application is not complete for job id-' + this.form.get('job_id').value);
          this.dialog.open(WarningPopupComponent, {
            width: '500px',
            data: {
              warning_title: 'Sampling Application Not Complete',
              warning_description: '',
              warning_sub: 'Sampling Application is not complete and must be done before the first inspection. Notify the CT on the project'
                + (res.ctName ? ' (' + res.ctName + ')' : '') + '.',
              confirmText: 'Ok',
              showCancelButton: false
            }
          }).afterClosed().subscribe(() => proceed());
        } else {
          proceed();
        }
      },
      err => {
        this.samplingChecked = true;
        proceed();
      }
    );
}


// Asks the scheduler to confirm the square footage is in job_notes before a Keen / Grand Living
// QI is saved as Scheduled. "Return to form" cancels the save; the next Save click asks again.
runSqftReminderCheck(proceed: () => void): void {
    const customerId = Number(this.selectedJobObj?.customer ?? this.data.job?.customer_id) || 0;
    const customerName = (this.customer_name || this.data.job?.customer_name || '').toLowerCase();
    const isListedCustomer = customerId
      ? SQFT_REMINDER_CUSTOMER_IDS.includes(customerId)
      : (customerName.includes('keen building') || customerName.includes('grand living'));
    const status = (this.form.get('job_status').value || '').toString().toLowerCase();
    const isQI = isQIJob({ customer_jobtype: this.form.get('customer_jobtype').value });

    if(this.isAudit || !isListedCustomer || !isQI || !status.includes('scheduled')){
      this.sqftReminderChecked = true;
      proceed();
      return;
    }

    this.dialog.open(WarningPopupComponent, {
      width: '500px',
      data: {
        warning_title: 'Square Footage Required',
        warning_description: 'Did you input square footage in job notes?',
        warning_sub: 'Keen Building Company and Grand Living Homes QIs need the home\'s SQFT recorded in the job notes.',
        confirmText: 'Yes, continue',
        cancelText: 'Return to form',
        showCancelButton: true
      }
    }).afterClosed().subscribe(answer => {
      if(answer === 2){
        this.log.warn(this.data.usernamee + ' confirmed SQFT is in the job notes for job_id ' + this.form.get('job_id').value);
        this.sqftReminderChecked = true;
        proceed();
      }
    });
}



async onPhotoSelected(event: Event): Promise<void> {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  this.messager.openSnackBar('Uploading photo...', '', 'successAlert');
  if (file) {
    this.newPhoto = file;

    try {
      // Automatically upload the file and get the URL from AWS
      const awsLink = await this.awsPhotoUpload(this.newPhoto);
      // Set previewUrl to the AWS URL after successful upload
      this.previewUrl = awsLink;

      //console.log("File uploaded successfully:", awsLink);
    } catch (error) {
      console.error("Error uploading photo:", error);
    }
  } else {
    console.warn("No file selected.");
  }
}

async addPhoto(): Promise<void> {
  //console.log(this.newPhoto);
  //console.log(this.form.get('newCaption').value);
  if (this.newPhoto && this.form.get('newCaption').value) {
   // const awsLink = await this.awsPhotoUpload(this.newPhoto);
    this.photoTable.push({ photo: this.previewUrl, caption: this.form.get('newCaption').value });
    this.dataSource.data = [...this.photoTable];
    this.form.get('newCaption').setValue(''); // Reset caption
    //console.log(this.photoTable);
    this.newPhoto = null; // Reset photo
    this.previewUrl = null; // Reset preview
  } else {
    alert("Please select a photo and add a caption.");
  }
}


async awsPhotoUpload(photo: File): Promise<string> {
  const name = `photo_${Date.now()}`; // Generate a unique name
  return new Promise((resolve, reject) => {
    this.service.uploadAuditPhoto(photo, name).subscribe({
      next: (response: any) => {
        if (!response.Error) {
          resolve(response.Photolink);
        } else {
          reject("Error uploading photo.");
        }
      },
      error: (error) => {
        reject(error);
      }
    });
  });
}


  save(): void {

    // Before saving, warn the scheduler if the job lands on a blackout date and
    // let them choose to schedule it anyway (bypassing the relocation rule).
    // Only do this when the schedule date actually changed in this edit. Editing
    // other fields on a job already sitting on a blackout date (e.g. a rater
    // changing only the technician) should not re-trigger the warning, and the
    // backend must leave the existing date in place — so we flag overrideBlackout
    // to skip relocation when the date was untouched.
    if(!this.blackoutChecked){
      if(this.schedDateChanged){
        this.runBlackoutCheck(() => this.save());
        return;
      }
      this.blackoutChecked = true;
      this.overrideBlackout = true;
    }

    if(!this.samplingChecked){
      this.runSamplingApplicationCheck(() => this.save());
      return;
    }

    if(!this.tripMoveChecked){
      this.runTripTaskMoveCheck(() => this.save());
      return;
    }

    if(!this.sqftReminderChecked){
      this.runSqftReminderCheck(() => this.save());
      return;
    }

    const cjt = this.form.get('customer_jobtype').value.toLowerCase();
    let customer_name;
    const isSchedule = this.fromPage.toLowerCase().includes('schedule')

    //create generator job for VCB subs
    if(this.subdivision_id == 4540 || this.subdivision_id == 4796){
        this.service.createGeneratorJob(this.data.location.location_id,
          this.form.get('technitian').value).subscribe();
    }

    this.fredAslaghiarRequest();
    if(!isSchedule){
      customer_name = this.customer_name;
      console.log(customer_name)

      if(this.subdivision_obj?.bldr_region?.toLowerCase().includes('west')
        && customer_name.includes('true')
        && (cjt.includes('pdwi'))){
          this.trueCharlotteWestFunction();
        }

    }else{
      customer_name = this.subdivision_obj?.customer_name?.toLowerCase();
    }


    if(this.form.get('job_status').value.toLowerCase().includes('cancel')){
      this.service.updateCancelledStatus(this.data.job.job_id).subscribe(
        res => {
          this.messager.openSnackBar(res.Message, '', 'successAlert');
        }, err => {
        });
    }

    if(this.statusDirty){
      this.sendEmailsForStatusChange();
      this.form.get('email_sent').setValue(false);

      // 'manual' jobs (HVAC Design - Existing Customers) bump schedule_date on status change like
      // compliance, but their modeler due date is fixed at creation (schedule date + 3 business days)
      // and must NOT be recomputed/wiped on a PendInfo<->Scheduled transition.
      // The MF model-update/prelim jobtypes are exempt for a different reason: they get
      // compliance statuses but are explicitly not compliance work for due-date purposes,
      // so they must not pick up the backend's default 7bd flex / 3bd modeler dates.
      const isDueDateExemptJobType = this.isDueDateExempt(this.form.get('customer_jobtype').value);

      if(this.initialStatus.toLowerCase().includes('pendinfo')){

        if(this.form.get('job_status').value.toLowerCase().includes('scheduled') && !isDueDateExemptJobType){
          this.service.updateDueDateCompliance(
            this.data.job.job_id,
            this.complianceCustomerId != null ? this.complianceCustomerId : this.data.job.customer_id,
            this.form.get('schedule_date').value,
            this.form.get('customer_jobtype').value,
            ).subscribe(
            )
        }

      }else if(this.initialStatus.toLowerCase().includes('scheduled')){
        if(this.form.get('job_status').value.toLowerCase().includes('pendinfo') && !isDueDateExemptJobType){
          this.service.resetDueDateCompliance(this.data.job.job_id).subscribe(
          );
        }
      }

      

    }

    const formattedDatepd = moment.utc(this.form.get('schedule_date').value).format('MM/DD/YYYY');
    this.form.get('schedule_date').setValue(formattedDatepd);

    if(this.isAudit){

      var auditObj = {
        auditorname: this.form.get('auditorname').value,
        audtype: this.form.get('audtype').value,
        audnotes: this.form.get('audnotes').value,
        ovlscore: this.form.get('ovlscore').value,
        audinspdate: this.form.get('audinspdate').value,
        audreported: this.form.get('audreported').value,
        constage: this.form.get('constage').value,
        region: this.form.get('region').value,
        nrgprogram: this.form.get('nrgprogram').value,
        additionalpics : this.savePhotos()
      }

      this.saveAllAudits(this.data.job.job_id, this.auditID);

      this.form.get('schedule_date').setValue(this.form.get('audinspdate').value);
      this.service.saveAudit(this.data.job.job_id, auditObj).subscribe(
        res => {
          this.messager.openSnackBar('Audit saved!', '', 'successAlert');
        }
      )

      switch(this.form.get('auditorname').value.trim().toLowerCase()){

        case 'jeremy price':
          this.form.get('technitian').setValue(6);
          break;
        case 'david bess':
          this.form.get('technitian').setValue(39);
          break;
        case 'hunter cook':
          this.form.get('technitian').setValue(78);
          break;
        case 'jacob buckner':
          this.form.get('technitian').setValue(188);
          break;
        case 'diana gochez':
          this.form.get('technitian').setValue(261);
          break;
        case 'elena arana':
          this.form.get('technitian').setValue(260);
          break;
        case 'john buono':
          this.form.get('technitian').setValue(85);
          break;
        case 'zach sumner':
          this.form.get('technitian').setValue(97);
          break;
        case 'jim forgays':
          this.form.get('technitian').setValue(95);
          break;
        case 'neyle steadman':
          this.form.get('technitian').setValue(115);
          break;
        case 'greg hite':
          this.form.get('technitian').setValue(140);
          break;
        case 'monte mickys':
          this.form.get('technitian').setValue(152);
          break;
        case 'gary vyner':
          this.form.get('technitian').setValue(309);
          break;
        case 'beth ainsworth':
          this.form.get('technitian').setValue(3);
          break;
        case 'misty kilgore':
          this.form.get('technitian').setValue(128);
          break;
        case 'dylan moles':
          this.form.get('technitian').setValue(202);
          break;
        case 'tim jarnigan':
          this.form.get('technitian').setValue(160);
          break;
        case 'woody woodward':
          this.form.get('technitian').setValue(219);
          break;
        default:
          this.form.get('technitian').setValue(0);
          break;
      }
    }

    const tagIds = this.inputTags.map(tag => tag.id);
    this.form.get('tagControl').setValue(tagIds);

    if(tagIds.includes(12)){
          if(!cjt.includes('hers+hero')){
            //remove the tag from the list
            const index = this.inputTags.findIndex(tag => tag.id == 12);
            this.inputTags.splice(index, 1);
            this.form.get('tagControl').setValue(this.inputTags.map(tag => tag.id));
          }
    }


    //ATTIC TENT REQUIRED TAG CHECK
    if(tagIds.includes(7)){

      //look for all permutations of 'attic tent required'
      if(
        !this.form.get('job_notes').value.toLowerCase().includes('attic tent required.') &&
        !this.form.get('job_notes').value.toLowerCase().includes('attic tent') &&
        !this.form.get('job_notes').value.toLowerCase().includes('tent required') &&
        !this.form.get('job_notes').value.toLowerCase().includes('install tent')
        ){
        this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n ATTIC TENT REQUIRED.');
      }
    }

    if(tagIds.includes(24)){
      this.form.get('invoice_number').setValue('1');
      this.form.get('po_number').setValue('1');
    }

    if(tagIds.includes(34)){
      this.form.get('job_notes').setValue(this.form.get('job_notes').value + '\n' + 'EACH UNIT NEEDS A STICKER.');
    }

    //DO NOT PUSH JOB TAG CHECK (tag id 57) — must be completed today
    if(tagIds.includes(57)){
      if(!(this.form.get('job_notes').value || '').toLowerCase().includes('do not push job')){
        this.form.get('job_notes').setValue((this.form.get('job_notes').value || '') + '\n' + 'Do not push job, must be completed today.');
      }
    }

    this.processTags();
    //if status is set to Fail RIS, we'll need to reset thermal required for location to false
    if(this.form.get('job_status').value == 'Fail-RIS'){
      this.service.resetThermalRequired(this.data.job.location_id).subscribe();
    }


    let updateDueDate = false;
    let jobObj = this.form.value;

    // customer_job is disabled while editing a trip (its Trips-tab primary-job logic owns it),
    // and Angular's FormGroup.value silently omits disabled controls — so without this, saving
    // ANY edit to an existing trip would send customer_job as undefined, which the backend
    // writes as NULL, breaking the trip out of the office schedule view's join on custmrjobs.
    if (this.form.get('customer_job').disabled) {
      jobObj = { ...jobObj, customer_job: this.form.get('customer_job').value };
    }

    if( this.mode == EDITING_MODE && this.form.get('customer_job').dirty ){
      this.form.get('flex_start_date').markAsDirty();
      updateDueDate = true;
      jobObj = {
        ...this.form.value,
        flex_start_date: this.form.get('flex_start_date').value
      }
    }

    // Also update due date if a manual jobtype user edited it directly
    if( this.isManualJobtype && this.form.get('flex_start_date').dirty ){
      updateDueDate = true;
      jobObj = {
        ...jobObj,
        flex_start_date: this.form.get('flex_start_date').value
      }
    }

    // Pass the scheduler's blackout-date decision through to the backend so it
    // knows whether to keep the date as-is or relocate it per the rule.
    jobObj = { ...jobObj, overrideBlackout: this.overrideBlackout };

    console.log('NEW TAGS', this.newTags );
    this.service.saveJobEdit(this.data.job.job_id,jobObj,updateDueDate, this.newTags).subscribe(
      async res => {

        let changedProperties = [];
        Object.keys(this.form.controls).forEach((name) => {
            const currentControl = this.form.controls[name];

            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.form.controls[name].value);
            }
          });

          if(this.track_id > 0 && (cjt.includes('pdwi') ||  cjt.includes('slab') ||  cjt.includes('as')) && !cjt.includes('re') && 
        this.track_id != 31 ){
            if(this.employee_name.toLowerCase().includes('unassigned')){
              this.updateTech = 1;
            }
            this.service.updateOtherTrackJobs(this.form.value, this.form.get('location_id').value,this.updateTech).subscribe(
              res => {
                //console.log(res);
              }, err => {
                //console.log(err);
              });
          }


          if(this.schedDateChanged == true){

            if(this.customer_name?.toLowerCase().includes('beechwood') && this.track_id > 0
              && !cjt.includes('rescheck')
              && !cjt.includes('re')
              && !cjt.includes('performance')
              && (this.form.get('job_status').value.toLowerCase().includes('scheduled') || this.form.get('job_status').value.toLowerCase().includes('projected'))
            ){
              //console.log('BEECH WOOD');
              this.service.updateTrackJobDatesBeechwood(this.form.get('job_id').value, this.form.get('location_id').value).subscribe(
                res => {
                  //console.log(res);
                }
              )
            } else if(this.track_id > 0 && cjt.includes('pdwi') && !cjt.includes('re') ){
              //console.log('updating track job dates');
                this.service.updateTrackJobDates(this.track_id, this.form.get('job_id').value, this.form.get('location_id').value).subscribe(
                  res => {
                    //console.log(res);
                  }
                )
            }
          }


        if(res.Error){

           let errMessage = res.Message;

          this.messager.openSnackBar('Error saving job, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.form.value,'Jobs via Locations', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for locations page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the jobs (locations) page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            })


          this.log.error(this.data.usernamee + ' encountered an error editing a job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + res.Message );
        }else {


          this.log.info(this.data.usernamee + ' saved the following edits to the ' + this.data.job.customer_jobtype + '@ '+ this.data.job.street_address + ' with id: ' + this.data.job.job_id + (this.form.get('istrip').value === true ? ' (TRIP)' : '') + ' {' + changedProperties.toString() + '}' + 'with location_id: ' + this.data.job.location_id  );
        }

        // Cascade the trip's own status/technician/schedule-date changes to every child job.
        // Wired up from every edit-job surface via enableTripFieldCascade (locations page, truck
        // view, schedule page) — not TripStatusDialogComponent, which already lets each child's
        // status be set independently. propagateTripFields()
        // reads the values server-side off the trip's own (now-saved) row, so this can't push a
        // stale schedule_date if editJob just relocated it off a blackout date. Server-side it
        // also narrows job_status specifically to "trip -> Scheduled/Projected, child currently
        // Scheduled/Projected" — technitian stays unconditional; schedule_date and contact skip
        // completed children.
        if (!res.Error && this.data.enableTripFieldCascade && this.form.get('istrip').value === true) {
          const cascadeFields: string[] = [];
          if (this.statusDirty) { cascadeFields.push('job_status'); }
          if (this.technitianChanged) { cascadeFields.push('technitian'); }
          if (this.schedDateChanged) { cascadeFields.push('schedule_date'); }
          if (this.tripFollowFields().includes('contact')) { cascadeFields.push('contact'); }
          if (cascadeFields.length > 0) {
            this.service.propagateTripFields(this.data.job.job_id, cascadeFields).subscribe(
              (propRes: any) => {
                if (!propRes?.Error && cascadeFields.includes('job_status') && (propRes?.StatusTasks ?? 0) > 0) {
                  const newStatus = (this.form.get('job_status').value || '').toString().trim();
                  this.messager.openSnackBar(propRes.StatusTasks + ' task(s) on this trip set to ' + newStatus + '.', '', 'successAlert');
                  this.log.info(this.data.usernamee + ' set ' + propRes.StatusTasks + ' task(s) on the TRIP with id: ' + this.data.job.job_id
                    + ' to ' + newStatus + ' with location_id: ' + this.data.job.location_id);
                }
                if (!propRes?.Error && cascadeFields.includes('schedule_date')) {
                  this.log.info(this.data.usernamee + ' moved ' + (propRes?.MovedTasks ?? 0) + ' task(s) with the TRIP with id: ' + this.data.job.job_id
                    + ' to ' + moment(this.form.get('schedule_date').value).format('M/D/YYYY') + ' with location_id: ' + this.data.job.location_id);
                }
              },
              () => { this.messager.openSnackBar('Error updating this trip\'s tasks to match.', '', 'errorAlert'); }
            );
          }
        }

        // A trip TASK's date/employee/manager changed: apply the scheduler's answer from
        // runTripTaskMoveCheck(). Awaited so the jobs list re-fetched after this dialog
        // closes already shows the moved trip / the detached task.
        if (!res.Error && this.tripMoveChoice) {
          try {
            const followFields = this.tripMoveFields;
            const moveRes = await this.service.resolveTripTaskMove(this.data.job.job_id, this.tripMoveChoice, followFields).toPromise();
            if (moveRes?.Error) {
              this.messager.openSnackBar('Task saved, but the trip was not updated: ' + moveRes.Message, '[close]', 'errorAlert');
            } else {
              const followed: string[] = [];
              if (followFields.includes('schedule_date')) { followed.push('date'); }
              if (followFields.includes('technitian')) { followed.push('employee: ' + (this.data.job.employee_name || '')); }
              if (followFields.includes('contact')) { followed.push('manager: ' + (this.data.job.name || '')); }
              this.log.info(this.data.usernamee + (this.tripMoveChoice === 'trip' ? ' updated the whole trip (' + followed.join(', ') + ') to match' : ' removed from its trip')
                + ' task id: ' + this.data.job.job_id + ' (trip id: ' + moveRes?.TripId + ') with location_id: ' + this.data.job.location_id);
            }
          } catch (e) {
            this.messager.openSnackBar('Task saved, but there was an error updating its trip.', '[close]', 'errorAlert');
          }
        }

        if (!res.Error && this.convertToTrip) {
          if (!(await this.finishConvertToTrip())) { return; }
        } else if (!res.Error && this.isEditTrip) {
          await this.persistTripTaskChanges();
          await this.persistTripTaskNotes();
        }

        this.data.currForm = this.form.value;
        this.data.job.job_status = this.form.get('job_status').value;
        this.data.job.po_number = this.form.get('po_number').value;
        this.data.job.invoice_number = this.form.get('invoice_number').value;
        this.data.job.job_notes = this.form.get('job_notes').value;
        this.data.job.billing_note = this.form.get('billing_note').value;
        if (this.isEditTrip) {
          // Same shape as the schedule queries' trip_task_notes, so the card updates without a refetch.
          this.data.job.trip_task_notes = this.selectedJobs
            .filter(j => (j.job_notes || '').trim())
            .map(j => ({ job_id: j.job_id, jobtype: (j.customer_jobtype || '').trim(), job_notes: j.job_notes.trim() }));
        }
        this.data.tripModeUsed = this.tripMode;

        this.dialogRef.close(this.data);


        //check for esmfnc in the customer_jobtype
        if(this.data.job.customer_jobtype.trim().toLowerCase().includes('esmf')
        || this.data.job.customer_jobtype.trim().toLowerCase().includes('mfes')){
          this.service.updateESMFNC(this.data.location.location_id).subscribe(
            res => {
              this.service.insertESMFNC(this.data.location.location_id).subscribe(
                res => {
                  this.messager.openSnackBar('ESMFNC Checklist added.', '', 'successAlert');
                });
              this.messager.openSnackBar('ESMFNC Checklist added.', '', 'successAlert');
            }, err => {
              this.messager.openSnackBar('Error adding ESMFNC Checklist (edit location flags if needed).', '', 'successAlert');
            })
        }

        if(!this.data.isAudit){
          this.dialogRef.close(this.data);
        }
      },
      err => {
        this.log.error(this.data.usernamee + ' encountered an error editing a job: Submitted data: ' + '{' + this.form.value.toString() + '} ' + err.toString() );
      }
    );

    //update confirmation status if schedule date changed.
    if(this.schedDateChanged) {
      this.schedService.updateConfStatus(this.data.job.job_id, '').subscribe(
        res => {
          //
          //if there's a track ID
          this.messager.openSnackBar('Saved. Confirmation status reset.', '', 'successAlert');
        }, err => {
          //this.messager.openSnackBar('Error resetting conf status.', '', 'errorAlert');
        }
      )
    }

  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.visibleTags?.filter(tag => tag.displayname.toLowerCase().includes(filterValue));
  }

  onEnter(auto: MatAutocomplete): void {
      this.form.get('tagControl').setValue('');
  }

  inspectionDateChange(): void {
    this.form.get('schedule_date').setValue(this.form.get('audinspdate').value);
  }

  sendEmailsForStatusChange(): void {

      let jobTypeValue = this.form.get('customer_jobtype').value || '';

      let isCustom = jobTypeValue.toLowerCase().includes('cust');
      let isProd = jobTypeValue.toLowerCase().includes('prod');

      let customer_name = this.customer_name.toLowerCase();

      //Beth wants to receive emails for the following statuses:
      let bethStatuses = ['underrev', 'fail-nr', 'fail', 'pass', 'complete'];

      let job_status = this.form.get('job_status').value.toLowerCase();
      let reviewer = '';

      let emailInfo = {
        ...this.data.job,
        customer_name : this.data.job.customer_name || this.customer_name || '',
        customer_jobtype : jobTypeValue,
        subdivision_name : this.data.location.subdivision_name,
        lot : this.data.location.lot,
        street_address : this.data.job.street_address || this.data.location.street_address,
      }

      emailInfo.job_status = job_status;

      if(isProd && job_status.includes('underrev') && !customer_name.toLowerCase().includes('beechwood')){

        this.schedService.sendReviewEmail(emailInfo, 2).subscribe(
          (res) => {
                      if(res.Error){
                      this.messager.openSnackBar('An error occurred sending review email. ', '', 'errorAlert');
                      }else {
                        this.messager.openSnackBar('Production Review email sent', '', 'successAlert');
                      }
          }, err => {
                      this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
          });
      }

      if(isCustom &&
        !customer_name.includes('schell brothers-nashville') &&
        bethStatuses.includes(job_status) &&
        !jobTypeValue.toLowerCase().includes('resch') &&
        !jobTypeValue.toLowerCase().includes('report'))
      {

            this.schedService.getReviewers(this.data.job.job_id).subscribe(
            res => {
              reviewer = (res.Reviewer || '') + ',beth@theperformancepoint.com,jonb@theperformancepoint.com';
              emailInfo.reviewer = reviewer;
              this.schedService.sendReviewEmail(emailInfo, 1).subscribe(
                (res) => {
                    if(res.error){
                    this.messager.openSnackBar('An error occurred sending review email. ', '', 'errorAlert');
                    }else {
                      this.messager.openSnackBar('Custom Review email sent', '', 'successAlert');
                    }
                }, err => {
                    this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
                });
            });
      }

      // Notify the subdivision consultant on any non-Scheduled status change
      // for _MF jobs. GPS customers excluded.
      const isMF = jobTypeValue.toLowerCase().includes('_mf');
      const isGPS = customer_name.includes('gps');

      if(isMF && !isGPS && !job_status.includes('scheduled')){
        const mfEmailInfo = { ...emailInfo, job_status: (this.form.get('job_status').value || '').trim() };
        this.schedService.sendReviewEmail(mfEmailInfo, 4).subscribe(
          (res) => {
            if(res.Skipped){
              this.messager.openSnackBar('No consultant set on this subdivision - consultant email not sent.', '', 'warningAlert');
            }else if(res.Error){
              this.messager.openSnackBar('An error occurred sending the MF consultant email.', '', 'errorAlert');
            }else {
              this.messager.openSnackBar('MF consultant email sent', '', 'successAlert');
            }
          }, err => {
            this.messager.openSnackBar('Error sending MF consultant email', '', 'errorAlert');
          });
      }

  }

  add(doSendAuditEmail: boolean = false): void {

    // Before adding, warn the scheduler if the job lands on a blackout date and
    // let them choose to schedule it anyway (bypassing the relocation rule).
    if(!this.blackoutChecked){
      this.runBlackoutCheck(() => this.add(doSendAuditEmail));
      return;
    }

    if(!this.samplingChecked){
      this.runSamplingApplicationCheck(() => this.add(doSendAuditEmail));
      return;
    }

    if(!this.sqftReminderChecked){
      this.runSqftReminderCheck(() => this.add(doSendAuditEmail));
      return;
    }

    // The note helpers below call .includes()/concatenate on job_notes; a null would throw
    // and abort the add, or save the literal "null".
    if(this.form.get('job_notes').value == null){
      this.form.get('job_notes').setValue('');
    }

    const tagIds = this.inputTags.map(tag => tag.id);
    const cjt = this.form.get('customer_jobtype').value.toLowerCase();
    const pattern = /es.*mf/;
    const matches = pattern.test(cjt);
    const VCB_SUBDIVISIONS = [4540, 4796];

    this.form.get('tagControl').setValue(tagIds);

    if(tagIds.includes(12)){
        if(!this.form.get('customer_jobtype').value.trim().toLowerCase().includes('hers+hero')){
          const index = this.inputTags.findIndex(tag => tag.id == 12);
          this.inputTags.splice(index, 1);
          this.form.get('tagControl').setValue(this.inputTags.map(tag => tag.id));
        }
    }

    let subdivision_id = this.data.location.subdivision;

    if(tagIds.includes(24)){
      this.form.get('invoice_number').setValue('1');
      this.form.get('po_number').setValue('1');
    }

    this.processTags();
    this.notesRequests(cjt, subdivision_id, tagIds);
    this.fredAslaghiarRequest();


    if(cjt.trim().toLowerCase().includes('esmf')
        || cjt.trim().toLowerCase().includes('mfes')){
      'Updating ESMFNC...';
      this.service.updateESMFNC(this.data.location.location_id).subscribe(
        res => {
          this.messager.openSnackBar('ESMFNC Checklist added.', '', 'successAlert');
        }, err => {
          this.messager.openSnackBar('Error adding ESMFNC Checklist (edit location flags if needed).', '', 'successAlert');
        })
    }

    //if(!cjt.includes('mf')){
      //const index = this.inputTags.findIndex(tag => tag.id == 12);
      //this.inputTags.splice(index, 1);
      //this.form.get('tagControl').setValue(this.inputTags.map(tag => tag.id));
    //}

    if(this.subdivision_obj?.bldr_region?.toLowerCase().includes('west')
      && this.customer_name?.toLowerCase().includes('true')
      && (cjt.includes('pdwi'))){
        this.trueCharlotteWestFunction();
    }

    //create generator for VCB subs
    if(VCB_SUBDIVISIONS.includes(this.subdivision_id)){
        this.service.createGeneratorJob(this.data.location.location_id,
          this.form.get('technitian').value).subscribe()
    }

    if(!this.form.get('schedule_date').value && !this.data.isAudit){
      this.messager.openSnackBar('Please input a schedule date (or an audit date)!', '[close]', 'errorAlert');
      this.longRippleError(this.scheduledateRipple);
    }else if(!this.form.get('audinspdate').value && this.data.isAudit){
      this.messager.openSnackBar('Please input an audit date!', '[close]', 'errorAlert');

    }else if((!this.form.get('estimatedtime').value || this.form.get('estimatedtime').value == 0) &&
    this.sitevisitreqd == true  ){
      this.messager.openSnackBar('Please input an estimated time for site visit required jobs!', '[close]', 'errorAlert');
      this.longRippleError(this.estimatedtimeRipple);
    }
     else {

      if(this.data.isAudit){
        //set Schedule date = current date
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();

        var todayDate = yyyy + '-' + mm + '-' + dd;
        this.form.get('schedule_date').setValue(this.form.get('audinspdate').value);
        this.form.get('isaudit').setValue(true);
        switch(this.form.get('auditorname').value.trim().toLowerCase()){
        case 'jeremy price':
          this.form.get('technitian').setValue(6);
          break;
        case 'david bess':
          this.form.get('technitian').setValue(39);
          break;
        case 'hunter cook':
          this.form.get('technitian').setValue(78);
          break;
        case 'jacob buckner':
          this.form.get('technitian').setValue(188);
          break;
        case 'diana gochez':
          this.form.get('technitian').setValue(261);
          break;
        case 'elena arana':
          this.form.get('technitian').setValue(260);
          break;
        case 'john buono':
          this.form.get('technitian').setValue(85);
          break;
        case 'zach sumner':
          this.form.get('technitian').setValue(97);
          break;
        case 'jim forgays':
          this.form.get('technitian').setValue(95);
          break;
        case 'neyle steadman':
          this.form.get('technitian').setValue(115);
          break;
        case 'greg hite':
          this.form.get('technitian').setValue(140);
          break;
        case 'monte mickys':
          this.form.get('technitian').setValue(152);
          break;
        case 'gary vyner':
          this.form.get('technitian').setValue(309);
          break;
        case 'beth ainsworth':
          this.form.get('technitian').setValue(3);
          break;
        case 'misty kilgore':
          this.form.get('technitian').setValue(128);
          break;
        case 'dylan moles':
          this.form.get('technitian').setValue(202);
          break;
        case 'tim jarnigan':
          this.form.get('technitian').setValue(160);
          break;
        case 'woody woodward':
          this.form.get('technitian').setValue(219);
          break;
        default:
          this.form.get('technitian').setValue(0);
          break;
        }
      }

      //make sure due date is not 1970
      let flexVal = this.form.get('flex_start_date').value;
      if(flexVal && new Date(flexVal).getFullYear() == 1970){
        this.setDueDate();
      }
      this.updateNotes();
      // PendPaym never carries a due date. getRawValue() includes the DISABLED
      // flex_start_date/modeler_duedate controls that setDueDate() stamps from the
      // jobtype (it never checks status), so strip them here. This is the single
      // choke point every added job passes through, and it's order-proof — the
      // user can select PendPaym and then change the jobtype or date, which
      // re-runs setDueDate() and re-stamps both controls.
      const addPayload: any = { ...this.form.getRawValue(), overrideBlackout: this.overrideBlackout };
      if((addPayload.job_status || '').toLowerCase().includes('pendpaym')){
        addPayload.flex_start_date = null;
        addPayload.modeler_duedate = null;
      }

      this.service.addJob(addPayload, this.newTags).subscribe(
      (res) => {

      if(res.Error){
          let errMessage = res.Message;
          this.messager.openSnackBar('Error saving job, an email with all data has been sent to support.', '[close]', 'errorAlert');
          this.ges.sendDebugEmail('IMPORTANT', this.form.value,'Jobs via Locations', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for jobs/locations page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the jobs (locations) page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            });
        this.log.error(this.data.usernamee + ' attempted to add a job but encountered an error, submitted data:  ' + this.form.value.toString() +  ' - Error:- ' + res.Message);
      }else {

            this.data.job.job_id = res.id;
            var local_job_id = res.id; //just for local use

            //add esmfnc if needed
            if(this.data.job.customer_jobtype.trim().toLowerCase().includes('esmfnc')){
              this.service.updateESMFNC(this.data.location.location_id).subscribe(
                res => {
                  this.service.insertESMFNC(this.data.location.location_id).subscribe(
                    res => {
                      this.messager.openSnackBar('ESMFNC Checklist added.', '', 'successAlert');
                    });
                  this.messager.openSnackBar('ESMFNC Checklist added.', '', 'successAlert');
                }, err => {
                  this.messager.openSnackBar('Error adding ESMFNC Checklist (edit location flags if needed).', '', 'successAlert');
                })
            }
            //now save the audit job if it's an audit job.
            if(this.data.isAudit){

              var auditObj = {
                job_id: this.data.job.job_id,
                auditorname: this.form.get('auditorname').value,
                audtype: this.form.get('audtype').value,
                audnotes: this.form.get('audnotes').value,
                ovlscore: this.form.get('ovlscore').value,
                audinspdate: this.form.get('audinspdate').value,
                audreported: this.form.get('audreported').value,
                constage: this.form.get('constage').value,
                region: this.form.get('region').value,
                nrgprogram: this.form.get('nrgprogram').value,
                additionalpics : this.savePhotos()
              }


              this.service.addAudit(auditObj).subscribe(
                res => {

                  this.saveAllAudits(local_job_id, res.AuditID);

                  this.messager.openSnackBar('Audit saved!', '', 'successAlert');
                  if(doSendAuditEmail == true){
                      this.service.sendAuditEmail(this.data.location.location_id, this.data.job.job_id).subscribe(
                        res => {
                          this.messager.openSnackBar('Audit email sent!', '', 'successAlert');
                        }, err => {
                          this.messager.openSnackBar('Error, Audit email not sent', '', 'errorAlert');
                        });
                  }
                }
              )
            }

            this.data.job.job_status = this.form.get('job_status').value;
            this.data.job.po_number = this.form.get('po_number').value;
            this.data.job.invoice_number = this.form.get('invoice_number').value;
            this.data.job.job_notes = this.form.get('job_notes').value;
            this.data.job.billing_note = this.form.get('billing_note').value;
            this.data.tripModeUsed = this.tripMode;

        try{
          this.log.info(this.data.usernamee + ' put a ' + this.data.job.customer_name + '-' + this.form.value.customer_jobtype.trim() + ' on for ' + moment(this.form.value.schedule_date).format('M/D/YYYY') +  ' job_id: ' + res.id );
        }catch(error){
          //never let a formatting error swallow the "who added this job" log entry
          this.log.info(this.data.usernamee + ' put a ' + this.data.job.customer_name + ' job on job_id: ' + res.id );
        }

            //update trip jobs - wait for completion before closing so child jobs have trip_id set
            // Filter out carryover job IDs - they'll be copied via carryOverTripJobs endpoint
            const manuallySelectedIds = this.selectedJobIds.filter(id => !this.carryOverJobIds.includes(id));
            if(manuallySelectedIds.length > 0){
              this.service.updateTripJobs(manuallySelectedIds, local_job_id).subscribe(
                () => {
                  // After linking manually selected jobs, carry over incomplete jobs from previous trip
                  if (this.carryOverJobs.length > 0 && this.previousTripId) {
                    const failCarryOvers = this.carryOverJobs.filter(j => ['fail', 'fail-nr', 'fail-epo', 'fail-ris'].includes((j.job_status || '').trim().toLowerCase()));
                    if (failCarryOvers.length > 0) {
                      this.snackbar.open('Creating re-inspection job(s)...', '', { duration: 4000 });
                    }
                    this.service.carryOverTripJobs(this.previousTripId, local_job_id).subscribe(
                      (carryRes) => {
                        if (!carryRes.Error && carryRes.Jobs?.length > 0) {
                          this.snackbar.open('Carried over ' + carryRes.Jobs.length + ' job(s) from previous trip', '', { duration: 3000, panelClass: 'successAlert' });
                        }
                        if (carryRes.MissingReJobs?.length > 0) {
                          const missingList = carryRes.MissingReJobs.map(j => '• ' + j.re_job_type).join('\n');
                          this.dialog.open(WarningPopupComponent, {
                            width: '480px',
                            data: {
                              warning_title: 'Re-Inspection Jobs Not Found',
                              warning_description: 'The following Re-inspection job types were not found in the system. Those jobs were carried over with their original type:\n\n' + missingList,
                              warning_sub: '',
                              confirmText: 'OK',
                              showCancelButton: false
                            }
                          });
                        }
                        this.dialogRef.close(this.data);
                      },
                      err => {
                        this.messager.openSnackBar('Error carrying over trip jobs.', '', 'errorAlert');
                        this.dialogRef.close(this.data);
                      }
                    );
                  } else {
                    this.dialogRef.close(this.data);
                  }
                },
                err => {
                  this.messager.openSnackBar('Error linking trip jobs.', '', 'errorAlert');
                  this.dialogRef.close(this.data);
                }
              );
            } else if (this.carryOverJobs.length > 0 && this.previousTripId) {
              // No manually selected jobs, but carry over from previous trip
              console.log(this.carryOverJobs);
              const failCarryOvers = this.carryOverJobs.filter(j => ['fail', 'fail-nr', 'fail-epo', 'fail-ris'].includes((j.job_status || '').trim().toLowerCase()));
              if (failCarryOvers.length > 0) {
                this.snackbar.open('Creating re-inspection job(s)...', '', { duration: 4000 });
              }
              this.service.carryOverTripJobs(this.previousTripId, local_job_id).subscribe(
                (carryRes) => {
                  if (!carryRes.Error && carryRes.Jobs?.length > 0) {
                    this.snackbar.open('Carried over ' + carryRes.Jobs.length + ' job(s) from previous trip', '', { duration: 3000, panelClass: 'successAlert' });
                  }
                  if (carryRes.MissingReJobs?.length > 0) {
                    const missingList = carryRes.MissingReJobs.map(j => '• ' + j.re_job_type).join('\n');
                    this.dialog.open(WarningPopupComponent, {
                      width: '480px',
                      data: {
                        warning_title: 'Re-Inspection Jobs Not Found',
                        warning_description: 'The following Re-inspection job types were not found in the system. Those jobs were carried over with their original type:\n\n' + missingList,
                        warning_sub: '',
                        confirmText: 'OK',
                        showCancelButton: false
                      }
                    });
                  }
                  this.dialogRef.close(this.data);
                },
                err => {
                  this.messager.openSnackBar('Error carrying over trip jobs.', '', 'errorAlert');
                  this.dialogRef.close(this.data);
                }
              );
            } else {
              this.dialogRef.close(this.data);
            }

      }
        if(res.Error) { this.dialogRef.close(this.data); }
      },
        err => {
        }
      );
    }
  }


  // Edit mode Trip?: the job stays itself and becomes the pinned primary task of a new trip on save.
  async toggleConvertToTrip(){
    this.convertToTrip = !this.convertToTrip;
    this.tripMode = this.convertToTrip;
    this.selectedJobs = [];
    this.selectedJobIds = [];
    this.carryOverJobs = [];
    this.carryOverJobIds = [];
    this.previousTripId = null;
    if (!this.convertToTrip) { this.availableJobs = []; return; }
    const self = this.data.fetchedJob;
    this.selectedJobs = [{
      job_id: self.job_id,
      customer_job: self.customer_job,
      customer_jobtype: self.customer_jobtype,
      customer_name: self.customer_name,
      job_status: self.job_status,
      schedule_date: self.schedule_date,
      estimatedtime: parseFloat(self.estimatedtime) || 0
    }];
    this.selectedJobIds = [self.job_id];
    await this.fetchJobsForTripModeAsync();
    await this.promptCarryOver();
  }

  async promptCarryOver(){
    // Check for previous trips and prompt for carryover
    if (this.data.previousTrips?.length > 0) {
      const sorted = [...this.data.previousTrips].sort((a, b) => {
        return (b.job_id || 0) - (a.job_id || 0);
      });
      this.previousTripId = sorted[0].job_id;

      const warningDialogRef = this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
          warning_title: 'Carry Over Jobs',
          warning_description: 'Carry over incomplete tasks from previous trip?',
          warning_sub: '',
          confirmText: 'Yes',
          cancelText: 'No',
          showCancelButton: true
        }
      });

      const result = await warningDialogRef.afterClosed().toPromise();
      if (result !== 1) {
        // User confirmed - fetch incomplete jobs from previous trip and block until done
        try {
          const res = await this.service.getTripJobs(this.previousTripId).toPromise();
          if (res.Jobs) {
            this.carryOverJobs = res.Jobs.filter(
              j => j.job_status?.trim() !== 'Pass' && j.job_status?.trim() !== 'Complete'
            );
            if (this.carryOverJobs.length > 0) {
              // Immediately add carryover jobs to selected list so they show in UI
              this.carryOverJobs.forEach(job => {
                const mappedJob = {
                  job_id: job.job_id,
                  customer_job: job.customer_job,
                  customer_jobtype: job.customer_jobtype,
                  customer_name: job.customer_name,
                  job_status: job.job_status,
                  schedule_date: job.schedule_date,
                  estimatedtime: parseFloat(job.estimatedtime) || 0,
                  job_notes: (job.job_notes || '').trim()
                };
                this.selectedJobs.push(mappedJob);
                this.selectedJobIds.push(job.job_id);
                this.carryOverJobIds.push(job.job_id); // Track separately
              });
              // Remove from available jobs to avoid duplicates
              this.availableJobs = this.availableJobs.filter(
                aj => !this.selectedJobIds.includes(aj.job_id)
              );
              // Set the trip's customer_jobtype to match the primary (first selected) job
              this.applyPrimaryJobToTrip();
              this.recomputeTripEstimatedTime();
              this.snackbar.open(this.carryOverJobs.length + ' incomplete job(s) added to trip', '', { duration: 3000, panelClass: 'successAlert' });
            } else {
              this.snackbar.open('No incomplete jobs found on previous trip', '', { duration: 3000 });
            }
          }
        } catch (err) {
          this.snackbar.open('Error loading previous trip jobs', '', { duration: 3000, panelClass: 'errorAlert' });
        }
      } else {
        // User declined carryover
        this.carryOverJobs = [];
        this.carryOverJobIds = [];
        this.previousTripId = null;
      }
    }
  }

  // After the job's own edits saved: new parent + selected tasks in one call, then carry-over.
  async finishConvertToTrip(): Promise<boolean> {
    const jobId = this.data.job.job_id;
    const taskIds = this.selectedJobIds.filter(id => id !== jobId && !this.carryOverJobIds.includes(id));
    let tripId: number;
    try {
      const r: any = await this.service.convertJobToTrip(jobId, taskIds).toPromise();
      if (r?.Error) { throw new Error(r.Message); }
      tripId = r.TripId;
    } catch (e) {
      this.messager.openSnackBar('Job saved, but the trip was not created: ' + (e?.message || ''), '[close]', 'errorAlert');
      this.toggleConvertToTrip();
      return false;
    }
    this.log.info(this.data.usernamee + ' turned job id: ' + jobId + ' into a new TRIP (trip id: ' + tripId + ') with ' + taskIds.length + ' other task(s) ' + (taskIds.length ? '[' + taskIds + '] ' : '') + 'with location_id: ' + this.data.job.location_id);
    this.messager.openSnackBar('Trip created with ' + (taskIds.length + 1) + ' task(s)', '', 'successAlert');
    if (this.carryOverJobs.length > 0 && this.previousTripId) { await this.runCarryOver(tripId); }
    return true;
  }

  async runCarryOver(tripId: number): Promise<void> {
    const failCarryOvers = this.carryOverJobs.filter(j => ['fail', 'fail-nr', 'fail-epo', 'fail-ris'].includes((j.job_status || '').trim().toLowerCase()));
    if (failCarryOvers.length > 0) { this.snackbar.open('Creating re-inspection job(s)...', '', { duration: 4000 }); }
    try {
      const carryRes: any = await this.service.carryOverTripJobs(this.previousTripId, tripId).toPromise();
      if (!carryRes.Error && carryRes.Jobs?.length > 0) {
        this.snackbar.open('Carried over ' + carryRes.Jobs.length + ' job(s) from previous trip', '', { duration: 3000, panelClass: 'successAlert' });
      }
      if (carryRes.MissingReJobs?.length > 0) {
        const missingList = carryRes.MissingReJobs.map(j => '• ' + j.re_job_type).join('\n');
        this.dialog.open(WarningPopupComponent, {
          width: '480px',
          data: {
            warning_title: 'Re-Inspection Jobs Not Found',
            warning_description: 'The following Re-inspection job types were not found in the system. Those jobs were carried over with their original type:\n\n' + missingList,
            warning_sub: '',
            confirmText: 'OK',
            showCancelButton: false
          }
        });
      }
    } catch (e) {
      this.messager.openSnackBar('Error carrying over trip jobs.', '', 'errorAlert');
    }
  }

  // Existing trip: persist the Trip Details tab's adds/removes against what was loaded at open.
  async persistTripTaskChanges(): Promise<void> {
    const tripId = this.data.job.job_id;
    const addIds = this.selectedJobIds.filter(id => !this.initialTripTaskIds.includes(id) && !this.carryOverJobIds.includes(id));
    const removeIds = this.initialTripTaskIds.filter(id => !this.selectedJobIds.includes(id));
    if (addIds.length === 0 && removeIds.length === 0) { return; }
    try {
      const r: any = await this.service.saveTripTasks(tripId, addIds, removeIds).toPromise();
      if (r?.Error) { throw new Error(r.Message); }
      this.log.info(this.data.usernamee + ' changed the tasks on the TRIP with id: ' + tripId + ' (added: [' + addIds + '], removed: [' + removeIds + ']) with location_id: ' + this.data.job.location_id);
    } catch (e) {
      this.messager.openSnackBar('Trip saved, but its tasks were not updated: ' + (e?.message || ''), '[close]', 'errorAlert');
    }
  }

  // Child task notes edited in the trip dialog are saved on each child row. Only tasks still on
  // the trip are considered; a task removed this session is no longer in selectedJobs.
  async persistTripTaskNotes(): Promise<void> {
    const changed = (this.selectedJobs || []).filter(j =>
      this.initialTaskNotes.has(j.job_id) && (j.job_notes || '') !== (this.initialTaskNotes.get(j.job_id) || ''));
    for (const j of changed) {
      try {
        await this.service.updateJobNotes(j.job_id, j.job_notes || '').toPromise();
      } catch (e) {
        this.messager.openSnackBar('Trip saved, but notes for ' + (j.customer_jobtype || '').trim() + ' were not saved.', '[close]', 'errorAlert');
      }
    }
    if (changed.length) {
      this.log.info(this.data.usernamee + ' edited task notes on TRIP id: ' + this.data.job.job_id + ' {' + changed.map(j => j.job_id).join(', ') + '}');
    }
  }

  recomputeTripEstimatedTime() {
    if (this.convertToTrip) { return; }
    if (!this.selectedJobs) { return; }
    const total = this.selectedJobs.reduce(
      (sum, j) => sum + (parseFloat(j.estimatedtime) || 0),
      0
    );
    const ctrl = this.form.get('estimatedtime');
    if (ctrl) {
      ctrl.setValue(total);
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    }
  }

  applyPrimaryJobToTrip() {
    if (this.convertToTrip || !this.selectedJobs || this.selectedJobs.length === 0) { return; }
    const primary = this.selectedJobs[0];
    if (primary.customer_job) { this.form.get('customer_job').setValue(primary.customer_job); }
    if (primary.customer_jobtype) {
      const jobtype = primary.customer_jobtype.trim();
      this.form.get('customer_jobtype').setValue(jobtype);
      this.data.job.customer_jobtype = jobtype;
    }
    if (primary.customer_name) {
      this.customer_name = primary.customer_name;
      this.data.job.customer_name = primary.customer_name;
    }
  }

  makeJobPrimary(index: number) {
    if (index <= 0 || index >= this.selectedJobs.length) { return; }
    const [chosen] = this.selectedJobs.splice(index, 1);
    this.selectedJobs.unshift(chosen);
    const [chosenId] = this.selectedJobIds.splice(index, 1);
    this.selectedJobIds.unshift(chosenId);
    this.applyPrimaryJobToTrip();
  }

  addJobToTrip(job: any) {
    if (!this.selectedJobIds.includes(job.job_id)) {
      this.selectedJobs.push(job);
      this.selectedJobIds.push(job.job_id);
      this.availableJobs = this.availableJobs.filter(j => j.job_id !== job.job_id);

      // The first job in the list is the primary — its customer_jobtype names the trip
      if (this.selectedJobs.length === 1) {
        this.applyPrimaryJobToTrip();
      }

      this.recomputeTripEstimatedTime();
    }
  }

  removeJobFromTrip(index: number) {
    const removedJob = this.selectedJobs[index];
    const removedJobId = this.selectedJobIds[index];
    this.availableJobs.push(removedJob);
    this.selectedJobs.splice(index, 1);
    this.selectedJobIds.splice(index, 1);
    // Also remove from carryOverJobIds if it was a carryover job
    const carryOverIndex = this.carryOverJobIds.indexOf(removedJobId);
    if (carryOverIndex > -1) {
      this.carryOverJobIds.splice(carryOverIndex, 1);
      const carryOverJobIndex = this.carryOverJobs.findIndex(j => j.job_id === removedJobId);
      if (carryOverJobIndex > -1) {
        this.carryOverJobs.splice(carryOverJobIndex, 1);
      }
    }

    // If the primary (first) job was removed, update to the new first job's type
    if (index === 0 && this.selectedJobs.length > 0) {
      this.applyPrimaryJobToTrip();
    } else if (this.selectedJobs.length === 0) {
      this.form.get('customer_job').setValue(14775);
      this.form.get('customer_jobtype').setValue('Performance Point Trip');
      this.data.job.customer_jobtype = 'Performance Point Trip';
      this.customer_name = null;
      this.data.job.customer_name = null;
    }

    this.recomputeTripEstimatedTime();
  }


}


@Component({
  selector: 'app-edit-location-dialog',
  templateUrl: 'edit-location-dialog.html',
  styleUrls: ['./location.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ],
})

export class EditLocationDialogComponent implements OnInit {
  defaultScope: string = '(N/A)';
  gasUtility: any;
  streetname$: Observable<any[]>;
  planDirty:boolean = false;

  readonly EDITING_MODE = EDITING_MODE;
  readonly ADDING_MODE = ADDING_MODE;

  socketid: any;
  tags: any[] = [];
  inputTags: any[] = [];
  fatags = faTags;

  // MF / SF / GPS tag-type filter. Empty = show all.
  tagTypeFilter: string[] = [];
  get visibleTags(): any[] { return this.tagService.filterByTypes(this.tags, this.tagTypeFilter); }
  toggleTagType(t: string): void {
    this.tagService.toggleType(this.tagTypeFilter, t);
    const c = this.locationForm.get('tagControl');
    if (c && c.value) { c.setValue(c.value); }
  }

  inheritedTagsSubdivision: boolean = false;
  inheritedCustomerJobsTags: boolean = false;

  // The subdivision's own tags, shown read-only on the Tags tab. Never written to l_tags.
  subdivisionTagIds: number[] = [];
  get subdivisionTags(): any[] {
    return (this.tags || []).filter(t => this.subdivisionTagIds.indexOf(t.id) >= 0);
  }
  loadSubdivisionTags(subdivisionId: any): void {
    this.subdivisionTagIds = [];
    // locmain.subdivision arrives as a string and can be NaN
    if (!(Number(subdivisionId) > 0)) { return; }
    this.tagService.getSubdivisionTags(subdivisionId).subscribe(res => {
      this.subdivisionTagIds = (res && !res.Error && res.Tags && res.Tags.s_tags) ? res.Tags.s_tags.map(Number) : [];
    }, err => console.log(err));
  }

  tracks: any[] = [];
  trackChanged: boolean = false;
  comptrackChanged: boolean = false;
  complianceTracks: any[] = [];
  sfTrackObj: any = {};
  registrybuildertext: string;
  scopes: any;
  tiers: string[] = [];
  gasrebates: any[];
  elecrebates: any[];
  paymenthold: any;
  gasUtilities: any;
  elecUtilities: any;
  city$: Observable<any>;
  rebatedetailsdirty: boolean = false;
  swppp_date: Date;
  swppp_schedule: string;
  swppp_create: boolean = false;
  swppp_remove: boolean = false;

  isMultifamily: boolean = false;
  nonexisting_jobs: any[] = [];

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<EditLocationDialogComponent>, public subdivisionService:SubdivisionService, @Inject(MAT_DIALOG_DATA) public data: LocationDialogData, public ps: PlanService, private fb: FormBuilder, public locationService: LocationService, public raterformService: RaterFormService, private messager: MessagerComponent, public log: LoggingService, public ges: GlobalEmailService, public tagService : TagService, public customerService: CustomerService, public cdr: ChangeDetectorRef) {}

  // Opens the shared Add Note popup; on Done, prepends the stamped line to Admin Notes.
  // Direct typing in the textarea is unaffected. Persists with the dialog's normal Save.
  openAddAdminNote(){
    this.dialog.open(AddNoteDialogComponent, {
      width: '400px',
      data: { usernamee: this.data.usernamee }
    }).afterClosed().subscribe(stamped => {
      if(!stamped){ return; }
      const existing = this.locationForm.get('adminnotes').value;
      const updated = stamped + (existing ? '\n' + existing : '');
      this.locationForm.get('adminnotes').setValue(updated);
    });
  }

  @ViewChild('subname', { read: false, static: false}) // reference the subdivision name field
  subNameInputRef: ElementRef;
  @ViewChild('planname', {read: false, static: false}) // reference the plan name field
  planNameInputRef: ElementRef;
  @ViewChild('contractorname',{read: false, static: false}) // reference the contractor name field
  contractorNameInputRef: ElementRef;
  @ViewChild('ripple', { read: MatRipple}) ripple: MatRipple;
  @ViewChild('regripple', { read: MatRipple}) regripple: MatRipple;
  @ViewChild('subRipple', { read: MatRipple}) subRipple: MatRipple;
  @ViewChild('stateRipple', { read: MatRipple}) stateRipple: MatRipple;
  @ViewChild('zipRipple', { read: MatRipple}) zipRipple: MatRipple;
  @ViewChild('elecRipple', { read: MatRipple}) elecRipple: MatRipple;
  @ViewChild('scopeRipple', { read: MatRipple}) scopeRipple: MatRipple;
  @ViewChild('myTabGroup') myTabGroup: MatTabGroup;


  public subdivision$: Observable<Subdivision[]>;
  public plan$: Observable<Plan[]>;
  public contractor$: Observable<any>;

  public subdivisionDisplay: string;
  public planDisplay: string;
  public hvacDisplay: string;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTags: Observable<any[]>;



  isLoading = false;
  id = this.data.location_id;
  mode = this.data.mode;
  ekoIsLoading = false;
  faImport = faFileImport;
  faQaReview = faClipboardCheck;
  qaReviewLoading = false;
  qaReviewNote = this.data.qa_review || '';
  showQaReview = false;

  // Colours the Import button: red until Ekotrope hands back a registry id, green once it has.
  // Modelers must re-import after registering, and a blank Registry ID is easy to overlook.
  get hasRegistryId(): boolean {
    const ctrl = this.locationForm.get('registryid');
    const val = ctrl ? ctrl.value : null;
    return !!(val && val.toString().trim().length > 0);
  }

  color = 'lightgreen';
  theSubdivision;
  subdivisionOptions: Subdivision[] = [];
  subdivisionError: string = '';
  originalSubdivisionName: string = (this.data.subdivision_name || '').toString().trim();
  elecUtility = '';
  isDuplicate = false;
  showtext = '';
  duplicateWarning = '';
  similarLocations: any[] = [];
  subtext = '';
  subisDuplicate = false;
  buildertext = '';

  gasrebatedetails = {
    gasrebate : this.data.gasrebatedetails?.gasrebate || null,
    gas_rebate1 : this.data.gasrebatedetails?.gas_rebate1 || false,
    gas_rebate2 : this.data.gasrebatedetails?.gas_rebate2  || false,
    gas_rebate_2_status : this.data.gasrebatedetails?.gas_rebate_2_status || null
  };

  electricrebatedetails = {
    elecrebate : this.data.electricrebatedetails?.elecrebate || null,
    electric_rebate1 : this.data.electricrebatedetails?.electric_rebate1 || false,
    electric_rebate2 : this.data.electricrebatedetails?.electric_rebate2 || false,
    electric_rebate_2_status : this.data.electricrebatedetails?.electric_rebate_2_status || null
  };



  regions: Region[] = [
    {value: 'ATL', viewValue: 'ATL'},
    {value: 'CHS', viewValue: 'CHS'},
    {value: 'CLT', viewValue: 'CLT'},
    {value: 'COL', viewValue: 'COL'},
    {value: 'CSTL', viewValue: 'CSTL'},
    {value: 'GRV', viewValue: 'GRV'},
    {value: 'KNX', viewValue: 'KNX'},
    {value: 'MEM', viewValue: 'MEM'},
    {value: 'MF', viewValue: 'MF'},
    {value: 'NSH', viewValue: 'NSH'},
    {value: 'RIC', viewValue: 'RIC'},
    {value: 'RDU', viewValue: 'RDU'},
    {value: 'TRI', viewValue: 'TRI'}
  ];






    locationForm = new FormGroup({
      street_address : new FormControl(this.data.street_address || ''),
      city : new FormControl(this.data.city || ''),
      state : new FormControl(this.data.state || ''),
      zip : new FormControl(this.data.zip || 0),
      subdivision: new FormControl(this.data.subdivision || 0),
      subdivision_name : new FormControl(this.data.subdivision_name || ''),
      lot : new FormControl(this.data.lot || ''),
      scope : new FormControl(this.data.scope || ''),
      contacts : new FormControl(this.data.contacts || ''),
      ekotrope_id : new FormControl(this.data.ekotrope_id || null),
      permit_no : new FormControl(this.data.permit_no || ''),
      permitdate : new FormControl(this.data.permitdate || null),
      hers_index : new FormControl(this.data.hers_index || 0),
      registryid : new FormControl(this.data.registryid || ''),
      taxparcel : new FormControl(this.data.taxparcel || ''),
      adminnotes : new FormControl(this.data.adminnotes || ''),
      site_notes : new FormControl(this.data.site_notes || ''),
      billing_notes : new FormControl(this.data.billing_notes || ''),
      weatherloc : new FormControl(this.data.weatherloc || ''),
      roughnotice : new FormControl(this.data.roughnotice || false),
      roughreport : new FormControl(this.data.roughreport || false),
      finalnotice : new FormControl(this.data.finalnotice || false),
      finalreport : new FormControl(this.data.finalreport || false),
      cert_printed : new FormControl(this.data.cert_printed || false),
      disclosuresent : new FormControl(this.data.disclosuresent || false),
      taxcred : new FormControl(this.data.taxcred || false),
      cfsent : new FormControl(this.data.cfsent || false),
      countyform : new FormControl(this.data.countyform || ''),
      adminarchive : new FormControl(this.data.adminarchive || false),
      missinginfo : new FormControl(this.data.missinginfo || false),
      targetset : new FormControl(this.data.targetset || false),
      hvac_contractor_id : new FormControl(this.data.hvac_contractor_id || 0),
      customer_id : new FormControl(this.data.customer_id || 0),
      hvacovrd : new FormControl(this.data.hvacovrd || false),
      rem_done : new FormControl(this.data.rem_done),
      rebate1 : new FormControl(this.data.rebate1 || false),
      rebate2 : new FormControl(this.data.rebate2 || false),
      plan_name : new FormControl(this.data.plan_name || ''),
      startdate : new FormControl(this.data.startdate || null ),
      closedate : new FormControl(this.data.closedate || null ),
      folderid : new FormControl(this.data.folderid || null),
      buid : new FormControl(this.data.buid || null),
      rebate3: new FormControl(this.data.rebate3 || false),
      gasutility : new FormControl(this.data.gasutility || ''),
      elecutility : new FormControl(this.data.elecutility || ''),
      premiseno: new FormControl(this.data.premiseno || ''),
      premnochkd: new FormControl(this.data.premnochkd || false),
      prmnochkdat: new FormControl(this.data.prmnochkdat || null),
      qad: new FormControl(this.data.qad || ''),
      qatype: new FormControl(this.data.qatype || ''),
      qadate: new FormControl(this.data.qadate || null),
      qanotes: new FormControl(this.data.qanotes || ''),
      hvacnotes: new FormControl(this.data.hvacnotes || ''),
      qareported: new FormControl(this.data.qareported || null),
      qad2: new FormControl(this.data.qad2 || ''),
      qatype2: new FormControl(this.data.qatype2 || ''),
      qadate2: new FormControl(this.data.qadate2 || null),
      qanotes2: new FormControl(this.data.qanotes2 || ''),
      qareported2: new FormControl(this.data.qareported2 || null),
      rebate2stat : new FormControl(this.data.rebate2stat || ''),
      auditorname : new FormControl(this.data.auditorname || ''),
      constage : new FormControl(this.data.constage || ''),
      nrgprogram : new FormControl(this.data.nrgprogram || ''),
      audtype : new FormControl(this.data.audtype || ''),
      audnotes : new FormControl(this.data.audnotes || ''),
      ovlscore : new FormControl(this.data.ovlscore || 0),
      audinspdate : new FormControl(this.data.audinspdate || null),
      audreported: new FormControl(this.data.audreported || false),
      region : new FormControl(this.data.region || ''),
      esmfnc : new FormControl(this.data.esmfnc || false),
      track : new FormControl(this.data.track || null),
      comptrack : new FormControl(this.data.comptrack || null),
      mfplanoverride : new FormControl(this.data.mfplanoverride || false),
      tagControl: new FormControl(),
      gasrebate : new FormControl(this.data.gasrebatedetails?.gasrebate || null),
      gas_rebate1 : new FormControl(this.data.gasrebatedetails?.gas_rebate1 || false),
      gas_rebate2 : new FormControl(this.data.gasrebatedetails?.gas_rebate2 || false),
      gas_rebate_2_status : new FormControl(this.data.gasrebatedetails?.gas_rebate_2_status || null),
      elecrebate : new FormControl(this.data.electricrebatedetails?.elecrebate || null),
      electric_rebate1 : new FormControl(this.data.electricrebatedetails?.electric_rebate1 || false),
      electric_rebate2 : new FormControl(this.data.electricrebatedetails?.electric_rebate2 || false),
      electric_rebate_2_status : new FormControl(this.data.electricrebatedetails?.electric_rebate_2_status || null),
      electric_tier : new FormControl(this.data.electricrebatedetails?.electric_tier || null),
      swppp : new FormControl(this.data.swppp || false),
      threetenrep : new FormControl(this.data.threetenrep || ''),
      refrigpw : new FormControl(this.data.refrigpw || ''),
      hvac_dr_request : new FormControl(this.data.hvac_dr_request || false)

    });



    resetRem(): void {
      this.locationService.resetRem(this.id).subscribe(res => {
        this.messager.openSnackBar('Rem file reset!', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('An error occured', '', 'errorAlert');
      })
    }

    openGasRebateModal(event): void {
      const modal = document.getElementById('gasModal');
      var input = document.getElementById('gasInput') as HTMLInputElement;
      input.value = '';
      if(modal){
        modal.style.display = 'block';
      }
    }

    openElecRebateModal(event): void {
      const modal = document.getElementById('elecModal');
      var input = document.getElementById('elecInput') as HTMLInputElement;
      input.value = '';
      if(modal){
        modal.style.display = 'block';
      }


    }

    handleElecResponse(response): void {

      var input = document.getElementById('elecInput') as HTMLInputElement;
      var inputValue = '';
      if(input) { var inputValue = input.value };

      const modal = document.getElementById('elecModal');
      if(modal){
        modal.style.display = 'none';
      }

      if(response == true){
        //console.log('user clicked save: ', inputValue);
        if(inputValue.length > 0){
          this.locationService.addRebate(inputValue, 'Electric').subscribe(
            res => {
              this.messager.openSnackBar('Added ' + inputValue + '!', '', 'successAlert');
              this.elecrebates.unshift({"rebate" : inputValue, "type" : "Electric"});
            });
        }
      }else {
      }
    }

    handleGasResponse(response): void {
      var input = document.getElementById('gasInput') as HTMLInputElement;
      var inputValue = '';
      if(input) { var inputValue = input.value };

      const modal = document.getElementById('gasModal');
      if(modal){
        modal.style.display = 'none';
      }

      if(response == true){
        if(inputValue.length > 0){
          this.locationService.addRebate(inputValue, 'Gas').subscribe(
            res => {
              this.messager.openSnackBar('Added ' + inputValue + '!', '', 'successAlert');
              this.gasrebates.unshift({"rebate" : inputValue, "type" : "Gas"});
            });
        }
      }else {
      }

    }

  formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  showSWPPPModal() : void {
    const modal = document.getElementById('swpppmodal');
    if(modal){
      modal.style.display = 'block';
    }
  }

  closeSWPPPModal(): void {
    const modal = document.getElementById('swpppmodal');
    if(modal){
      modal.style.display = 'none';
    }
  }


  handleSWPPPResponse(cancel: boolean = false): void {

    if(!cancel) {
      let datevalue = document.getElementById('swpppDateInput') as HTMLInputElement;
      let date = datevalue.value;
      const selectedSchedule = document.getElementById('swpppsched') as HTMLSelectElement;
      this.swppp_date = date ? new Date(date) : null;
      this.swppp_schedule = selectedSchedule.value;
      this.swppp_create = true;
    }else{
      // Cancelling leaves no schedule, so the checkbox must not stay ticked - that would save
      // locmain.swppp = true with no swppp_info row behind it.
      this.locationForm.get('swppp').setValue(false);
      this.swppp_create = false;
    }

    const modal = document.getElementById('swpppmodal');
    if(modal){
      modal.style.display = 'none';
    }

  }


  swpppSave(location_id): void {

    this.locationService.swpppInsert(location_id, this.locationForm.get('customer_id').value,{
      swppp_date: this.formatDate(this.swppp_date),
      swppp_schedule: this.swppp_schedule
    }).subscribe(
      res => {
        if(res.Error){
          this.messager.openSnackBar(res.Message, '', 'errorAlert');
        }else{
          this.messager.openSnackBar(res.Message, '', 'successAlert');
        }},
      err => {
        console.log(err);
        this.messager.openSnackBar('Error saving SWPPP data: ' + err.toString(), '', 'errorAlert');
      }
    );

  }

  get swpppCaption(): string {
    if(!this.swppp_schedule){
      return '';
    }
    const started = this.swppp_date ? ', started ' + moment(this.swppp_date).format('MM/DD/YYYY') : '';
    return 'SWPPP: ' + this.swppp_schedule + started;
  }

  handleSWPPPclick(checked: boolean): void {

    if(checked){
      this.swppp_remove = false;
      this.showSWPPPModal();
    }else{
      // Must clear swppp_create: check-then-uncheck in one session would otherwise fire the
      // insert and the deactivate as two un-awaited calls, and the insert can land last.
      this.swppp_create = false;
      this.swppp_schedule = '';
      this.swppp_date = null;
      this.swppp_remove = true;
    }

  }

  swpppEnd(location_id): void {

    this.locationService.swpppEnd(location_id).subscribe(
      res => {
        if(res.Error){
          this.messager.openSnackBar('Error ending SWPPP data: ' + res.Message, '', 'errorAlert');
        }else{
          this.messager.openSnackBar(res.Message, '', 'successAlert');
        }
      }, err => {
        this.messager.openSnackBar('Error ending SWPPP data: ' + err.toString(), '', 'errorAlert');
      }
    )

  }

  getDate(date:string): string{
      return moment(date).format('MM/DD/YYYY');
    }

    getEkotropeLink(projectID): string {
      return 'https://app.ekotrope.com/#project:' + projectID;
    }

    getDriveLink(folderID): string {
      return 'https://drive.google.com/drive/u/0/folders/' + folderID;
    }

    // The control holds the resolved name string after a pick, not the Subdivision object.
    displayFunction(subdivision: any) {
      if (subdivision == null) { return ''; }
      if (typeof subdivision === 'object') { return subdivision.subdivision_name; }
      return subdivision;
    }

    get subdivisionIsValid(): boolean {
      const id = Number(this.locationForm.get('subdivision').value) || 0;
      const name = (this.locationForm.get('subdivision_name').value || '').toString().trim();
      if (id > 0) { return true; }
      if (name.length === 0) { return true; }
      return this.subdivisionIsLegacyPristine;
    }

    // Older rows can hold a typed name with no linked subdivision. Let unrelated edits save
    // until the user touches the field.
    get subdivisionIsLegacyPristine(): boolean {
      const ctrl = this.locationForm.get('subdivision_name');
      const name = (ctrl.value || '').toString().trim();
      return this.mode == EDITING_MODE && !ctrl.dirty && name === this.originalSubdivisionName;
    }

    onSubdivisionBlur(): void {
      this.checkForDuplicateSubLot();

      // Deferred so a click on an option (which blurs first) lands before the input is judged.
      setTimeout(() => {
        const el = this.subNameInputRef ? this.subNameInputRef.nativeElement : null;
        const typed = ((el ? el.value : '') || '').toString().trim();

        if (typed.length === 0) { this.subdivisionError = ''; return; }
        if (typed === (this.theSubdivision || '').toString().trim()) { this.subdivisionError = ''; return; }

        const match = (this.subdivisionOptions || []).find(s =>
          (s.subdivision_name || '').toString().trim().toLowerCase() === typed.toLowerCase());
        if (match) { this.onSelectSubdivision(match); return; }

        if (el) { el.value = this.theSubdivision || ''; }
        this.locationForm.get('subdivision_name').setValue(this.theSubdivision || '');
        this.subdivisionError = 'Pick a subdivision from the list. Typed names are not saved - '
          + 'if the subdivision is missing, add it on the Subdivisions page first.';
        this.messager.openSnackBar('Select a subdivision from the dropdown.', '', 'errorAlert');
        this.log.warn(this.data.usernamee + ' typed a subdivision that is not in the list: "'
          + typed + '" (location_id: ' + (this.data.location_id || 'new') + ')');
      }, 250);
    }

    // Called by the autocomplete with whatever the control holds: a Customer once one is
    // picked from the dropdown, but a bare contractor id when it was prefilled from the
    // subdivision. Fall back to the resolved name so the field never renders blank.
    displayFunctionHvac = (contractor: any) => {
      if (contractor == null || contractor === 0 || contractor === '0') { return ''; }
      if (typeof contractor === 'object') { return contractor.customer_name; }
      return this.hvacDisplay || '';
    }

    displayFunctionPlan(plan: Plan){
      if (plan) {return plan.plan_name; }
    }

    ngOnInit() {

      let builderFound = false;
      this.socketid = this.data.socketid || null;

      //get rebate features
      if(this.data.electricrebatedetails?.electric_tier != null || this.data.electricrebatedetails?.elecrebate?.toLowerCase().includes('duke') ){
        this.tiers = ['Whole House', 'Whole House Plus', 'Equipment Only', 'ACE', 'ACE + HERS', ''];
      }

      this.getLatestSelections();

      this.subdivisionService.getScopes().subscribe(
        res => {
          this.scopes = res.Scopes;
        });

      //get the customer
      if(this.data.customer_id != null && this.data.customer_id != 0){
        this.locationService.getBuilder(this.data.customer_id).subscribe(
          res => {
            this.buildertext = res.Customer.customer_name;
            builderFound = true;

            this.customerService.getOneCustomer(this.data.customer_id).subscribe(
              res => {
                this.registrybuildertext = res.Customer.registry_name;
                this.paymenthold = res.Customer.paymenthold;
              }
            )

          }, err => {
            this.buildertext = '(No Builder)';
            builderFound = false;
          }
        )
      }

      //get tracks
      this.locationService.getTracks().subscribe(
        res => {
          this.tracks = res.Tracks;
          ////console.log(this.tracks);
        }, err => {
          ////console.log(err);
      });


      this.loadUtilities();

        if(this.data.subdivision < 1 || this.data.subdivision == null){
        this.elecUtility = this.data.elecutility || 'Use details tab';
        this.gasUtility = this.data.gasutility || 'Use details tab';

        this.defaultScope = this.data.scope || 'Use the details tab';

      } else {

        this.locationService.getElecUtility(this.data.subdivision).subscribe(
          res => {
            if(res.Error){

                this.elecUtility = '(None selected)'
                this.gasUtility = '(None selected)';

            } else {
              this.locationService.getScope(this.data.subdivision).subscribe(
                res => {
                  if(res.Error){
                    //////console.log('ERROR SCOPE', res);
                    this.defaultScope = '(N/A)'
                    if(builderFound == false){
                      this.buildertext = '(No Builder)';
                    }

                  }else {
                    this.defaultScope = res.Scope.scope || '(N/A)';
                    if(builderFound == false){
                      this.buildertext = res.Scope.customer_name || '(No Builder)';
                    }
                    if(this.data.customer_id == null || this.data.customer_id == 0){
                      this.locationForm.get('customer_id').setValue(res.Scope.customer_id);
                    }

                    if(res.Scope.ismultifamily == true){
                      this.isMultifamily = true;
                    }
                  }

                }, err => {
                  this.defaultScope = '(N/A)';
                }
              )
                this.elecUtility = res.elecutility || '';

                if(this.locationForm.get('elecutility').value == ''){
                  this.locationForm.get('elecutility').setValue(res.elecutility);
                }

                this.gasUtility = res.gasutility || '';

                if(this.locationForm.get('gasutility').value == ''){
                  this.locationForm.get('gasutility').setValue(res.gasutility);
                }

            }

          }, err => {
            this.elecUtility = '(None selected)';
            this.gasUtility = '(None selected)';
          }
        )


      }

      if(this.data.permitdate != null){
        let pdate = new Date(this.data.permitdate);

        const day = pdate.getUTCDate();
        const month = pdate.getUTCMonth() + 1; // Return Value is 0 indexed
        const year = pdate.getUTCFullYear();

        const formattedDate = moment(this.data.permitdate, "YYYY-MM-DD").format("MM/DD/YYYY");

        const formattedDatepd = moment.utc(this.data.permitdate).format('MM/DD/YYYY');
        this.locationForm.get('permitdate').setValue(formattedDatepd);

      }

      if(this.data.closedate != null){
        let pdate = new Date(this.data.closedate);

        const day = pdate.getUTCDate();
        const month = pdate.getUTCMonth() + 1; // Return Value is 0 indexed
        const year = pdate.getUTCFullYear();

        const formattedDatecd = moment.utc(this.data.closedate).format('MM/DD/YYYY');
        this.locationForm.get('closedate').setValue(formattedDatecd);

      }

      if(this.data.startdate != null){
        let pdate = new Date(this.data.startdate);

        const day = pdate.getUTCDate();
        const month = pdate.getUTCMonth() + 1; // Return Value is 0 indexed
        const year = pdate.getUTCFullYear();

        const formattedDatesd = moment.utc(this.data.startdate).format('MM/DD/YYYY');
        this.locationForm.get('startdate').setValue(formattedDatesd);

      }



      this.subdivisionDisplay = this.data.subdivision_name;
      this.theSubdivision = this.data.subdivision_name;
      this.hvacDisplay = '';

      this.locationService.getHvacContractor(this.data.hvac_contractor_id).subscribe(
        res => {
          this.hvacDisplay = res.customer_name;
        }, err => {
        }
      )


      this.planDisplay = this.data.plan_name;


      this.subdivision$ = this.locationForm.get('subdivision_name').valueChanges.pipe(
        debounceTime(400),
        tap(value => {
          this.isLoading = true;
        }),
        switchMap(value =>
          value.length > 0 ? this.locationService.getSubdivisionsDropdown(value as string) : empty()
          .pipe(
            finalize(() => this.isLoading = false)
            )
        ),
        tap((list: any) => { this.subdivisionOptions = Array.isArray(list) ? list : []; })
      );

      this.city$ = this.locationForm.get('city').valueChanges.pipe(
        debounceTime(400),
        tap(value => {
          //console.log(value);
          this.isLoading = true;
        }),
        switchMap(value =>
          value.length > 0 ? this.subdivisionService.getCitiesDropdown(value as string) : empty()
          .pipe(
            finalize(() => this.isLoading = false)
            )
          )
      );


      // load contractors for dropdown
      this.contractor$ = this.locationForm.get('hvac_contractor_id').valueChanges.pipe(
        debounceTime(400),
        tap(value => {
        }),
        switchMap(value =>
          value.length > 0 ? this.locationService.getContractorsDropdown(value as string) : empty()
          .pipe(
            finalize(() => this.isLoading = false)
            )
        )
      );

      this.locationService.getComplianceTracks().subscribe(
        res => {
          this.complianceTracks = res.Tracks;
        });


      this.plan$ = this.locationForm.get('plan_name').valueChanges.pipe(
        debounceTime(400),
        tap(() => this.isLoading = true),
        switchMap(value =>
          value.length > 0 ? this.locationService.getPlanDropdownOptions(value as string) : empty()
          .pipe(
            tap((res) => {
              this.isLoading = false;
            })
          )
        )
      );

      //see if region is blank
      if( (this.data.region == null || this.data.region == '') && this.data.subdivision > 0){
        this.locationService.getRegion(this.data.subdivision).subscribe(
          res => {
            this.locationForm.get('region').setValue(res.region.trim());
          }, err => {

          })
      }

      this.locationService.getTags().subscribe(
        res => {
          this.tags = res.data;
        });

      this.loadSubdivisionTags(this.data.subdivision);


       if(this.data.mode == EDITING_MODE){
        // just load tags that are already selected
        this.data.l_tags?.forEach(tag => {
          this.locationService.getTag(tag).subscribe(
            res => {
              this.inputTags.push(res.data);
            }
          );
        });


        //load swppp data
        if(this.data.swppp == true){
          this.locationService.getSWPPPinfo(this.data.location_id).subscribe(
            res => {
              const info = res.Data && res.Data.length > 0 ? res.Data[0] : null;
              this.swppp_schedule = info ? info.schedule : '';
              this.swppp_date = info ? info.startdate : null;
            },err => {
              console.log(err);
            }
          )
       }

        }

        this.filteredTags = this.locationForm.get('tagControl').valueChanges.pipe(
          debounceTime(400),
          tap(value => {
          }),
          filter((tag: string | null) => tag && tag.length > 0),
          map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice())
        );

    } //ngOninit


    getLatestSelections() {

    this.locationService.getRebateSelections().subscribe(
      res => {
        this.gasrebates = res.Gas;
        this.elecrebates = res.Electric;
      });
  }



    setGasRebateDirty(): void {
      this.rebatedetailsdirty = true;
    }

    private _filter(value: string): any[] {
      const filterValue = value?.toLowerCase();
      return this.visibleTags.filter(tag => tag.displayname.toLowerCase().includes(filterValue));
    }

    manualUpdateUtilities(item, value?): void {
      if ( value === '0') {
        // Open the dialog to enter a new scope
        const dialogRef = this.dialog.open(NewScopeDialogComponent, {
          width: '400px',
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Set the new scope name to the form control
            this.locationForm.get('scope').setValue(result.scope);
            this.data.scope = result.scope;

            //console.log('VALUE',this.locationForm.get('scope').value);
            // Call the service to save the new scope (mocked for now)
            this.subdivisionService.saveNewScope(result).subscribe(
              (res) => {
                //console.log(res);
                if (res && res.Error) {
                  this.messager.openSnackBar(res.Message || 'Error saving new scope', '[close]', 'errorAlert');
                  return;
                }
                // Carry `category` (scopedef.category) onto the local row so the
                // new scope behaves like a reloaded one.
                this.scopes.push(
                  {
                    scope: result.scope,
                    category: result.category,
                    description: result.desc
                  }
                )
                this.messager.openSnackBar(`New scope '${result.scope}' added successfully`, '[close]', 'successAlert');
              },
              (err) => {
                this.messager.openSnackBar('Error saving new scope', '[close]', 'errorAlert');
              }
            );
          }
        });
      }
    }

    resetBuilderLocationButton(){
      this.locationService.resetBuilderLocationButton(this.id).subscribe(
        res => {
          this.messager.openSnackBar('Builder TEC Reset!', '', 'successAlert');
        })
    }

    updateRebateObj(gas_or_electric,fieldname, value) {

      //console.log(value);
      //console.log(fieldname);
      if(gas_or_electric == 'gas'){
        this.gasrebatedetails[fieldname] = value;
        this.setGasRebateDirty();
      }else {
        this.electricrebatedetails[fieldname] = value;
      }

      //console.log(this.gasrebatedetails);
      //console.log(this.electricrebatedetails);

    }

    addBuilderClick(){

      //open the modal component we defined below
      const dialogRef = this.dialog.open(SelectBuilderComponent, {
          width: '450px',
          data: {location_id: this.id}
        }).afterClosed().subscribe(
          res => {
            if(res){
              ////console.log(res);
              this.buildertext = res.customer_name;
              this.paymenthold = res.paymenthold;
              this.locationForm.get('customer_id').setValue(res.customer_id);

              //get registry_name
              this.customerService.getOneCustomer(res.customer_id).subscribe(
                res => {
                  ////console.log(res.Customer.registry_name);
                  this.registrybuildertext = res.Customer.registry_name;
                }
              )
              this.log.info(this.data.usernamee + ' added builder ' + res.customer_name + ' to location ' + this.data.street_address + ' with location_id: ' + this.data.location_id );
            }
          });

    }

    onSelectCity(city: any): void {

      this.locationForm.get('city').setValue(city.city);
      if(this.locationForm.get('subdivision_name').value == null || this.locationForm.get('subdivision_name').value == ''){
        this.locationForm.get('region').setValue(city.region?.trim() || '');
        this.locationForm.get('state').setValue(city.state?.trim() || '');
      }

    }


    onSelectSubdivision(subdivision: Subdivision): void {
      this.data.subdivision = subdivision.subdivision_id;
      this.subdivisionDisplay = subdivision.subdivision_name;
      this.theSubdivision = subdivision.subdivision_name;
      this.subdivisionError = '';
      this.buildertext = subdivision.customer_name || '(No Builder)';
      this.registrybuildertext = '';
      this.locationForm.get('customer_id').setValue(subdivision.customer_id);
      this.isMultifamily = subdivision.ismultifamily || false;

      if(this.isMultifamily){
        this.isDuplicate = false;
        this.duplicateWarning = "Multifamily subdivision. Dupliicate addresses allowed.";
      }

      this.checkForDuplicateSA();
      this.customerService.getOneCustomer(subdivision.customer_id).subscribe(
        res => {
          if(res.Error == false){
            this.registrybuildertext = res.Customer.registry_name || '';
          }
        }
      )

      this.locationForm.get('subdivision').setValue(subdivision.subdivision_id);
      this.data.subdivision_name = subdivision.subdivision_name;
      this.locationForm.get('subdivision_name').setValue(subdivision.subdivision_name);
      this.locationForm.get('region').setValue(subdivision.region?.trim() || '');

      const subCity = subdivision.city || '';
      this.data.city = subCity;
      if (subCity.length > 1) {
        this.longRipple(this.subRipple);
      }
      this.locationForm.get('city').setValue(subCity);

      const subState = subdivision.state || '';
      this.data.state = subState;
      if (subState.length > 1) {
        this.longRipple(this.stateRipple);
      }
      this.locationForm.get('state').setValue(subState);

      const subZip = subdivision.dzip || '';
      this.data.zip = subZip;
      if (subZip.trim().length > 2) {
        this.longRipple(this.zipRipple);
        this.locationForm.get('zip').setValue(subZip);
      }else {
        this.locationForm.get('zip').setValue(0);
      }

      // dhvaccontractor is numeric(10,0), so it arrives as a string - coerce to a number
      // so the id saved on the location matches the customer_id type used everywhere else.
      const subContractorId = Number(subdivision.dhvaccontractor);
      if(subdivision.dhvaccontractor != null && subContractorId > 0){
        this.customerService.getOneCustomer(subContractorId).subscribe(
          res => {
            if(res.Error == false){
              this.data.hvac_contractor_id = subContractorId;
              this.hvacDisplay = res.Customer.customer_name;
              this.locationForm.get('hvac_contractor_id').setValue(subContractorId);
              if(this.contractorNameInputRef){
                this.contractorNameInputRef.nativeElement.value = res.Customer.customer_name;
              }
            }
          }
        )
      }

      this.locationForm.get('scope').setValue(subdivision.scope || '');

      this.locationService.getElecUtility(subdivision.subdivision_id).subscribe(
        res => {
          if(res.Error){
            this.elecUtility = ''
            this.gasUtility = ''
          }
          this.elecUtility = res.elecutility || '';
          this.gasUtility = res.gasutility || '';
          this.locationForm.get('elecutility').setValue(res.elecutility || '');
          this.locationForm.get('gasutility').setValue(res.gasutility || '');
        }, err => {
          this.elecUtility = '';
          this.gasUtility = ''
        }
      )

      this.locationService.getScope(subdivision.subdivision_id).subscribe(
        res => {
          if(res.Error){
            this.defaultScope = '(N/A)'
          }
          this.defaultScope = res.Scope.scope || '(N/A)';
        }, err => {
          this.defaultScope = '(N/A)';
        }
      )


      if(this.mode == 2 && subdivision.subdivision_name.toLowerCase().includes('waxhaw landing')){
        this.trackDirty(14);
      }

      this.subdivisionTagIds = [];
      this.tagService.getSubdivisionTags(this.data.subdivision).subscribe(
        res => {
          // Must run before the forEach below, which throws when s_tags is null.
          this.subdivisionTagIds = ((res && res.Tags && res.Tags.s_tags) || []).map(Number);
          res.Tags.s_tags.forEach(tag => {
              if(!this.data.l_tags){
                this.data.l_tags = [];
              }

              if(!this.data.l_tags.includes(tag)){
                this.data.l_tags.push(tag);
              }

          });

          if(res.Tags.s_tags.length > 0){
            this.inheritedTagsSubdivision = true;
          }

          this.data.l_tags.forEach(tag => {
            this.tagService.getTag(tag).subscribe(
              res => {
                this.inputTags.push(res.data);
              }
            );
          });

        });

    }

    goToTags(){
      this.myTabGroup.selectedIndex = 6;
    }

    loadUtilities(): void {
      this.locationService.getGasUtilities().subscribe(
        res => {
          this.gasUtilities = res.Data;
        }, err => {
          this.gasUtilities = [];
        });

      this.locationService.getElectricUtilities().subscribe(
        res => {
          this.elecUtilities = res.Data;
        }, err => {
          this.elecUtilities = [];
        });
    }

    addUtilityDialog(): void {
      const dialogRef = this.dialog.open(AddUtilityDialogComponent, {
        width: '450px',
        data: { who: this.data.usernamee },
        panelClass: 'edit-dialog-container'
      });

      dialogRef.afterClosed().subscribe(added => {
        if (added) {
          this.loadUtilities();
        }
      });
    }

    removeTag(tag: any): void {
      const index = this.inputTags.indexOf(tag);

      if (index >= 0) {
        this.inputTags.splice(index, 1);
        this.log.info(this.data.usernamee + ' removed tag#' + tag.id + ' (named: ' + tag.displayname + ') from ' +  this.data.street_address + ' with location_id: ' + this.data.location_id );
      }

    }

    onEnter(auto: MatAutocomplete): void {
        this.locationForm.get('tagControl').setValue('');
    }

    addTag(event: MatChipInputEvent, tag?: any): void {

      const input = event.input;
      // Only add tag if it is not already selected
      if(tag){
        if (this.inputTags) {
          const tagIds = this.inputTags.map(existingTag => existingTag.id);
          if (!tagIds.includes(tag.id)) {
            this.inputTags.push(tag);
            this.log.info(this.data.usernamee + ' added tag#' + tag.id + ' (named: ' + tag.displayname + ') to the ' +  this.data.street_address + ' with id: ' + this.data.location_id );
          }
        }
      }
      input.value = '';
      //this.processTags();

    }




    arrayize(val) {
      return Array.from(val);
    }



    onSelectPlan(plan: Plan): void {
      this.data.plan = plan.plan_id;
      this.planDisplay = plan.plan_name + ' (' + plan.customer_name + ')';
      // this.locationForm.get('plan').setValue(plan.plan_id);
      this.data.plan_name = plan.plan_name;
      this.locationForm.get('plan_name').setValue(plan.plan_name);
      this.planNameInputRef.nativeElement.value = plan.plan_name;
    }

    clearSubdivision(): void {
      this.data.subdivision = 0;
      this.data.subdivision_name = '';
      this.locationForm.get('subdivision').setValue(0);
      this.locationForm.get('subdivision_name').setValue('');
      this.subdivisionDisplay = '';
      this.theSubdivision = '';
      this.subdivisionTagIds = [];
      this.subdivisionError = '';
      this.messager.openSnackBar('Subdivision cleared.', '', 'successAlert');
      this.elecUtility = ''
      this.defaultScope = '(N/A)';
      this.showtext = '';
      this.isMultifamily = false;
      this.checkForDuplicateSA();
    }

    clearContractor(): void {
      this.data.hvac_contractor_id = 0;
      this.locationForm.get('hvac_contractor_id').setValue(0);
      this.hvacDisplay = '';
      this.messager.openSnackBar('Contractor cleared.', '', 'successAlert');
    }

    clearPlan(): void {
      this.data.plan = 0;
      this.locationForm.get('plan_name').setValue('');
      this.planDisplay = '';
      this.data.plan_name = '';
      this.planNameInputRef.nativeElement.value = '';
      //this.locationForm.get('plan').setValue(0);
      this.messager.openSnackBar('Plan cleared.', '', 'successAlert');
    }

    // Strip leading/trailing whitespace off the address text fields so the value that gets
    // duplicate-checked, saved and displayed is always the trimmed one.
    trimAddressFields(): void {
      ['street_address', 'city', 'state'].forEach(name => {
        const control = this.locationForm.get(name);
        const value = control?.value;
        if (typeof value === 'string' && value !== value.trim()) {
          control.setValue(value.trim(), { emitEvent: false });
        }
      });
    }

    checkForDuplicateSA(): void {

      this.trimAddressFields();

      const streetAddress = this.locationForm.get('street_address')?.value?.trim()?.toLowerCase() || '';

      if(streetAddress.length > 1 &&
        !this.isMultifamily &&
        !streetAddress.includes('tbd')){
          this.locationService.checkDuplicateSA(streetAddress, this.data.location_id || 0).subscribe(
            res => {
              if(res.Length > 0){
                // Normalized-exact duplicate -> hard block (Add is a no-op).
                this.showtext = 'NOTE: Street address ' + res.Data[0].street_address + ' exists! Changing it is recommended.';
                this.isDuplicate = true;
                this.duplicateWarning = "This location already exists, please edit to continue";
                this.similarLocations = [];
              } else if(res.Similar && res.Similar.length){
                // Similar-but-not-identical -> soft warning, Add NOT blocked.
                this.showtext = 'NOTE: ' + res.Similar.length + ' similar address(es) already exist — check before adding.';
                this.isDuplicate = false;
                this.duplicateWarning = '';
                this.similarLocations = res.Similar;
              } else {
                this.showtext = 'This is a new street address.';
                this.isDuplicate = false;
                this.duplicateWarning = '';
                this.similarLocations = [];
              }
            },err => {
            }
          )
      }else{
          this.showtext = 'This is a new street address.';
          this.isDuplicate = false;
          this.similarLocations = [];
      }

      if(this.isMultifamily){
              this.showtext = 'NOTE: This is a multifamily subdivision. Duplicate addresses are allowed.';
              this.isDuplicate = false;
              this.similarLocations = [];
      }

    }


    selectionChangeRebate(value){
      if(value.toLowerCase().includes('duke energy')){
        this.tiers = ['Whole House', 'Whole House Plus', 'Equipment Only', 'ACE', 'ACE + HERS', ''];
      }else {
        this.tiers.length = 0;
      }
    }



    sendAuditEmail(): void {
      this.messager.openSnackBar('Sending audit email...', '', 'successAlert');
      //save Current Data:
      var locObj = this.locationForm.value;
      locObj.plan = this.data.plan;
      locObj.hvac_contractor_id = this.data.hvac_contractor_id;

      const startDate = moment(this.locationForm.get('startdate').value).format('YYYY-MM-DD');
      const closeDate = moment(this.locationForm.get('closedate').value).format('YYYY-MM-DD');
      const permitDate = moment(this.locationForm.get('permitdate').value).format('YYYY-MM-DD');

      locObj.startdate = startDate;
      locObj.closedate = closeDate;
      locObj.permitdate = permitDate;
      this.locationService.saveEdit(this.data.location_id, locObj).subscribe(
        (res) => {

           let changedProperties = [];
            Object.keys(this.locationForm.controls).forEach((name) => {
                const currentControl = this.locationForm.controls[name];

                if (currentControl.dirty) {
                  changedProperties.push(name +': ' + this.locationForm.controls[name].value);
                }
              });

            if(res.Error){
              let errMessage = res.Message;
              //this.messager.openSnackBar('Error saving, an email with all data has been sent to support.', '[close]', 'errorAlert');
              this.ges.sendDebugEmail('IMPORTANT', this.locationForm.value,'Locations', errMessage).subscribe(
                res => {
                  if(res.Error){
                    this.log.error('Error sending debug email for locations page: ' + res.Message)
                  }else {
                    this.log.debug('Debug email sent to support from the locations page.')
                  }
                }, err => {
                  this.log.error('Application error sending debug email: ' + err.toString() );
                })

              this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + res.Message );
            }else {
              this.log.info(this.data.usernamee + ' saved the following edits to location ' + this.data.street_address.trim() + ' {' + changedProperties.toString() + '} with location_id: ' + this.data.location_id  );
            }
        },
        err => {

        this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + err.toString());
        }
      );

    }

    checkForDuplicateSubLot(): void {

      let sub = this.locationForm.get('subdivision_name').value;
      let lot = this.locationForm.get('lot').value;

      if(sub && lot){
        this.locationService.checkDuplicateSubLot(sub,
        lot).subscribe(
          res => {
            if(res.Length > 0){
              this.subtext = 'The subdivision - lot combo already exists! Changing it is recommended.';
              this.subisDuplicate = true;
            } else {
              this.subtext = 'This is a new subdivision - lot combo.';
              this.subisDuplicate = false;
            }
          },err => {

          }
        )
      }
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

    onSelectContractor(contractor: Customer): void {
      this.data.hvac_contractor_id = contractor.customer_id;
      this.hvacDisplay = contractor.customer_name;
      // this.locationForm.get('plan').setValue(plan.plan_id);
      this.locationForm.get('hvac_contractor_id').setValue(contractor.customer_id);
      this.contractorNameInputRef.nativeElement.value = contractor.customer_name;
      //this.planNameInputRef.nativeElement.value = plan.plan_name;
    }

    launchRipple(theRipple: MatRipple) {
      const ripRef = theRipple.launch({
        persistent: true,
        centered: true,
        color: 'lightgreen'
      });
      ripRef.fadeOut();
    }

    longRipple(theRipple: MatRipple) {
      const ripRef = theRipple.launch({
        persistent: true,
        centered: true,
        color: 'lightgreen',
        animation: {
          enterDuration : 1000,
          exitDuration : 2000
        }
      });
      ripRef.fadeOut();
    }

    missingInfoUpdate() {
      //set missing_info form control to disabled
      //this.locationForm.controls['missinginfo'].disable();
      //this.locationForm.controls['missinginfo'].setValue(true);

      this.locationService.setMissingInfo(this.data.location_id).subscribe(
        res => {
          this.messager.openSnackBar('Missing info date set.', '', 'successAlert');
        }, err => {
          this.messager.openSnackBar('Error updating missing info.', '', 'errorAlert');
        });
    }


   updateRebate3() {

    this.locationService.rebate3update(this.data.location_id)
    .subscribe(
      res => {
        this.messager.openSnackBar('Rebate date set.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error updating rebate date.', '', 'errorAlert');
      });

   }

   certPrintedDateUpdate() {
      //set missing info form control to false;
      this.locationForm.controls['missinginfo'].setValue(false);
      //this.locationForm.controls['missinginfo']. = false;
      this.locationService.setCertPrintedDate(this.data.location_id).subscribe(
        res => {
          this.messager.openSnackBar('Certification printed date set.', '', 'successAlert');
        }, err => {
          this.messager.openSnackBar('Error updating certification printed date.', '', 'errorAlert');
        });
    }



    insertESMFNCdata(location_id: number) {
        this.locationService.insertESMFNC(location_id).subscribe(
          res => {
            this.log.info(this.data.usernamee + ' created ESMFNC data for ' + this.data.street_address.trim() + '' );
          }, err => {
          });
    }

    // Which customer the selected track's jobs get created under. Tracks 32 and 35
    // (HVAC Design) are billed to the location's HVAC contractor; every other track uses
    // the builder, exactly as before. Returns 0 when nothing usable is set.
    trackCustomerId(): number {
      const builder = Number(this.locationForm.get('customer_id').value) || 0;
      const trackValue = Number(this.locationForm.get('track').value) || 0;

      if(trackValue !== 32 && trackValue !== 35){
        return builder;
      }

      // this.data.hvac_contractor_id is authoritative: the hvac_contractor_id FormControl
      // is bound straight to the autocomplete <input>, so it holds the typed text until an
      // option is picked. Fall back to the builder when there is no contractor.
      const contractor = (Number(this.data.hvac_contractor_id) || 0)
        || (Number(this.locationForm.get('hvac_contractor_id').value) || 0);

      return contractor > 0 ? contractor : builder;
    }

    // See manageTracks() above — same "wait for the create call before the caller closes the
    // dialog" rationale, applied to the Compliance Track dropdown.
    async manageCompTrack(location_id: number, customer_id: number): Promise<void> {

      const trackValue = this.locationForm.get('comptrack').value;
      switch(trackValue) {
        case 16:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsHeroCustPrelim(location_id, customer_id).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
        break;
        default :
          try {
            const res = await this.locationService.addTrackJobs(trackValue, customer_id, location_id, this.sfTrackObj, this.socketid).toPromise();
            this.handleTrackResponse(res);
          } catch (err) {
            this.handleTrackResponse(null, true);
            this.messager.openSnackBar('Error adding compliance track job, please add manually', '', 'errorAlert');
          }
        break;
      }
    }

    // Returns once the selected track's job-creation call (and, for HVAC Design, the
    // contractor-picker + its creation call) has actually finished, so callers (add()/save())
    // can wait for it before closing the dialog and triggering a jobs-list refresh — otherwise
    // the dialog can close (via the unrelated saveEdit()/addOne() call) before these track jobs
    // exist, and the /locations page's job list never picks them up.
    async manageTracks(location_id: number, customer_id: number): Promise<void> {

      console.log('Managing tracks for track value: ' + this.locationForm.get('track').value);
      let trackValue = this.locationForm.get('track').value;
      const TRUE_TRIAD_ID = 1604;
      const TRUE_TRIAD_HVG_TRACK_ID = 23;
      //const BENSON_VILLAGE_SUBDIVISION_IDs = [4872,3727,4244,1584];

      //if scope is hers + hero  AND hers + hero track is selected, and customer is true triad
      //update track here to true triad hvg hers hero track
      if(customer_id == TRUE_TRIAD_ID && trackValue == 10 && (
        this.data.scope.trim() === 'HERS + HERO' ||
        this.locationForm.get('scope').value === 'HERS + HERO')) {
        trackValue = TRUE_TRIAD_HVG_TRACK_ID;
      }

      switch(trackValue) {
        case 12:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsBeechwood(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 41: // Beechwood Track (HERS + HERO)
          try { this.handleTrackResponse(await this.locationService.addTrackJobsBeechwoodHERSHERO(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 14:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsWaxhawLanding(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 17:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsCentury(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 18:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsTaylorMorrison(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 19:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsBrighton(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 22:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsBlairPlace(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 24:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsRedCedar(location_id, this.sfTrackObj, customer_id).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 25:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsMillCreek(location_id, this.sfTrackObj, customer_id).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 28:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsBratton(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 29:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsMeritageRDUHVG(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 38: // Meritage Homes Coastal
          try { this.handleTrackResponse(await this.locationService.addTrackJobsMeritageCoastal(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 40: // Meritage Homes Coastal (Trips) - id pinned by the 2026-09 migration
          try { this.handleTrackResponse(await this.locationService.addTrackJobsMeritageCoastalTrips(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 31:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsTaylorMorrisonHERSHERO(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 34:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsDRHTRI(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 36:
          try { this.handleTrackResponse(await this.locationService.addTrackJobsDRHTRICode(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 37: // Keen Building Company (card UyFfdPvC)
          try { this.handleTrackResponse(await this.locationService.addTrackJobsKeen(location_id, this.sfTrackObj).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 39: // Carol Golden - customer jobs resolved from the builder at run time
          try { this.handleTrackResponse(await this.locationService.addTrackJobsCarolGolden(location_id, this.sfTrackObj, customer_id).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        case 32: // HVAC Design
        case 35: { // HVAC Design - Existing Customers
          // No contractor popup: the track's jobs are looked up under the location's HVAC
          // Contractor, falling back to the assigned builder when there isn't one.
          const custToUse = this.trackCustomerId();
          try { this.handleTrackResponse(await this.locationService.addTrackJobs(trackValue, custToUse, location_id, this.sfTrackObj, this.socketid).toPromise()); }
          catch (err) { this.handleTrackResponse(null, true); }
          break;
        }
        default:
          try {
            const res = await this.locationService.addTrackJobs(trackValue, customer_id, location_id, this.sfTrackObj, this.socketid).toPromise();
            this.handleTrackResponse(res);
            if (trackValue == 1 || trackValue == 33) {
              this.locationService.setTechForAxis(location_id, trackValue).subscribe();
            }
          } catch (err) { this.handleTrackResponse(null, true); }
          break;
    }
  }


  closeNonExistingModal(){
    const modal = document.getElementById('nonexistentJobsModal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  openTrackWarning() {
    const modal = document.getElementById('nonexistentJobsModal');

    if(modal){
      modal.style.display = 'block';
    }
  }

  handleTrackResponse(res, err=false): void {
    if(res?.Error || err == true){
      this.messager.openSnackBar('Error adding track jobs (job type likely not available for customer) ', '', 'errorAlert');
    }else{
      this.logTrackJobs(res.Data);
      this.messager.openSnackBar('Successfully added track jobs.', '', 'successAlert');
    }

    if(res.NonExistentJobs?.length > 0){
      this.nonexisting_jobs =  res.NonExistentJobs;
      if (Array.isArray(this.nonexisting_jobs)) {
        this.nonexisting_jobs.map(e => e.job_name).join(', ');
      }
    }

    const VCB_SUB_IDS = [4540, 4796];
    let isVCBSubdivision = VCB_SUB_IDS.includes(this.locationForm.get('subdivision').value * 1)

    if(isVCBSubdivision == true){
      this.locationService.addNoteToVCBjobs(res.Data).subscribe(
        res => {
          if(res.Error){
            this.messager.openSnackBar('Error adding construction notes to VCB jobs', '', 'errorAlert');
          }else{
            this.messager.openSnackBar('Note added to VCB jobs (may need to refresh jobs to see)', '', 'successAlert');
          }
        }
      );
    }

  }



    logTrackJobs(arrayjobs: number[]): void {
      arrayjobs.forEach(job_id => {
        this.locationService.logTrackJob(job_id).subscribe(

          res =>{
            let date = res.Data.schedule_date;
            let formattedDate = moment(date).format('MM/DD/YYYY');
            this.log.info(this.data.usernamee + ' put a ' + res.Data.customer_name.trim() + '-' + res.Data.customer_jobtype.trim() + ' on for ' + formattedDate +  ' job_id: ' + job_id );
          }
        );
      })
    }

    add() {

      this.trimAddressFields();

      if (!this.subdivisionIsValid) {
        this.messager.openSnackBar('Select a subdivision from the dropdown before adding.', '', 'errorAlert');
        this.log.warn(this.data.usernamee + ' attempted to add a location with a manually typed subdivision: '
          + this.locationForm.get('subdivision_name').value);
        return;
      }

      this.processTags();
      const tagIds = this.inputTags.map(tag => tag.id);
      this.locationForm.get('tagControl').setValue(tagIds);

      var locObj = this.locationForm.value;
      // Never send the raw control text; only a resolved subdivision (or none) is saved.
      locObj.subdivision = Number(this.locationForm.get('subdivision').value) || 0;
      locObj.subdivision_name = locObj.subdivision > 0 ? (this.theSubdivision || '').toString().trim() : '';
      locObj.plan = this.data.plan;
      // Mirror save(): the form control can hold the typed autocomplete text, so take the
      // resolved id (set by the subdivision cascade or onSelectContractor) as authoritative.
      locObj.hvac_contractor_id = this.data.hvac_contractor_id || 0;

      locObj.startdate = moment(this.locationForm.get('startdate').value).format('YYYY-MM-DD');
      locObj.closedate = moment(this.locationForm.get('closedate').value).format('YYYY-MM-DD');
      locObj.permitdate = moment(this.locationForm.get('permitdate').value).format('YYYY-MM-DD');


      if(this.gasrebatedetails.gasrebate != null){
        locObj.gasrebatedetails = this.gasrebatedetails;
      }
      if(this.electricrebatedetails.elecrebate != null){
        locObj.electricrebatedetails = this.electricrebatedetails;
      }

      if (this.isDuplicate) {
         this.log.warn(this.data.usernamee + ' attempted to add a duplicate location: ' + this.locationForm.get('street_address').value);
         return;
      }

      this.locationService.addOne(locObj).subscribe(
        (res) => {
          if(res.Error){
            this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + res.Message );
          }else {
            this.log.info(this.data.usernamee + ' added a location ' + this.locationForm.get('street_address').value.trim() + ' with location_id: ' + res.LocationId);

                  locObj.location_id = res.LocationId;

                  if(this.swppp_create){
                    this.swpppSave(res.LocationId);
                  }

                  if(this.swppp_remove){
                    this.swpppEnd(res.LocationId);
                  }

                  locObj.folderid = res.FolderId;
                  if(this.locationForm.get('esmfnc').value == true){
                    this.insertESMFNCdata(res.LocationId);
                  }

                  this.locationService.addOneFrontend(locObj);

              // Wait for track job creation to finish before closing, same as save() —
              // otherwise the dialog can close before the new track jobs exist.
              let addTrackPromise: Promise<void> = Promise.resolve();
              let addComptrackPromise: Promise<void> = Promise.resolve();

              // Gate on the customer the track is actually created under, not the builder -
              // an HVAC Design location may have only an HVAC contractor. Unchanged for
              // every other track, where trackCustomerId() IS the builder.
              if(this.locationForm.get('track').value > 0 && this.trackCustomerId() > 0 && !this.paymenthold){
                  addTrackPromise = this.manageTracks(res.LocationId, this.locationForm.get('customer_id').value);
                }

              if(this.locationForm.get('comptrack').value > 0 && this.locationForm.get('customer_id').value > 0 && !this.paymenthold){
                    addComptrackPromise = this.manageCompTrack(res.LocationId, this.locationForm.get('customer_id').value);
                    }

              Promise.all([addTrackPromise, addComptrackPromise]).finally(() => {
                this.dialogRef.close({ location_id: res.LocationId, tracksApplied: true });
              });
              return;
              }
            this.dialogRef.close();
        },
        err => {
          this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + err.toString() );
        }
      );
    }

    save() {
      this.trimAddressFields();

      if (!this.subdivisionIsValid) {
        this.messager.openSnackBar('Select a subdivision from the dropdown before saving.', '', 'errorAlert');
        this.log.warn(this.data.usernamee + ' attempted to save a location with a manually typed subdivision: '
          + this.locationForm.get('subdivision_name').value + ' (location_id: ' + this.data.location_id + ')');
        return;
      }

      if(this.locationForm.get('esmfnc').value == true){
        this.insertESMFNCdata(this.data.location_id);
      }

      this.processTags();
      const tagIds = this.inputTags.map(tag => tag.id);
      if(tagIds.length > 0){
        this.locationForm.get('tagControl').setValue(tagIds);
      }

      var locObj = this.locationForm.value;
      // Untouched legacy rows keep their stored name so an unrelated save doesn't wipe it.
      locObj.subdivision = Number(this.locationForm.get('subdivision').value) || 0;
      locObj.subdivision_name = locObj.subdivision > 0
        ? (this.theSubdivision || '').toString().trim()
        : (this.subdivisionIsLegacyPristine ? this.originalSubdivisionName : '');
      locObj.plan = this.data.plan;
      locObj.hvac_contractor_id = this.data.hvac_contractor_id;
      this.planDirty = this.locationForm.get('plan_name').dirty;

      //if(this.planDirty){
        //this.locationService.resetSFOnForm(this.data.location_id).subscribe();
      //}

      if(this.gasrebatedetails.gasrebate != null){
        locObj.gasrebatedetails = this.gasrebatedetails;
        if(this.rebatedetailsdirty == true){
          if(this.gasrebatedetails.gas_rebate2 == true && this.gasrebatedetails.gas_rebate_2_status.toLowerCase().includes('pass')){
            this.locationService.sendGasRebateEmail(this.data.location_id).subscribe(
              res => {
                this.log.info(this.data.usernamee + ' sent gas rebate email for ' + this.locationForm.get('street_address').value);
              }, err => {
                this.log.error(this.data.usernamee + ' encountered an error sending gas rebate email for ' + this.locationForm.get('street_address').value + ': ' + err.toString() );
              }
            );
          }
        }
      }
      if(this.electricrebatedetails.elecrebate != null){
        locObj.electricrebatedetails = this.electricrebatedetails;
      }

      const startDate = this.locationForm.get('startdate').value != null ? moment(this.locationForm.get('startdate').value).format('YYYY-MM-DD') : null;
      const closeDate = this.locationForm.get('closedate').value != null ? moment(this.locationForm.get('closedate').value).format('YYYY-MM-DD') : null;
      const permitDate = this.locationForm.get('permitdate').value != null ?  moment(this.locationForm.get('permitdate').value).format('YYYY-MM-DD') : null;
      locObj.startdate = startDate;
      locObj.closedate = closeDate;
      locObj.permitdate = permitDate;

      // Kick these off in parallel with the save below, but track their promises so the
      // dialog only closes (and the /locations page only refreshes) once track job creation
      // has actually finished — see manageTracks()/manageCompTrack() above.
      let trackPromise: Promise<void> = Promise.resolve();
      let comptrackPromise: Promise<void> = Promise.resolve();

      if(this.trackChanged){
        // Gate on the resolved track customer, not the builder - see add() above.
        if(this.locationForm.get('track').value > 0 && this.trackCustomerId() > 0 && !this.paymenthold){
            trackPromise = this.manageTracks(this.data.location_id, this.locationForm.get('customer_id').value);
          }
      }

      if(this.comptrackChanged){
        if(this.locationForm.get('comptrack').value > 0 && this.locationForm.get('customer_id').value > 0 && !this.paymenthold){
            comptrackPromise = this.manageCompTrack(this.data.location_id, this.locationForm.get('customer_id').value);
          }
      }


      if(this.swppp_create){
        this.swpppSave(this.data.location_id);
      }

      if(this.swppp_remove){
        this.swpppEnd(this.data.location_id);
      }

      this.locationService.saveEdit(this.data.location_id, locObj).subscribe(
        (res) => {
           let changedProperties = [];
            Object.keys(this.locationForm.controls).forEach((name) => {
                const currentControl = this.locationForm.controls[name];
                if (currentControl.dirty) {
                  changedProperties.push(name +': ' + this.locationForm.controls[name].value);
                }
              });

            if(res.Error){
              let errMessage = res.Message;
              this.messager.openSnackBar('Error saving, an email with all data has been sent to support.', '[close]', 'errorAlert');
              this.ges.sendDebugEmail('IMPORTANT', this.locationForm.value,'Locations', errMessage).subscribe(
                res => {
                  if(res.Error){
                    this.log.error('Error sending debug email for locations page: ' + res.Message)
                  }else {
                    this.log.debug('Debug email sent to support from the locations page.')
                  }
                }, err => {
                  this.log.error('Application error sending debug email: ' + err.toString() );
                })
              this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + res.Message );
            }else {
              this.log.info(this.data.usernamee + ' saved the following edits to location ' + this.data.street_address.trim() + ' {' + changedProperties.toString() + '}' + ' with location_id: ' + this.data.location_id );
              // Wait for any in-flight track job creation to finish before closing, so the
              // caller's afterClosed() refresh actually finds the new jobs.
              Promise.all([trackPromise, comptrackPromise]).finally(() => {
                this.dialogRef.close({ location_id: this.data.location_id, tracksApplied: this.trackChanged || this.comptrackChanged });
              });
            }
        },
        err => {
          this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.locationForm.value.toString() + '} ' + err.toString());
        }
      );
    }

    processTags(){

      //loop through all tags, grab the id and push to id array;
      let idArray = [];
      this.inputTags.forEach(element => idArray.push(element.id));

      //call API function to update tag use count:

      this.locationService.updateTagUseCount(idArray).subscribe(
        res => {
        });
    }

    trackDirty(selectedTrack: any){
      this.trackChanged = true;
      var noDateNeededTracks = [16]; //some track IDs don't need the date popup
      const trackId = selectedTrack;

      //find value in tracks array where id = trackId
      const track = this.tracks.find(track => track.id == trackId);

      const trackType = track.tracktype;

      this.locationForm.get('track').setValue(trackId);

      //open Popup here if selected track is a single family track
      if(((trackType && trackType.toLowerCase().includes('single')) || trackId == 34 || trackId == 36) && !noDateNeededTracks.includes(trackId)){
        this.openTrackDatePicker(selectedTrack);
      }

    }

    // Opens the single-family track first-job date picker, then checks the chosen
    // date against the region's blackout dates. If it's a blackout date the user is
    // prompted ("Schedule anyway" pins the date via sfTrackObj.overrideBlackout;
    // "Pick a different date" re-opens this picker and re-checks). Cancelling the
    // picker (result === 2) clears the track selection and ends the loop.
    openTrackDatePicker(selectedTrack: any){
      const trackId = selectedTrack;

      const dialogRef = this.dialog.open(TrackOptionsComponent, {
        width: '500px',
        data: {track: selectedTrack},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

          // User cancelled the date picker -> clear the track and stop.
          if(result == 2){
            this.locationForm.get('track').setValue(null);
            this.sfTrackObj = {};
            return;
          }

          let pdate = new Date(result.firstjobdate);
          const day = pdate.getUTCDate();
          const month = pdate.getUTCMonth() + 1; // Return Value is 0 indexed
          const year = pdate.getUTCFullYear();
          // Fresh object each pick so a prior "Schedule anyway" can't leak forward.
          this.sfTrackObj = result;
          this.locationForm.get('track').setValue(selectedTrack);
          if(result.firstjobdate){
            // 'YYYY-MM-DD' for the region-level blackout check (built from the
            // picked date's UTC parts, matching how the backend reads it).
            const dateStr = year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
            result.firstjobdate = new Date(month + '/' + day + '/' + year);
            this.log.info(this.data.usernamee + ' selected track: ' + trackId +
            ' for ' + this.data.street_address.trim() +
            ' with location_id: ' + this.data.location_id + ' DATE: ' +  JSON.stringify(result.firstjobdate)
            );
            this.checkTrackBlackoutDate(selectedTrack, dateStr);
          }

      });
    }

    // Region-level blackout check for a track's first job date, mirroring the job
    // add/edit "Schedule anyway" prompt. On a blackout date the user either pins the
    // date (overrideBlackout) or re-opens the picker to choose a different date.
    checkTrackBlackoutDate(selectedTrack: any, dateStr: string){
      this.locationService.checkBlackoutDate(this.data.location_id, dateStr).subscribe(
        res => {
          if(res && !res.Error && res.isBlackout){
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              width: '420px',
              data: {
                title: 'Blackout Date',
                message: `The selected date (${moment.utc(dateStr).format('MM/DD/YYYY')}) is a blackout date`
                  + (res.region ? ` for the ${res.region} region` : '')
                  + `. Would you still like to schedule the first track job on this date?`,
                confirmText: 'Schedule anyway',
                cancelText: 'Pick a different date'
              }
            });
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
              if(confirmed){
                // Pin the first job to the chosen date; backend skips the bump.
                this.sfTrackObj.overrideBlackout = true;
              } else {
                // Re-open the date picker so the user can choose a different date.
                this.openTrackDatePicker(selectedTrack);
              }
            });
          }
          // Not a blackout date -> nothing to do; sfTrackObj already holds the date.
        },
        err => {
          // Fail-open (mirrors the job add/edit page): proceed without prompting;
          // the backend relocates the first job as it does today.
        }
      );
    }

    complianceTrackDirty(){
      this.comptrackChanged = true;
    }


    ekoImport(importId: string): void {
      const ekoModel = {};
      this.ekoIsLoading = true;

      // load ekoproject from ekotrope api
      this.locationService.getEkotropeProject(importId).pipe(
        tap(res => {
          this.locationService.postEkoTropeProject(res.Response).subscribe(
            () => {
              const regid = res.Response.hersRatingDetails.registryId;
              this.data.registryid = regid;
              this.launchRipple(this.regripple);
              this.locationForm.get('registryid').setValue(regid);


              if(this.locationForm.get('registryid').value && this.locationForm.get('registryid').value.toString().trim().length > 1 ){
                this.locationForm.get('rem_done').setValue(true);
              }

              // import utility rates
              res.Response.utilityRates.forEach(element => {
                this.locationService.postEkotropeUtilityRates(res.Response.id, element).subscribe(
                  err => {
                    `${this.data.usernamee} failed to save ${importId} to location ${this.data.street_address.trim()} - ${this.getErrorMessage(err)}`
                  }
                );
              });
            },
            err => {
              this.log.error(
                `${this.data.usernamee} failed to save ${importId} to location ${this.data.street_address.trim()} - ${this.getErrorMessage(err)}`
              );
            }
          );
        }),
        mergeMap(res => {
           const plan = this.locationService.getEkotropePlan(res.Response.masterPlanId);
           const ana = this.locationService.getEkotropePlanAnalysis(res.Response.masterPlanId);
           return forkJoin([plan, ana]);
        }
        )
      ).subscribe(
        res => {
        this.locationService.postEkotropeHousePlan(importId, res[0].Response).subscribe(
          () => {
            this.locationService.postEkotropePlanAnalysis(importId, res[1].Response).subscribe(
              () => {
                this.log.info(this.data.usernamee + ' imported ekotrope project: ' + importId + ' to location ' + this.data.street_address.trim());

                this.messager.openSnackBar('Successfully imported Ekotrope project', '', 'successAlert');
              },
              err => {
                `${this.data.usernamee} failed to save ${importId} to location ${this.data.street_address.trim()} - ${this.getErrorMessage(err)}`
              }
            );
          },
          err => {
            `${this.data.usernamee} failed to save ${importId} to location ${this.data.street_address.trim()} - ${this.getErrorMessage(err)}`
          }
        );

        this.ekoIsLoading = false;
        const hersindecks = res[1].Response.hersScore;
        this.data.hers_index = hersindecks;
        this.launchRipple(this.ripple);
        this.locationForm.get('hers_index').setValue(hersindecks);


      },
      err => {
        `${this.data.usernamee} failed to save ${importId} to location ${this.data.street_address.trim()} - ${this.getErrorMessage(err)}`
        this.messager.openSnackBar('Error with Ekotrope import, please try again..', 'Close', 'errorAlert');
      }
      ); // subsc ribe

    }



    // Pre-registration QA check against the live Ekotrope file. The backend prepends the
    // stamped findings to locmain.qa_review, so we just mirror the returned note locally.
    qaReview(): void {
      if (this.qaReviewLoading) { return; }
      this.qaReviewLoading = true;

      this.locationService.qaReview(this.data.location_id, { reviewer: this.data.usernamee }).subscribe(
        res => {
          this.qaReviewLoading = false;

          if (res.Error) {
            this.messager.openSnackBar(res.message || 'QA review failed', 'Close', 'errorAlert');
            this.log.error(`${this.data.usernamee} failed a QA review on location ${this.data.location_id} - ${res.message}`);
            return;
          }

          this.qaReviewNote = res.note;
          this.data.qa_review = res.note;
          this.showQaReview = true;

          this.dialog.open(QaReviewResultDialogComponent, {
            width: '640px',
            data: {
              checks: res.checks || [],
              findings: res.findings || [],
              naLines: res.naLines || [],
              logId: res.logId
            }
          });

          this.log.info(
            `${this.data.usernamee} ran a QA review on location ${this.data.location_id} - ` +
            `${(res.findings || []).length} finding(s) [qa_log: ${res.logId}]`
          );
        },
        err => {
          this.qaReviewLoading = false;
          this.messager.openSnackBar('Error running QA review, please try again..', 'Close', 'errorAlert');
          this.log.error(`${this.data.usernamee} failed a QA review on location ${this.data.location_id} - ${this.getErrorMessage(err)}`);
        }
      );
    }

    private getErrorMessage(err: any): string {
      if (err.error instanceof ErrorEvent) {
        return `Client error: ${err.error.message}`;
      } else if (err.error && typeof err.error === 'object') {
        return `Server error (${err.status} - ${err.statusText}): ${JSON.stringify(err.error)}`;
      } else if (err.message) {
        return `Error: ${err.message}`;
      }
      return 'Unknown error occurred';
    }

}

// END EDIT LOCATION


@Component({
  selector: 'app-qa-review-result',
  template: `
    <h2 mat-dialog-title style="color:#424242;">QA Review Results</h2>
    <mat-dialog-content style="background:#ffffff; color:#424242;">
      <p *ngIf="!data.findings.length" style="color:#2e7d32; font-weight:500; margin-top:0;">
        No findings &mdash; this file passed every QA check.
      </p>
      <p *ngIf="data.findings.length" style="color:#c62828; font-weight:500; margin-top:0;">
        {{ data.findings.length }} of the checks below did not match.
      </p>

      <table style="width:100%; border-collapse:collapse; font-size:0.9em; color:#424242;">
        <thead>
          <tr style="text-align:left; border-bottom:2px solid #d0d0d0;">
            <th style="padding:6px 8px;">Check</th>
            <th style="padding:6px 8px;">RaterHelper</th>
            <th style="padding:6px 8px;">Ekotrope</th>
            <th style="padding:6px 8px;">Result</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of data.checks"
              [ngStyle]="{ 'background': c.status === 'mismatch' ? '#fdecea' : '#ffffff' }"
              style="border-bottom:1px solid #eeeeee;">
            <td style="padding:6px 8px;">{{ c.check }}</td>
            <td style="padding:6px 8px;">{{ c.rh }}</td>
            <td style="padding:6px 8px;">{{ c.eko }}</td>
            <td style="padding:6px 8px; font-weight:500;"
                [ngStyle]="{ 'color': c.status === 'mismatch' ? '#c62828' : (c.status === 'match' ? '#2e7d32' : '#757575') }">
              <ng-container [ngSwitch]="c.status">
                <span *ngSwitchCase="'mismatch'">Mismatch</span>
                <span *ngSwitchCase="'match'">Match</span>
                <span *ngSwitchDefault>N/A<span *ngIf="c.detail" style="color:#9e9e9e;"> ({{ c.detail }})</span></span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>

      <p style="margin-top:1em; color:#757575; font-size:0.85em;">
        Saved to this location's QA Review notes. [qa_log: {{ data.logId }}]
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" style="background:#ffffff;">
      <button mat-button color="primary" [mat-dialog-close]="1">Close</button>
    </mat-dialog-actions>
  `
})
export class QaReviewResultDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}









@Component({
  selector: 'app-view-job-locations',
  templateUrl: './view-job-locations.html',
  styleUrls: ['./location.component.css']
})
export class ViewJobLocationsComponent implements OnInit {
  generator: any;
  customerJobs: any;
  customersDropdown: boolean = false;
  constructor(public bpo: BreakpointObserver, public dialog: MatDialog, private fb:FormBuilder, public service: LocationService, private messager: MessagerComponent, public contactService: ContactsService, public route: ActivatedRoute, public scheduleService: ScheduleService, public locationService: LocationService, public log: LoggingService, private auth: AuthService) {}

  ngOnInit(){
    this.auth.userProfile$.subscribe(
      (profile) => {
        this.employeeID = this.auth.getEmployeeId();
        this.usernamee = profile ? profile.nickname.charAt(0).toUpperCase() + profile.nickname.slice(1) : '';
      }, err => {
      });

    let locid = this.route.snapshot.paramMap.get('id');
    //let locService = this.service;
        this.service.getJobsForLocation(locid).subscribe(
          res => {
            this.jobs = res.Jobs;
            //this.data.location_id = locid;
            this.service.getOneLocation(locid).subscribe(
              res => {
                //this.data.location = res.Location;
                this.location = res.Location

                this.service.getScope(this.location.subdivision).subscribe(
                  res => {
                    if(res.Error){
                      this.generator = false;
                      this.displayScope = this.location.scope;
                      this.displayScope2 = '';
                      this.displayScope3 = '';
                      this.displayPathway = '';
                      this.displayPathway2 = '';
                      this.displayPathway3 = '';
                      this.displayStories = '';
                      return;
                    }
                    this.generator = res.Scope.generator;
                    // Scope + second scope + the pathways under each, pulled from the subdivision.
                    this.displayScope = res.Scope.scope;
                    this.displayScope2 = res.Scope.scope2;
                    this.displayScope3 = res.Scope.scope3;
                    this.displayPathway = (res.Scope.scope1paths || []).join(', ');
                    this.displayPathway2 = (res.Scope.scope2paths || []).join(', ');
                    this.displayPathway3 = (res.Scope.scope3paths || []).join(', ');
                    this.displayStories = res.Scope.story_type || '';
                  }, err => {
                    this.generator = false;
                    this.displayScope = this.location.scope;
                    this.displayScope2 = '';
                    this.displayScope3 = '';
                    this.displayPathway = '';
                    this.displayPathway2 = '';
                    this.displayPathway3 = '';
                    this.displayStories = '';
                  }
                )
              });
          }, err => {
          });

          this.locationService.getCustomerJobs().subscribe(
            (data) => {
              this.customerJobs = data;
            }, err => {

            });

    // Day state for the Time Functions clock buttons. Uses the lightweight loader,
    // not init() -- init() also pulls the whole schedule grid and throws on a cold
    // deep-link load before app.component's setProfile() has run.
    this.scheduleService.initDayStatuses();

    this.scheduleService.getDayStarted().subscribe(res => { this.daystarted = res; });
    this.scheduleService.getFirstJob().subscribe(res => { this.firstJobDone = res; });
    this.scheduleService.getIsPaused().subscribe(res => { this.isPaused = res; }, err => { this.isPaused = false; });
    this.scheduleService.getIsClockedIn().subscribe(res => { this.isClockedIn = res; }, err => { this.isClockedIn = false; });


   //this.data = this.service.jobsForLoc;
  }

  location;
  usernamee;
  jobs;
  displayScope;
  displayScope2;
  displayScope3;
  displayPathway;
  displayPathway2;
  displayPathway3;
  // Subdivision "Number of Stories" (sbdivisions.story_type), shown next to Pathway.
  displayStories;
  fapaperclip = faPaperclip;
  faedit = faEdit;
  fatrash = faTrashAlt;
  fatags = faTags;
  fahome = faHome;
  modal = false;
  selected;
  facamera = faCamera;
  fahardhat = faHardHat;
  fagoogle = faGoogle;
  faenvelope = faEnvelope;
  faclipboard = faClipboard;
  show = 1;
  fabuilderchklist = faFile;
  fahvac = faCopy;
  fasquare = faPlusSquare;
  faEko = faLeaf;
  fachecksquare = faCheckSquare;
  faflag = faFlag;
  faCalendarCheck = faCalendarCheck;
  faScroll = faScroll;
  facomments = faComments;

  timefunctions = false;
  areTimeButtonsDisabled: boolean;
  daystarted: boolean = false;
  firstJobDone: boolean;
  isClockedIn: boolean;
  isPaused: boolean;
  employeeID: any;


  onLogClick(job, all:boolean = false){

    this.messager.openSnackBar('Loading logs...', '', 'successAlert',10000)
    let dataAll = {
      formData: null,
      unfilteredData: null,
      applogData: null,
      all: all,
      street_address: job.street_address?.trim(),
      customer_jobtype: job.customer_jobtype?.trim() || '',
      customer_name: job.customer_name?.trim() || '',
      location_id: job.location_id
    };

    if(all)
    {
      this.locationService.getFormlogs(job.location_id).subscribe(
        res=>{
          dataAll.formData = res.FormData;
          dataAll.unfilteredData = res.Unfiltered;
          const dialogRef = this.dialog.open(FormLogsComponent, {
            minWidth: '65vw',
            height: '80vh',
            panelClass: 'no-padding',
            data: dataAll
          });
        },
        err=>{}
      )
    }else {
      this.locationService.getFormLogsSingle(job.form_id).subscribe(
        res=>{
          dataAll.formData = res.FormData;
          const dialogRef = this.dialog.open(FormLogsComponent, {
            minWidth: '65vw',
            height: '80vh',
            panelClass: 'no-padding',
            data: dataAll
          });
        })
    }

  }

  openFailNotes(job: any): void {
    const dialogRef = this.dialog.open(ViewFailNotesComponent, {
      width: '60vw',
      height: '60vw',
      data: job,
      panelClass: 'custom-dialog-container',
    });
  }

  epoUpdated(job): void {

    job.eporeqstd = !job.eporeqstd
    this.service.updateEpo(job).subscribe(
      res => {
        this.messager.openSnackBar('EPO status updated!', '', 'successAlert');
      },err => {
        this.messager.openSnackBar('EPO update failed', '', 'errorAlert');
      }
    )

  }



   onPhotosClick(job): void {
     this.messager.openSnackBar('Loading photos taken at this job...', '', 'successAlert');

     this.scheduleService.getRaterPicsOne(job.job_id).subscribe(
      res => {
        if(res.Error){
          if(res.Error.result && res.Error.result.rowCount == 0){
              this.messager.openSnackBar('This job does not have photos yet.', '[close]', 'errorAlert');
          }else {
              this.messager.openSnackBar('An error occurred', '[close]', 'errorAlert');
          }
          return;
        }
        if(!res.Photos || res.Photos.length == 0){
          this.messager.openSnackBar('This job does not have photos yet.', '[close]', 'errorAlert');
          return;
        }
        const transformExif = res.Photos.map((item) => {
          const exifParsed = item.exif && item.exif.length > 0 ? JSON.parse(item.exif[0]) : {};
          return { ...item, exif: exifParsed };
        });
        const loc = this.location || {};
        this.dialog.open(RatingPhotosDialogComponent, {
          minWidth: '100vw',
          height: '100vh',
          panelClass: 'rating-photos-panel',
          data: {
            photos: transformExif,
            job: job,
            location: { street_address: loc.street_address, subdivision_name: loc.subdivision_name, lot: loc.lot, city: loc.city },
            locmain: false
          }
        });
      }, err => {
        this.messager.openSnackBar('An Error occured opening the pictures', '', 'errorAlert');
      })
  }

  openJobForm(job): void {

    this.scheduleService.getRaterformData(job).subscribe(
      (res) => {
        this.log.info(this.usernamee + ' opened the form at ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' ' );
        let jobData = res.formData;
        jobData.job_id = job.job_id;
        jobData.location_id = job.location_id;

        let pics = {} as any;
        let notes = {};
        let formData = {} as any;

        let mod = {} as any;

        let theData = {
          formData : formData,
          pics : pics,
          notes : notes,
          job_id : job.job_id,
          location_id : job.location_id,
          fromLocations : true
        }

        let _self = this;
        // 2.A If we have an id, we've worked on a form for this job, so just pull that data using the id associated with the job.
          this.scheduleService.getRaterPicsAll(job.job_id).subscribe(
            (res)=> {
              // ************************************
              theData.pics = res.Photos[0];
              // ************************************
          this.scheduleService.getDataByFormID(job.form_id).subscribe(
            (res) => {
              //formData = res.formData;
              this.messager.openSnackBar('Loading form... ', '', 'errorAlert');

              // ************************************
              //theData.formData = res.formData;
              // ************************************

              let upd = res.formData;
              upd.plan_id = jobData.plan || 0;
              upd.note = jobData.note || 'No Job Notes';
              upd.loclog = jobData.loclog;
              upd.job_id = job.job_id;
              upd.jobinfo = jobData;
              upd.customer = jobData.customer;


              theData.formData = upd;
              theData.formData.form_id = job.form_id;


                this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                res => {
                  if(res.Rows > 0){
                    theData.notes = res.Notes[0];
                    const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '480px',
                            height: '700px',
                            panelClass: 'custom-dialog-container',
                            data: theData,
                        })

                        dialogRef.afterClosed().subscribe(() => {
                            _self.refreshJobs();
                        });

                  }else {
                    this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                      res => {
                        theData.notes = {};
                        const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '480px',
                            height: '700px',
                            panelClass: 'custom-dialog-container',
                            data: theData
                        }).afterClosed().subscribe(() => {
                          _self.refreshJobs();
                      });
                      })
                   }
                });
                //open form here:
                }, err => {
                  this.messager.openSnackBar('Could not load form: ' + err.message, '', 'errorAlert');
                });

                }, err => {
                  this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
                });


            },
            err => {
              this.log.error(this.usernamee + ' encountered an error opening the form ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' Err: ' + err.toString() );
              this.messager.openSnackBar('No old jobs to load:  ' + err.message, '', 'errorAlert');
            }
          );

  }

  //edit Job Stuff
  openEditJob(job: any, index, isAudit: boolean = false): void {

    let audit = {} as any;
    this.locationService.getOneJob(job.job_id).subscribe(

      res => {
        let isMobile = this.bpo.isMatched('(max-width: 768px)');

        const dialogRef = this.dialog.open(EditJobDialogComponent, {
          disableClose: true,
          data: {
            location: this.location,
            job: job,
            fetchedJob: res.Job,
            cj : this.customerJobs,
            dd : this.customersDropdown,
            mode: EDITING_MODE,
            isAudit: isAudit,
            usernamee: this.usernamee || 'User',
            generator: this.generator,
            // Provide the location's other jobs so the Trip Details tab can offer them as
            // add-able tasks when editing a trip from this (truck) view.
            // Exclude jobs already pointed at ANY trip (trip_id set) — a job can only belong
            // to one trip, so an already-tripped job must not be offered as addable here.
            availableJobs: this.jobs?.filter(j => j.istrip != true && !j.trip_id),
            previousTrips: this.jobs?.filter(j => j.istrip == true),
            // Editing a trip's own status/technician/schedule date cascades that field to
            // every child job (same flag on the /locations and schedule page edits).
            enableTripFieldCascade: true,
          },
          ...(isMobile ? { width: '100vw', height: '100vh' } : { width: '800px', height: '90vh' }),
          panelClass: 'edit-dialog-container',
          autoFocus : false
        });

          dialogRef.afterClosed().subscribe(result => {
            if (result?.tripModeUsed) { this.refreshJobs(); }
          });
      }
    )

  }

  refreshJobs(): void {
    this.service.getJobsForLocation(this.jobs[0].location_id).subscribe(
      res => {
        this.jobs = res.Jobs;
        //this.data.location_id = locid;
        this.service.getOneLocation(this.jobs[0].location_id).subscribe(
          res => {
            //this.data.location = res.Location;
            this.location = res.Location
          },err => {
          });
      }, err => {
      });
  }

  deleteJob(job, row): void {



    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete this ' + job.customer_jobtype.trim() + '?',
        delete_api_url: '/rhAPI/jobEntry/deleteOne/',
        delete_id: job.job_id,
        delete_header_text: 'Deleting ' + job.customer_jobtype.trim()
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.service.deleteJob(job.job_id);
        this.log.info(this.usernamee + ' deleted the ' + job.customer_jobtype + ' with id: ' + job.job_id);
        this.jobs.splice(row, 1);

      }
    });


  }



  openAddJob(isAudit: boolean = false): void {

        console.log(this.location);
        let isMobile = this.bpo.isMatched('(max-width: 768px)');
        const dialogRef = this.dialog.open(EditJobDialogComponent, {
          disableClose: true,
          data: {
            fetchedJob: {},
            location: this.location,
            job: {
              customer_name : 'Customer',
              customer_jobtype : 'Jobtype',
              job_status : 'Scheduled'
            },
            panelClass: 'edit-dialog-container',
            usernamee: this.usernamee || 'User',
            generator: this.generator,
            mode: ADDING_MODE,
            isAudit: isAudit,
          },
          ...(isMobile ?
            { width: '100%', height: '100%', maxWidth: '100vw' } :
            { width: '800px', height: '90vh', position: {left: '50%'} }),
          panelClass: 'edit-dialog-container',
          autoFocus : false
        });
          dialogRef.afterClosed().subscribe(result => {
            this.jobs.push(result.job);
            const deps = { dialog: this.dialog, service: this.service, messager: this.messager, log: this.log, usernamee: this.usernamee };
            promptTripChoiceForNewJob(deps, result, this.location?.location_id, isAudit).subscribe(onTrip => {
              if (onTrip) { this.refreshJobs(); }
            });
          });

  }


  openJobFormLocmain(row, noSave: boolean = false): void {
    this.scheduleService.getRaterformData(row).subscribe(
      (res) => {
        this.log.info(this.usernamee + ' opened the form at ' + row.street_address + '- ' + row.subdivision_name + ' - ' + row.lot);
        let jobData = res.formData;
        jobData.job_id = res.formData.job_id;
        jobData.location_id = row.location_id;

        let pics = {} as any;
        let notes = {};
        let formData = {} as any;

        let theData = {
          formData: res.formData,
          pics: pics,
          notes: notes,
          job_id: res.formData.job_id,
          location_id: row.location_id,
          noSave: noSave,
          fromLocations: true
        }

        theData.formData.jobinfo = {};
        theData.formData.jobinfo.customer_jobtype = 0;

        this.scheduleService.getRaterPicslocmainRF(row.locpics_id).subscribe(
          (res) => {
            theData.pics = res.Photos;
            this.scheduleService.getDataByFormID(row.form_id).subscribe(
              (res) => {
                this.messager.openSnackBar('Loading form... ', '', 'errorAlert');

                let upd = res.formData;
                upd.plan_id = jobData.plan || 0;
                upd.note = jobData.note || 'No Job Notes';
                upd.loclog = jobData.loclog;
                upd.job_id = jobData.job_id;
                upd.jobinfo = jobData;
                upd.customer = jobData.customer;

                theData.formData = upd;
                theData.formData.form_id = row.form_id;

                this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                  res => {
                    if (res.Rows > 0) {
                      theData.notes = res.Notes[0];
                      const dialogRef = this.dialog.open(RaterformComponent, {
                        width: '100vw',
                        height: '100vh',
                        data: theData,
                        panelClass: ['custom-dialog-container', 'raterform-fit'],
                        autoFocus: false
                      });
                      dialogRef.afterClosed().subscribe(result => {
                        this.refreshJobs();
                      });
                    } else {
                      this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                        res => {
                          theData.notes = {};
                          const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '100vw',
                            height: '100vh',
                            data: theData,
                            panelClass: ['custom-dialog-container', 'raterform-fit'],
                            autoFocus: false
                          });
                          dialogRef.afterClosed().subscribe(result => {
                            this.refreshJobs();
                          });
                        }, err => {
                        });
                    }
                  }, err => {
                  });
              }, err => {
                this.messager.openSnackBar('Could not load form: ' + err.message, '', 'errorAlert');
              });
          }, err => {
            this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
          });
      },
      err => {
        this.log.error(this.usernamee + ' encountered an error opening the form ' + row.street_address + '- ' + row.subdivision_name + ' - ' + row.lot + ' Err: ' + err.toString());
        this.messager.openSnackBar('No old jobs to load: ' + err.message, '', 'errorAlert');
      }
    );
  }

  copyJob(job){

    //prompt user to confirm
    let dialogRef;
    if(job.customer_jobtype.trim().toLowerCase().includes('final') && job.job_status.trim().toLowerCase().includes('pass') && !(job.customer_name.toLowerCase().includes('gps')) && !(job.customer_jobtype.toLowerCase().includes('audit'))  ){
      dialogRef =  this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
            warning_title: 'Duplicate Final Warning',
            warning_description: '',
            warning_sub: 'You are attempting to create a duplicate final for a home in which the Final has already been marked Pass (and registered with Resnet). This is not recommended based upon our quality assurance standards.',
            confirmText: 'Continue',
            cancelText: `Don't Copy`,
            showCancelButton: true
        }
      });
      //this.messager.openSnackBar('You cannot copy a completed final job.', '', 'errorAlert');
    }else {
      dialogRef = this.dialog.open(GridDeleteComponent, {
        width: '500px',
        data: {
          delete_body_text: 'Are you sure you want to copy this ' + job.customer_jobtype.trim() + '?',
          delete_api_url: '',
          delete_header_text: 'Copying ' + job.customer_jobtype.trim(),
          isDelete: false
        }
      });
    }


    dialogRef.afterClosed().subscribe(result => {
      ////console.log(result);
      if (result === 1) {
        this.log.info(this.usernamee + ' copied the ' + job.customer_jobtype + ' with id: ' + job.job_id);
        this.service.copyJob(job.job_id).subscribe(
          res => {
            // Subscribe to the Observable returned by pushJob
            this.pushJob(res.job).subscribe(updatedJob => {
              this.jobs.push(updatedJob);
              this.messager.openSnackBar('Job copied!', '', 'successAlert');
            });
          }, err => {
            this.messager.openSnackBar('Error copying job: ' + err, '', 'errorAlert');
          }
        );
      }
    });

  }

  pushJob(job){
    // Return the Observable from this method
    return new Observable(observer => {
      this.service.getJobDisplayDetails(job).subscribe(res =>{
        ////console.log(res);
        job.customer_name = res.CustomerName.customer_name;
        job.employee_name = res.EmployeeName.employee_name;
        job.name = res.ContactName.name;
        ////console.log(job);
        // Notify subscribers that the job has been updated
        observer.next(job);
        observer.complete();
      }, err => {
        ////console.log('Error:', err);
        // You can also pass the job object back in case of error if needed
        observer.next(job);
        observer.complete();
      });
    });
  }

  isParticipant(participants, empID): boolean{
    return participants? participants.includes(empID) : false;
  }

  // Copied from LocationComponent, minus its document.getElementById('timeButtons').click()
  // repaint workaround -- that exists only because LocationComponent is OnPush; this
  // component uses default change detection, so mutating job.clockedin repaints on its own.
  updateStartTimeNew(job) {

    this.areTimeButtonsDisabled = true;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.messager.openSnackBar('Clocking in...', '', 'successAlert');


    if(this.daystarted){

      this.scheduleService.updateStartTime(job, this.employeeID, timezone).subscribe(
        res => {
          if(res.Error){
            this.messager.openSnackBar('Error: ' + res.Message, '', 'errorAlert');
            this.log.error(this.usernamee + 'attempted to clocked into ' + job.job_id + "Error: " + res.Message );
            this.areTimeButtonsDisabled = false;
          } else {
            //update first job status
            if(this.firstJobDone == false){

            this.log.info(this.usernamee + ' clocked into their FIRST JOB.');
              this.scheduleService.updateTimeToFirstJob(this.employeeID, res.Date, timezone).subscribe(
                (res) => {
                  this.firstJobDone = true;
                  this.areTimeButtonsDisabled = false;

                }, err => {
                  this.messager.openSnackBar('Error occurred. This has been logged', '', 'errorAlert');
                  this.log.info(this.usernamee + ' experienced an error clocking into their first job: '+ err);
                  this.areTimeButtonsDisabled = false;

                }
              )

            }else {
              //update travel time.
              this.scheduleService.updateTravelTime(this.employeeID, res.Date, timezone).subscribe(
                res => {

                  this.areTimeButtonsDisabled = false;
                }, err => {
                  this.log.info(this.usernamee + ' experienced an error updating travel time to : ' + job.job_id + ' ' + err);
                  this.areTimeButtonsDisabled = false;

                }
              )
            }

            job.clockedin = true;
            job.starttime = res.Date;
            this.messager.openSnackBar('Clocked In', '', 'successAlert');
            this.log.info(this.usernamee + ' clocked into ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);

            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);

              }, err => {
                this.log.info(this.usernamee + ' experienced an error becoming a participant of : ' + job.job_id + ' ' + err);
              }
            )
          }
        },
        err => {
          this.messager.openSnackBar('Could not clock in: ' + err, '', 'errorAlert');
          this.areTimeButtonsDisabled = false;

        }
      );

    }else {
      this.messager.openSnackBar('Please start your day first', '', 'errorAlert');
      this.areTimeButtonsDisabled = false;
    }

  }

  updateEndTimeNew(job) {
    this.areTimeButtonsDisabled = true;
    this.messager.openSnackBar('Clocking out...', '', 'successAlert');


    //check to make sure no one is clocked in

      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      //update time file for this job
      this.scheduleService.updateEndTime(job, this.employeeID, timezone).subscribe(
      res => {

        if(!res.Error){

          job.clockedin = false;
          this.messager.openSnackBar('Clocked Out! Time on job: ' + (res.Total.hours || '00' + ' hour(s) ') + (typeof res.Total.minutes === 'undefined' ? '' : (res.Total.minutes + " min")) + " " + res.Total.seconds + " sec", '', 'successAlert');
          this.log.info(this.usernamee + ' clocked out of ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);
          this.areTimeButtonsDisabled = false;

          //add total time to 'jobtime' in 'day' entry in table AND update lastClockout
            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                this.areTimeButtonsDisabled = false;
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);

              }, err => {
                this.areTimeButtonsDisabled = false;
                this.log.error(this.usernamee + 'experienced an api error attempting to clock out of ' + job.job_id + "Error: " + err);
              }
            )
        }else {
          this.areTimeButtonsDisabled = false;
          this.log.error(this.usernamee + 'attempted to clock out of ' + job.job_id + "Error: " + res.Message);
        }



      },
      err => {
        this.messager.openSnackBar('Could not clock out: ' + err, '', 'errorAlert');
        this.areTimeButtonsDisabled = false;
      }
    );

    this.scheduleService.getIsClockedIn().subscribe(
      res => {
        this.isClockedIn = res;
      }, err => {
        this.isClockedIn = false;
      }
    );

  }

  viewTimeCard(): void {

    this.messager.openSnackBar('Loading timecard...', '', 'successAlert');
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.scheduleService.getTodaysTimecard(this.employeeID, timezone).subscribe(
      res => {
        let jobs = res.Data;
        this.scheduleService.getDayInfo(this.employeeID, timezone).subscribe(
          res => {
            const dialogRef = this.dialog.open(TimeCardDialogComponent, {
              minWidth: '90vw',
              height: '90vh',
              data : {
                jobs: jobs,
                day : res.Data,
                from : 'location',
                canEditTimes:false
              }
            });
          }, err => {

          }
        )
      }, err => {
      }
    )

  }

  // Opens the server-rendered Extra Notes feed for this location in a new tab.
  // URL construction is shared with the Locations grid and the /extra-notes/:id
  // bounce route so posts are attributed under one consistent `usernamee`.
  openExtraNotes(row): void {
    const url = buildExtraNotesUrl(
      environment.baseUrl,
      row.location_id,
      this.usernamee,
      this.auth.getEmployeeId()
    );
    window.open(url, '_blank');
  }
}

@Component({
  selector: 'app-location',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  @ViewChild('table', { static: false}) table: APIDefinition;

  public configuration: Config;
  public columns: Columns[];
  public toggledRows = new Set<number>();

  private socket: any;
  _socketID_ : any;

  public guiLocked = false;

  editData;
  editJobData;

  //for holding csv file content
  filecontentUpdater :any;
  csvselected = 'option0';
  vendorSuiteCustomerId: number = null;
  uploaderCustomers: any[] = [];

  moreSearchOpened = false; //for advance search

  updaterFilename = '';
  usernamee;
  user;
  displayScope;
  // Second and third scopes + the pathways under each, pulled from the subdivision
  // like displayScope.
  displayScope2;
  displayScope3;
  displayPathway;
  displayPathway2;
  displayPathway3;
  // Subdivision "Number of Stories" (sbdivisions.story_type), shown next to Pathway.
  displayStories;
  timefunctions = false;

  deepsearchOn = false;

  fapaperclip = faPaperclip;
  faedit = faEdit;
  faScroll = faScroll;
  facomments = faComments;
  fatrash = faTrashAlt;
  fatags = faTags;
  fahome = faHome;
  faflag = faFlag;
  modal = false;
  selected;
  facamera = faCamera;
  fahardhat = faHardHat;
  fagoogle = faGoogle;
  faenvelope = faEnvelope;
  faclipboard = faClipboard;
  show = 1;
  fabuilderchklist = faFile;
  fahvac = faCopy;
  faclone = faClone;
  fasquare = faPlusSquare;
  faEko = faLeaf;
  fachecksquare = faCheckSquare;
  facheckcircle = faCheckCircle;
  faexclamationtriangle = faExclamationTriangle;
  tripsView = false;
  customersDropdown = false;
  filterOutGPSJobs: number = 0;

  @Input() allLoadedIn: Observable<any>;

  allLoaded = false;


  location$: Observable<Location[]>;

  // location_ids that have at least one live Extra Notes post. Refreshed every time the
  // grid stream emits (initial load, All Locations Loaded, searches) so the green
  // Extra Notes button stays current without a per-row query.
  notedLocationIds = new Set<number>();
  private notedLocationsLoading = false;
  allLocation$: Observable<Location[]>;
  allLoaded$: Observable<boolean>;



  @ViewChild('streetname', { read: false, static: false}) streetNameInputRef: ElementRef;



  job$: Observable<any[]>;
  addresse$: Observable<any[]>;
  subdivision$: Observable<any[]>;
  streetname$: Observable<any[]>;
  registeryid$: Observable<any[]>;
  invoiceno$: Observable<any[]>;
  ponumber$: Observable<any[]>;
  builder$: Observable<any[]>;

  pagename: string;
  jobLoading$: Observable<boolean>;
  private baseURL = environment.baseUrl;
  thermalRequired: boolean;
  plan$: Observable<unknown>;
  customerJobs: any;
  generator: boolean;
  jobTags: any;
  loadingJobs: boolean = false;
  areTimeButtonsDisabled: boolean;
  daystarted: boolean = false;
  firstJobDone: boolean;
  isClockedIn: boolean;
  isPaused: boolean;
  employeeID: any;
  breakpointobserver: any;
  useNewPhotoPopup: boolean = false;
  headers: any;
  nonexisting_jobs: any[] = [];
  currentlyViewedJobs: any[];
  ismultifamily: boolean = false;


  constructor(public bpo: BreakpointObserver, private _snackBar: MatSnackBar, public locationService: LocationService, public tagService: TagService, public messager: MessagerComponent, public dialog: MatDialog, private fb: FormBuilder, private cd: ChangeDetectorRef, private auth: AuthService, public log: LoggingService, private scheduleService: ScheduleService, private router: Router,public snackbarComponent : UploadSnackBarComponent) {
    this.socket = io(this.baseURL)
  }

  form = new FormGroup({
    safilter: new FormControl(''),
    subfilter: new FormControl(''),
    registeryfilter: new FormControl(''),
    invoicefilter: new FormControl(''),
    pofilter: new FormControl(''),
    builderfilter: new FormControl(''),
    planfilter: new FormControl(''),
  });

  // Deep-search mode for the whole panel. 'starts' keeps the historical prefix-anchored
  // behavior; 'contains' is a substring match ("Sun Valley" finds "Trailside at Sun Valley");
  // 'fuzzy' adds trigram similarity on top of contains, so typos/gaps still match.
  // Session-only by design (resets to 'starts' on load) — no persistence.
  searchMode: 'starts' | 'contains' | 'fuzzy' = 'starts';
  private searchMode$ = new BehaviorSubject<string>('starts');

  // Contains/fuzzy over a 231k-row unindexed table: a 1-char term matches nearly everything,
  // so don't fire the autocomplete until there's enough of a term to be selective.
  private readonly MIN_LEN_BROAD = 3;

  private meetsMinLength(value: any): boolean {
    const len = (value == null ? '' : String(value)).length;
    return this.searchMode === 'starts' ? len > 0 : len >= this.MIN_LEN_BROAD;
  }

  onSearchModeChange(mode: 'starts' | 'contains' | 'fuzzy'): void {
    if (!mode || mode === this.searchMode) { return; }
    this.searchMode = mode;
    // Re-runs whatever is currently typed against the new mode, so flipping the toggle
    // shows results immediately instead of waiting for another keystroke.
    this.searchMode$.next(mode);
  }

    onSelectAddressFilterManual (name): void {

    let newArray = [];
    this.locationService.updateViewStreetAddressManual(name, this.searchMode).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res);
      }, err => {
      });


    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;
  }

  onSelectRegisteryIdManual (name): void {

    let newArray = [];

    this.locationService.updateRegisteryIdManual(name, this.searchMode).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res);
      }, err => {
      });


    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;


  }

  onSelectAddressFilter(value): void {

    let newArray = [];
    newArray.push(value);

    this.locationService.updateViewStreetAddress(newArray);
    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;


  }

  openTagsDialog(): void {

    const dialogRef = this.dialog.open(TagsDialogComponent, {
      width: '40vw',
      height: '70vh',
      data: {
        usernamee: this.usernamee || 'User',
      },
      autoFocus : false
  })

  }

  onSelectRegisteryId(value): void {

    let newArray = [];
    newArray.push(value);

    this.locationService.updateViewStreetAddress(newArray);

    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;


  }

  viewTimeCard(): void {

    this.messager.openSnackBar('Loading timecard...', '', 'successAlert');
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.scheduleService.getTodaysTimecard(this.employeeID, timezone).subscribe(
      res => {
        let jobs = res.Data;
        this.scheduleService.getDayInfo(this.employeeID, timezone).subscribe(
          res => {
            const dialogRef = this.dialog.open(TimeCardDialogComponent, {
              minWidth: '90vw',
              height: '90vh',
              data : {
                jobs: jobs,
                day : res.Data,
                from : 'location',
                canEditTimes:false 
              }
            });
          }, err => {

          }
        )
      }, err => {
      }
    )

  }

  toggleDropdown(): void {
    this.customersDropdown = !this.customersDropdown;
  }

  toggleNewPhotoPopup(): void {
    this.useNewPhotoPopup = !this.useNewPhotoPopup;
  }

  onSelectInvoiceNo(value): void {

    let newArray = [];
    newArray.push(value);

    this.locationService.updateViewStreetAddress(newArray);

    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;
  }

  onSelectPoNumber(value): void {

    let newArray = [];
    newArray.push(value);

    this.locationService.updateViewStreetAddress(newArray);

    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;
  }



  onSelectInvoiceNoManual (name): void {

    let newArray = [];

    this.locationService.updateInvoiceNoManual(name, this.searchMode).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res);
      }, err => {
      });


    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;
  }


  onSelectInvoicePoManual (name): void {

    let newArray = [];

    this.locationService.updatePoNumberoManual(name, this.searchMode).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res);
      }, err => {
      });


    this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });
    this.toggledRows.clear();
    this.guiLocked = true;
  }


  updateStartTimeNew(job) {

    this.areTimeButtonsDisabled = true;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.messager.openSnackBar('Clocking in...', '', 'successAlert');


    if(this.daystarted){

      this.scheduleService.updateStartTime(job, this.employeeID, timezone).subscribe(
        res => {
          if(res.Error){
            this.messager.openSnackBar('Error: ' + res.Message, '', 'errorAlert');
            this.log.error(this.usernamee + 'attempted to clocked into ' + job.job_id + "Error: " + res.Message );
            this.areTimeButtonsDisabled = false;
          } else {
            //update first job status
            if(this.firstJobDone == false){

            this.log.info(this.usernamee + ' clocked into their FIRST JOB.');
              this.scheduleService.updateTimeToFirstJob(this.employeeID, res.Date, timezone).subscribe(
                (res) => {
                  this.firstJobDone = true;
                  this.areTimeButtonsDisabled = false;
                  document.getElementById('timeButtons').click();


                }, err => {
                  this.messager.openSnackBar('Error occurred. This has been logged', '', 'errorAlert');
                  this.log.info(this.usernamee + ' experienced an error clocking into their first job: '+ err);
                  this.areTimeButtonsDisabled = false;

                }
              )

            }else {
              //update travel time.
              this.scheduleService.updateTravelTime(this.employeeID, res.Date, timezone).subscribe(
                res => {

                  document.getElementById('timeButtons').click();

                  this.areTimeButtonsDisabled = false;
                  //this.cd.detectChanges();
                }, err => {
                  this.log.info(this.usernamee + ' experienced an error updating travel time to : ' + job.job_id + ' ' + err);
                  this.areTimeButtonsDisabled = false;

                }
              )
            }

            job.clockedin = true;
            job.starttime = res.Date;
            this.messager.openSnackBar('Clocked In', '', 'successAlert');
            this.log.info(this.usernamee + ' clocked into ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);

            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);

                document.getElementById('timeButtons').click();

                //this.cd.detectChanges();
              }, err => {
                this.log.info(this.usernamee + ' experienced an error becoming a participant of : ' + job.job_id + ' ' + err);
              }
            )
          }
        },
        err => {
          this.messager.openSnackBar('Could not clock in: ' + err, '', 'errorAlert');
          this.areTimeButtonsDisabled = false;

        }
      );

    }else {
      this.messager.openSnackBar('Please start your day first', '', 'errorAlert');
      this.areTimeButtonsDisabled = false;
    }

  }



  isParticipant(participants, empID): boolean{
    return participants? participants.includes(empID) : false;
  }

  updateEndTimeNew(job) {
    this.areTimeButtonsDisabled = true;
    this.messager.openSnackBar('Clocking out...', '', 'successAlert');


    //check to make sure no one is clocked in

      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      //update time file for this job
      this.scheduleService.updateEndTime(job, this.employeeID, timezone).subscribe(
      res => {

        if(!res.Error){

          job.clockedin = false;
          this.messager.openSnackBar('Clocked Out! Time on job: ' + (res.Total.hours || '00' + ' hour(s) ') + (typeof res.Total.minutes === 'undefined' ? '' : (res.Total.minutes + " min")) + " " + res.Total.seconds + " sec", '', 'successAlert');
          this.log.info(this.usernamee + ' clocked out of ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);
          this.areTimeButtonsDisabled = false;

          //add total time to 'jobtime' in 'day' entry in table AND update lastClockout
            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                this.areTimeButtonsDisabled = false;
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);

                //for some reason, it doesn't update GUI unless it's clicked.
                //change detection didn't seem to work, so used this workaround.
                document.getElementById('timeButtons').click();

              }, err => {
                this.areTimeButtonsDisabled = false;
                this.log.error(this.usernamee + 'experienced an api error attempting to clock out of ' + job.job_id + "Error: " + err);
              }
            )
        }else {
          this.areTimeButtonsDisabled = false;
          this.log.error(this.usernamee + 'attempted to clock out of ' + job.job_id + "Error: " + res.Message);
        }



      },
      err => {
        this.messager.openSnackBar('Could not clock out: ' + err, '', 'errorAlert');
        this.areTimeButtonsDisabled = false;
      }
    );

    this.scheduleService.getIsClockedIn().subscribe(
      res => {
        ////console.log(res);
        this.isClockedIn = res;
      }, err => {
        this.isClockedIn = false;
      }
    );

  }



  onSelectBuilderNo(value): void {

    //this.form.get('builderfilter').setValue(value.customer_name);

    this.locationService.getCompanyLocations(value.customer_id).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res.Locations);
        this.messager.openSnackBar('Found ' + res.Locations.length + ' locations for this builder.', '', 'successAlert');
        this.deepsearchOn = true;
        this.toggledRows.forEach(e => {
        this.table.apiEvent({
              type: API.toggleRowIndex,
              value: e
            });
            this.toggledRows.delete(e);
          });
        this.toggledRows.clear();
        this.guiLocked = true;
      }, err => {
        this.messager.openSnackBar('Cannot find any locations for this builder', '', 'errorAlert');
      }

    )


  }




  //
  onSelectPlanNo(value): void {

    this.locationService.getPlansLocations(value).subscribe(
      res => {
        if(res.length == 0) {
          this.messager.openSnackBar('Cannot find any locations associated with this plan', '', 'errorAlert');
        }else {
          this.locationService.updateViewStreetAddress(res);
          this.messager.openSnackBar('Found ' + res.length + ' locations associated with this plan.', '', 'successAlert');
          this.deepsearchOn = true;
          this.toggledRows.forEach(e => {
          this.table.apiEvent({
                type: API.toggleRowIndex,
                value: e
              });
              this.toggledRows.delete(e);
            });
          this.toggledRows.clear();
          this.guiLocked = true;
        }}, err => {
          this.messager.openSnackBar('Cannot find any locations associated with this plan', '', 'errorAlert');
        }
    )

  }

  showTECinfo(row): void {

    let snackB = this._snackBar.open('Initialed By ' + row.builder_initials + ' on ' + row.tec_date.substring(0,10), 'close');
    snackB.onAction().subscribe(() => {
      snackB.dismiss();
    });

  }



  onPhotosClickLocmain(row): void {

    if(this.useNewPhotoPopup){
      window.open('https://rh-photo-gallery.vercel.app/photos/' + row.locpics_id + '/' + row.location_id,  '_blank');
    }else {
      this.messager.openSnackBar('Loading photos for location...', '', 'successAlert');
      this.scheduleService.getRaterPicslocmain(row.locpics_id).subscribe(
        res => {
            const photosArray = Object.keys(res.Photos).map(key => ({
                name: key,
                image: res.Photos[key]
            }));

            res.Photos.locmain = true;
            const dialogRef = this.dialog.open(RatingPhotosDialogComponent, {
              minWidth: '100vw',
              height: '100vh',
              panelClass: 'rating-photos-panel',
              data: {
                photos : photosArray,
                job: row
              },
            });
        }, err => {

        })
    }

  }



  deleteJob(job, row): void {

    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete this ' + job.customer_jobtype.trim() + '?',
        delete_api_url: '/rhAPI/jobEntry/deleteOne/',
        delete_id: job.job_id,
        delete_header_text: 'Deleting ' + job.customer_jobtype.trim()
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.locationService.deleteJob(job.job_id);
        this.log.info(this.usernamee + ' deleted the ' + job.customer_jobtype + ' with id: ' + job.job_id);
      }
    });

  }


  sendResultsEmail(job, loc): void {
    const dialogRef = this.dialog.open(GridEmailComponent, {

      width: '500px',
      data: {
        usernamee : this.usernamee,
        job: job,
        loc: loc,
      }
    });
  }



  onSelectSubFilterManual(value): void {


    let newArray = [];

    this.locationService.updateViewSubdivisionManual(value, this.searchMode).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res.Locations);
      }, err => {
      });


    this.deepsearchOn = true;

      this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });

    this.toggledRows.clear();
    this.guiLocked = true;


  }


  openFlags(row, index): void {

    this.locationService.getOneLocation(row.location_id).subscribe(
      (tdata: any) => {
        const dialogRef = this.dialog.open(FlagsDialogComponent, {
          height: '80vh',
          width: '85vw',
          data: {
            location_id: tdata.Location.location_id,
            subdivision: tdata.Location.subdivision,
            subdivision_name: tdata.Location.subdivision_name,
            lot: tdata.Location.lot,
            street_address: tdata.Location.street_address,
            city: tdata.Location.city,
            state: tdata.Location.state,
            zip: tdata.Location.zip,
            cert_printed: tdata.Location.cert_printed,
            taxcred: tdata.Location.taxcred,
            disclosuresent: tdata.Location.disclosuresent,
            emailedbuilder: tdata.Location.emailedbuilder,
            hvacovrd: tdata.Location.hvacovrd,
            elevleft: tdata.Location.elevleft,
            rebate2: tdata.Location.rebate2,
            rebate1: tdata.Location.rebate1,
            missinginfo: tdata.Location.missinginfo,
            cfsent: tdata.Location.cfsent,
            esmfnc : tdata.Location.esmfnc,
            rebate3: tdata.Location.rebate3,
            rem_done: tdata.Location.rem_done,
            roughnotice : tdata.Location.roughnotice,
            roughreport : tdata.Location.roughreport,
            finalnotice : tdata.Location.finalnotice,
            finalreport : tdata.Location.finalreport,
        		adminarchive : tdata.Location.adminarchive,
        		rebate2stat : tdata.Location.rebate2stat,
            mfplanoverride: tdata.Location.mfplanoverride,
            ekotrope_id: tdata.Location.ekotrope_id,
            registryid : tdata.Location.registryid,
            hers_index : tdata.Location.hers_index,
            adminnotes : tdata.Location.adminnotes,
            gasrebate : tdata.Location.gasrebate,
            elecrebate : tdata.Location.elecrebate,
            gasrebatedetails : tdata.Location.gasrebatedetails,
            electricrebatedetails : tdata.Location.electricrebatedetails,
            threetenrep : tdata.Location.threetenrep,
            refrigpw : tdata.Location.refrigpw,
            targetset : tdata.Location.targetset,
            usernamee : this.usernamee || 'User',
            qa_review : tdata.Location.qa_review,
            hvac_dr_request : tdata.Location.hvac_dr_request,
          },
          panelClass: 'edit-dialog-container'
        });

      }
    )

  }


  onSelectSubFilter(value): void {

    //lock GUI
    this.guiLocked = true;

    this.locationService.getSubFilter(value.subdivision_name).subscribe(
      res => {
        this.locationService.updateViewStreetAddress(res.Locations);
      }, err => {
        this.messager.openSnackBar('Subdivision search failed.', '[close]', 'errorAlert')
      })

    this.deepsearchOn = true;

      this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });

    this.toggledRows.clear();


  }

  displayFunctionSAfilter(obj: any){
    if (obj) {return obj.street_address; }
  }

  displayFunctionSubfilter(obj: any){
    if (obj) {return obj.subdivision_name; }
  }

  displayFunctionRegfilter(obj: any){
    if (obj) {return obj.registryid; }
  }

  displayFunctionInvofilter(obj: any){
    if (obj) {return obj.invoice_number; }
  }
  displayFunctionPofilter(obj: any){
    if (obj) {return obj.po_number; }
  }

  displayFunctionBuilderfilter(obj:any){
    if (obj) {return obj.customer_name; }
  }

  displayFunctionPlanfilter(obj:any){
    if (obj) {return obj.plan_name; }
  }


  openDialog(myData): void {

    this.locationService.getOneLocation(myData.location_id).subscribe(
      (tdata: any) => {
        const dialogRef = this.dialog.open(EditLocationDialogComponent, {
          height: '850px',
          width:  '750px',
          data: {
            location_id: tdata.Location.location_id,
            subdivision: tdata.Location.subdivision,
            subdivision_name: tdata.Location.subdivision_name,
            lot: tdata.Location.lot,
            street_address: tdata.Location.street_address,
            city: tdata.Location.city,
            state: tdata.Location.state,
            zip: tdata.Location.zip,
            plan: tdata.Location.plan,
            plan_name: tdata.Location.plan_name,
            site_notes: tdata.Location.site_notes,
            cert_printed: tdata.Location.cert_printed,
            hers_index: tdata.Location.hers_index,
            ratingtool: tdata.Location.ratingtool,
            taxcred: tdata.Location.taxcred,
            ratingtypeuse: tdata.Location.ratingtypeuse,
            disclosuresent: tdata.Location.disclosuresent,
            hvac_design_id: tdata.Location.hvac_design_id,
            permit_no: tdata.Location.permit_no,
            registryid: tdata.Location.registryid,
            adminnotes: tdata.Location.adminnotes,
            pdwdone: tdata.Location.pdwdone,
            emailedbuilder: tdata.Location.emailedbuilder,
            runnumber: tdata.Location.runnumber,
            jurs_id: tdata.Location.jurs_id,
            taxparcel: tdata.Location.taxparcel,
            hvac_contractor_id: tdata.Location.hvac_contractor_id,
            hvac_done: tdata.Location.hvac_done,
            hvacnotes: tdata.Location.hvacnotes,
            hvacerrors: tdata.Location.hvacerrors,
            builder_done: tdata.Location.builder_done,
            builder_initials: tdata.Location.builder_initials,
            tec_date: tdata.Location.tec_date,
            hvacovrd: tdata.Location.hvacovrd,
            reviewcomplete: tdata.Location.reviewcomplete,
            savings: tdata.Location.savings,
            elevback: tdata.Location.elevback,
            elevfront: tdata.Location.elevfront,
            elevright: tdata.Location.elevright,
            elevleft: tdata.Location.elevleft,
            closedate: tdata.Location.closedate,
            adminarchive: tdata.Location.adminarchive,
            sbmt_dsn_id: tdata.Location.sbmt_dsn_id,
            hvacresubmt: tdata.Location.hvacresubmt,
            rebate2: tdata.Location.rebate2,
            rebate1: tdata.Location.rebate1,
            rem_done: tdata.Location.rem_done,
            loclog: tdata.Location.loclog,
            weatherloc: tdata.Location.weatherloc,
            ekotrope_id: tdata.Location.ekotrope_id,
            roughnotice: tdata.Location.roughnotice,
            roughreport: tdata.Location.roughreport,
            finalnotice: tdata.Location.finalnotice,
            finalreport: tdata.Location.finalreport,
            missinginfo: tdata.Location.missinginfo,
            scope: tdata.Location.scope,
            contacts: tdata.Location.contacts,
            permitdate: tdata.Location.permitdate,
            final_done: tdata.Location.final_done,
            cfsent: tdata.Location.cfsent,
            countyform: tdata.Location.countyform,
            billing_notes: tdata.Location.billing_notes,
            startdate: tdata.Location.startdate,
            folderid: tdata.Location.folderid,
            buid: tdata.Location.buid,
            elecutility: tdata.Location.elecutility,
            gasutility: tdata.Location.gasutility,
            mode: EDITING_MODE,
            usernamee : this.usernamee || 'User',
            premiseno : tdata.Location.premiseno,
            premnochkd: tdata.Location.premnochkd,
            prmnochkdat: tdata.Location.prmnochkdat?.substring(0,10),
            qad: tdata.Location.qad,
            qadate: tdata.Location.qadate?.substring(0,10),
            qanotes: tdata.Location.qanotes,
            qareported: tdata.Location.qareported,
            qatype: tdata.Location.qatype,
            qad2: tdata.Location.qad2,
            qadate2: tdata.Location.qadate2?.substring(0,10),
            qanotes2: tdata.Location.qanotes2,
            qareported2: tdata.Location.qareported2,
            qatype2: tdata.Location.qatype2,
            rebate2stat: tdata.Location.rebate2stat,
            auditorname : tdata.Location.auditorname,
            constage : tdata.Location.constage,
            nrgprogram : tdata.Location.nrgprogram,
            audtype : tdata.Location.audtype,
            audnotes : tdata.Location.audnotes,
            ovlscore : tdata.Location.ovlscore,
            audinspdate : tdata.Location.audinspdate?.substring(0,10),
            audreported : tdata.Location.audreported,
            region : tdata.Location.region,
            esmfnc : tdata.Location.esmfnc,
            l_tags: tdata.Location.l_tags,
            rebate3: tdata.Location.rebate3,
            track: tdata.Location.track,
            comptrack: tdata.Location.comptrack,
            customer_id: tdata.Location.customer_id,
            mfplanoverride: tdata.Location.mfplanoverride,
            gasrebate : tdata.Location.gasrebate,
            elecrebate : tdata.Location.elecrebate,
            gasrebatedetails : tdata.Location.gasrebatedetails,
            electricrebatedetails : tdata.Location.electricrebatedetails,
            threetenrep : tdata.Location.threetenrep,
            refrigpw : tdata.Location.refrigpw,
            swppp : tdata.Location.swppp,
            targetset : tdata.Location.targetset,
            qa_review : tdata.Location.qa_review,
            socketid : this._socketID_,
            hvac_dr_request: tdata.Location.hvac_dr_request ?? false
          },
          panelClass: 'edit-dialog-container'
        });

        // If a track/comp track was applied during this edit, the new jobs already exist by
        // the time the dialog closes (manageTracks/manageCompTrack are awaited before close);
        // reload this location's job list so they show up without a manual page refresh.
        dialogRef.afterClosed().subscribe((result) => {
          if (result?.tracksApplied) {
            this.job$ = this.locationService.getJobs(myData.location_id, this.filterOutGPSJobs).pipe(
              mergeMap(jobs => {
                const updatedJobs$ = jobs.map(job =>
                  this.locationService.getAllNamedTags(job.job_id).pipe(
                    map(res => ({ ...job, namedTags: res.NamedTags })),
                    catchError(err => of({ ...job, namedTags: [] }))
                  )
                );
                return forkJoin(updatedJobs$);
              }),
              tap(jobs => { this.currentlyViewedJobs = jobs; })
            );
            this.cd.detectChanges();
          }
        });

      }
    )

  }

  duplicateDialog(row): void {
    this.locationService.getOneLocation(row.location_id).subscribe(
      (tdata: any) => {
        const loc = tdata.Location;
        const dialogRef = this.dialog.open(EditLocationDialogComponent, {
          height: '850px',
          width: '750px',
          data: {
            // Structural data - copied
            subdivision: loc.subdivision,
            subdivision_name: loc.subdivision_name,
            lot: '',
            street_address: (loc.street_address || '').trim() + ' (Copy)',
            city: loc.city,
            state: loc.state,
            zip: loc.zip,
            plan: loc.plan,
            plan_name: loc.plan_name,
            scope: loc.scope,
            contacts: loc.contacts,
            region: loc.region,
            customer_id: loc.customer_id,
            hvac_contractor_id: loc.hvac_contractor_id,
            buid: '',
            gasutility: loc.gasutility,
            elecutility: loc.elecutility,
            premiseno: loc.premiseno,
            track: '',
            comptrack: '',
            esmfnc: loc.esmfnc,
            mfplanoverride: loc.mfplanoverride,
            swppp: loc.swppp,
            weatherloc: loc.weatherloc,
            countyform: loc.countyform,
            nrgprogram: loc.nrgprogram,
            // Notes - copied
            adminnotes: loc.adminnotes,
            site_notes: loc.site_notes,
            billing_notes: loc.billing_notes,
            hvacnotes: loc.hvacnotes,
            // Rebate config - copied
            gasrebate: loc.gasrebate,
            elecrebate: loc.elecrebate,
            gasrebatedetails: loc.gasrebatedetails,
            electricrebatedetails: loc.electricrebatedetails,
            // Tags - copied
            l_tags: loc.l_tags,
            // Status flags - reset
            cert_printed: false,
            disclosuresent: false,
            taxcred: false,
            cfsent: false,
            roughnotice: false,
            roughreport: false,
            finalnotice: false,
            finalreport: false,
            missinginfo: false,
            adminarchive: false,
            rem_done: false,
            rebate1: false,
            rebate2: false,
            rebate3: false,
            hvacovrd: false,
            targetset: false,
            // Completion fields - reset
            hers_index: 0,
            ekotrope_id: null,
            registryid: '',
            folderid: null,
            permit_no: '',
            taxparcel: '',
            rebate2stat: '',
            // Dates - reset
            startdate: null,
            closedate: null,
            permitdate: null,
            audinspdate: null,
            qadate: null,
            qadate2: null,
            // QA fields - reset
            qad: '',
            qatype: '',
            qanotes: '',
            qareported: false,
            qad2: '',
            qatype2: '',
            qanotes2: '',
            qareported2: false,
            auditorname: '',
            constage: '',
            audtype: '',
            audnotes: '',
            ovlscore: 0,
            audreported: false,
            threetenrep: '',
            refrigpw: '',
            premnochkd: false,
            prmnochkdat: null,
            // Dialog context
            mode: ADDING_MODE,
            usernamee: this.usernamee || 'User',
            socketid: this._socketID_
          },
          panelClass: 'edit-dialog-container'
        });
      }
    );
  }

  ngOnInit(): void {

    this.socket.on('connect', () => {
        console.log('Socket connected:', this.socket.id);
        this._socketID_= this.socket.id
      });


    this.socket.on('reconnect', () => {
        console.log('Socket connected:', this.socket.id);
        this._socketID_= this.socket.id
      });

    this.locationService.init();
    console.log('LocationComponent initialized');

    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;
    this.configuration.detailsTemplate = true;
    this.configuration.showDetailsArrow = false;
    this.configuration.isLoading = false;
    this.configuration.threeWaySort = true;
    this.configuration.isLoading = this.locationService.isLoading;

    this.jobLoading$ = this.locationService.loadingSubject$;

   this.auth.userProfile$.subscribe(
    (profile) => {

      this.employeeID = this.auth.getEmployeeId();
      this.user = profile;
      this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    }, err => {
    });
    this.socket.on('uploadingFile', data => {
      this.snackbarComponent.updateProgress(data.percentage,data.streetAddress)
    })

    this.socket.on('drHortonCLTComplete', data => {
      if (data && data.Summary) {
        this.locationService.addCSVReport(data.Summary, 847).subscribe();
        try {
          this.openDataInNewTab(data.Summary);
        } catch(e) {
          this.handleCSVError(e, 'drhclt');
        }
      }
      if (data && data.Error) {
        this.handleCSVError(data.Message, 'drhclt');
      }
      this.snackbarComponent.dismissSnackbar();
    })

    this.socket.on('trueHomesComplete', data => {
      if (data && data.Summary) {
        this.log.info(this.usernamee + ' uploaded True Homes Permit Report.');
        this.locationService.addCSVReport(data.Summary, 39).subscribe();
        try {
          this.openDataInNewTab(data.Summary);
        } catch (e) {
          this.handleCSVError(e, 'truehomes');
        }
      }
      if (data && data.Error) {
        this.handleCSVError(data.Message, 'truehomes');
      }
      this.snackbarComponent.dismissSnackbar();
    })

    this._socketID_ = this.socket.id;

      this.socket.on('nonexistentjobs', (data) => {
      this.nonexisting_jobs = data.jobs;
        if (Array.isArray(this.nonexisting_jobs)) {
          const jobNames = data.jobs.map(e => e.job_name).join(', ');
          this.cd.detectChanges();
          this.openTrackWarning();
        }
      });

      // Each deep-search autocomplete combines its own input with the shared search mode,
      // so flipping the toggle re-runs the current term instead of waiting for a keystroke.
      // The mode stream is NOT debounced (a toggle click is deliberate); only typing is.
      const withMode = (controlName: string) => combineLatest([
        this.form.get(controlName).valueChanges.pipe(debounceTime(400)),
        this.searchMode$,
      ]);

      this.streetname$ = withMode('safilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getAddressFilterNames(value as string, this.searchMode) : empty()
      )
    );

      this.subdivision$ = withMode('subfilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getSubdivisionsDropdown(value as string, this.searchMode) : empty()
      )
    );

    this.registeryid$ = withMode('registeryfilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getRegisteryFilterDropdown(value as Number, this.searchMode) : empty()
      )
    );

    this.invoiceno$ = withMode('invoicefilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getInvoiceNoDropdown(value as string, this.searchMode) : empty()
      )
    );
    this.ponumber$ = withMode('pofilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getPoNumberDropdown(value as string, this.searchMode) : empty()
      )
    );

    this.builder$ = withMode('builderfilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getBuilderDropdown(value as string, this.searchMode) : empty()
      )
    );

    this.plan$ = withMode('planfilter').pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getPlanDropdownOptions(value as string, this.searchMode) : empty()
      )
    );



    this.locationService.getCustomerJobs().subscribe(
      (data) => {
        this.customerJobs = data;
      }, err => {

      });


    this.location$ = this.locationService.getInitial().pipe(
      tap(
          () => {
            this.configuration.isLoading = false;
            this.refreshNotedLocations();
            this.cd.markForCheck();
          }
        )
    );

    this.allLoaded$ = this.locationService.getAllLoaded();


    this.allLocation$ = this.locationService.getAllLocs().pipe(
      tap(
        () => {

          this.cd.markForCheck();
        }))


    //this.allLocation$ = this.locationService.getAll


    this.columns = [
      { key: '', title: '', width:'5%'},
      { key: 'street_address', title: 'Address', orderEnabled: true, width: '16%' },
      { key: 'subdivision_name', title: 'Subdivision', orderEnabled: true, width: '17%'},
      { key: 'lot', title: 'Lot', width: '12%', orderEnabled: true},
      { key: 'city', title: 'City', width: '9%'},
      { key: 'state', title: 'State', width: '5%'},
      { key: 'region', title: 'Region', width: '5%'},
      { key: 'plan_name', title: 'Plan', width: '18%'}

    ];

    // This is the stream actually bound to the Street Address dropdown (streetname$ is a
    // near-duplicate left in place); it needs the same mode plumbing.
    this.addresse$ = combineLatest([
      this.form.get('safilter').valueChanges.pipe(debounceTime(400)),
      this.searchMode$,
    ]).pipe(
      switchMap(([value]) =>
        this.meetsMinLength(value) ? this.locationService.getAddressFilterNames(value as string, this.searchMode) : empty()
      )
    );

    this.scheduleService.init(2);

    this.scheduleService.getDayStarted().subscribe(
      res => {
        this.daystarted = res;
        ////console.log(res);

        this.scheduleService.getFirstJob().subscribe(
          res => {
            this.firstJobDone = res;
          }
        )

        ////console.log('GETTING PAUSED');
        this.scheduleService.getIsPaused().subscribe(
          res => {
            ////console.log(res);
            this.isPaused = res;
          }, err => {
            this.isPaused = false;
          }
        )

        this.scheduleService.getIsClockedIn().subscribe(
          res => {
            ////console.log(res);
            this.isClockedIn = res;
          }, err => {
            this.isClockedIn = false;
          }
        );

      }, err => {
        //this.doneLoading = true;
      })


  }// ng-on init

  closeNonExistingModal(){
    const modal = document.getElementById('nonexistentJobsModal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  openTrackWarning() {
    const modal = document.getElementById('nonexistentJobsModal');

    if(modal){
      modal.style.display = 'block';
    }
  }

  displayFunction(customer: Customer) {
    if (customer) { return customer.customer_name; }
}


  onRowClicked(row): void {
  }

  openJobForm(job, noSave:boolean = true): void {

    this.scheduleService.getRaterformData(job).subscribe(
      (res) => {
        //this.dialogRef.close();
        //this.messager.openSnackBar('Loading form...', '', 'successAlert');
        this.log.info(this.usernamee + ' opened the form at ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' ' );


        //this.openDialog(res.formData,job.job_id, job.location_id);

        let jobData = res.formData;

        jobData.job_id = job.job_id;
        jobData.location_id = job.location_id;
        //jobData.form_id = 100211;

        let pics = {} as any;
        let notes = {};
        let formData = {} as any;

        let mod = {} as any;

        let theData = {
          formData : formData,
          pics : pics,
          notes : notes,
          job_id : job.job_id,
          location_id : job.location_id,
          noSave : noSave,
          fromLocations : true

        }
        //see if this job has a form already. If so, open it.

        // 1. Does this job have a form associated with it? Case: someone is coming back to this page to edit it again
        // 2.A If we have an id, we've worked on a form for this job, so just pull that data using the id associated with the job.
          this.scheduleService.getRaterPicsAll(job.job_id).subscribe(
            (res)=> {
              ////console.log(res);
              // ************************************
              theData.pics = res.Photos[0];
              // ************************************
          this.scheduleService.getDataByFormID(job.form_id).subscribe(
            (res) => {
              //formData = res.formData;
              this.messager.openSnackBar('Loading form... ', '', 'errorAlert');

              // ************************************
              //theData.formData = res.formData;
              // ************************************

              let upd = res.formData;
              upd.plan_id = jobData.plan || 0;
              upd.note = jobData.note || 'No Job Notes';
              upd.loclog = jobData.loclog;
              upd.job_id = job.job_id;
              upd.jobinfo = jobData;
              upd.customer = jobData.customer;


              theData.formData = upd;
              theData.formData.form_id = job.form_id;
              theData.formData.jobinfo.customer_jobtype = job.customer_jobtype;

                this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                res => {
                  if(res.Rows > 0){
                    theData.notes = res.Notes[0];
                    const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '100vw',
                            height: '100vh',
                            data: theData,
                            panelClass: ['custom-dialog-container', 'raterform-fit'],
                            autoFocus : false
                        }).afterClosed().subscribe(result => {
                          this.job$ = this.locationService.getJobs(job.location_id,this.filterOutGPSJobs).pipe(
                            mergeMap(jobs => {
                                // Transform each job into an observable that fetches named tags and appends them to the job
                                const updatedJobs$ = jobs.map(job =>
                                    this.locationService.getAllNamedTags(job.job_id).pipe(
                                        map(res => ({ ...job, namedTags: res.NamedTags })),
                                        catchError(err => {
                                            return of({ ...job, namedTags: [] });
                                        })
                                    )
                                );
                                return forkJoin(updatedJobs$);
                            }),
                            finalize(() => {
                              this.loadingJobs = false;
                            })
                          );
                        });
                  }else {
                    this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                      res => {
                        theData.notes = {};
                        const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '100vw',
                            height: '100vh',
                            data: theData,
                            panelClass: ['custom-dialog-container', 'raterform-fit'],
                            autoFocus : false
                        }).afterClosed().subscribe(result => {
                          this.job$ = this.locationService.getJobs(job.location_id,this.filterOutGPSJobs).pipe(
                            mergeMap(jobs => {
                                // Transform each job into an observable that fetches named tags and appends them to the job
                                const updatedJobs$ = jobs.map(job =>
                                    this.locationService.getAllNamedTags(job.job_id).pipe(
                                        map(res => ({ ...job, namedTags: res.NamedTags })),
                                        catchError(err => {
                                            return of({ ...job, namedTags: [] });
                                        })
                                    )
                                );
                                return forkJoin(updatedJobs$);
                            }),
                            finalize(() => {
                              this.loadingJobs = false;
                            })
                          );
                        });
                      }, err => {
                      });

                  }


                }, err => {
                });




                //open form here:
                }, err => {
                  this.messager.openSnackBar('Could not load form: ' + err.message, '', 'errorAlert');
                });

                }, err => {
                  this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
                });


            },
            err => {
              this.log.error(this.usernamee + ' encountered an error opening the form ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' Err: ' + err.toString() );
              this.messager.openSnackBar('No old jobs to load:  ' + err.message, '', 'errorAlert');
            }
          );




  }


  openJobFormLocmain(row, noSave:boolean = false): void {

    this.scheduleService.getRaterformData(row).subscribe(
      (res) => {
        ////console.log(res);
        this.log.info(this.usernamee + ' opened the form at ' + row.street_address + '- ' + row.subdivision_name + ' - ' + row.lot + ' ' );
        let jobData = res.formData;
        jobData.job_id = res.formData.job_id;
        jobData.location_id = row.location_id;

        let pics = {} as any;
        let notes = {};
        let formData = {} as any;

        let mod = {} as any;

        let theData = {
          formData : res.formData,
          pics : pics,
          notes : notes,
          job_id : res.formData.job_id,
          location_id : row.location_id,
          noSave : noSave,
          fromLocations : true
        }

        theData.formData.jobinfo = {};

        theData.formData.jobinfo.customer_jobtype = 0;
          this.scheduleService.getRaterPicslocmainRF(row.locpics_id).subscribe(
            (res)=> {
              ////console.log(res);
              // ************************************
              theData.pics = res.Photos;
              // ************************************
          this.scheduleService.getDataByFormID(row.form_id).subscribe(
            (res) => {
              //formData = res.formData;
              this.messager.openSnackBar('Loading form... ', '', 'errorAlert');

              // ************************************
              //theData.formData = res.formData;
              // ************************************

              let upd = res.formData;
              upd.plan_id = jobData.plan || 0;
              upd.note = jobData.note || 'No Job Notes';
              upd.loclog = jobData.loclog;
              upd.job_id = jobData.job_id;
              upd.jobinfo = jobData;
              upd.customer = jobData.customer;

              theData.formData = upd;
              theData.formData.form_id = row.form_id;

                this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                res => {
                  if(res.Rows > 0){
                    theData.notes = res.Notes[0];
                    const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '100vw',
                            height: '100vh',
                            data: theData,
                            panelClass: ['custom-dialog-container', 'raterform-fit'],
                            autoFocus : false
                        }).afterClosed().subscribe(result => {
                          this.job$ = this.locationService.getJobs(row.location_id,this.filterOutGPSJobs).pipe(
                            mergeMap(jobs => {
                                // Transform each job into an observable that fetches named tags and appends them to the job
                                const updatedJobs$ = jobs.map(job =>
                                    this.locationService.getAllNamedTags(job.job_id).pipe(
                                        map(res => ({ ...job, namedTags: res.NamedTags })),
                                        catchError(err => {
                                            return of({ ...job, namedTags: [] });
                                        })
                                    )
                                );
                                return forkJoin(updatedJobs$);
                            }),
                            finalize(() => {
                              this.loadingJobs = false;
                            })
                        );
                        });
                  }else {
                    this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                      res => {
                        theData.notes = {};
                        const dialogRef = this.dialog.open(RaterformComponent, {
                            width: '100vw',
                            height: '100vh',
                            data: theData,
                            panelClass: ['custom-dialog-container', 'raterform-fit'],
                            autoFocus : false
                        }).afterClosed().subscribe(result => {
                          this.job$ = this.locationService.getJobs(row.location_id,this.filterOutGPSJobs).pipe(
                            mergeMap(jobs => {
                                // Transform each job into an observable that fetches named tags and appends them to the job
                                const updatedJobs$ = jobs.map(job =>
                                    this.locationService.getAllNamedTags(job.job_id).pipe(
                                        map(res => ({ ...job, namedTags: res.NamedTags })),
                                        catchError(err => {
                                            return of({ ...job, namedTags: [] });
                                        })
                                    )
                                );
                                return forkJoin(updatedJobs$);
                            }),
                            finalize(() => {
                              this.loadingJobs = false;
                            })
                        );
                        });
                      }, err => {
                      });
                  }
                }, err => {
                });
                //open form here:
                }, err => {
                  this.messager.openSnackBar('Could not load form: ' + err.message, '', 'errorAlert');
                });

                }, err => {
                  this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
                });
            },
            err => {
              this.log.error(this.usernamee + ' encountered an error opening the form ' + row.street_address + '- ' + row.subdivision_name + ' - ' + row.lot + ' Err: ' + err.toString() );
              this.messager.openSnackBar('No old jobs to load:  ' + err.message, '', 'errorAlert');
            }
          );

  }

  reset(): void {
    this.locationService.resetFilter();
    this.deepsearchOn = false;
    this.guiLocked = false;

    this.form.get('safilter').setValue('');
    this.form.get('subfilter').setValue('');
    this.form.get('registeryfilter').setValue('');
    this.form.get('invoicefilter').setValue('');
    this.form.get('builderfilter').setValue('');
    this.form.get('planfilter').setValue('');


    this.toggledRows.forEach(e => {
      this.table.apiEvent({
        type: API.toggleRowIndex,
        value: e
      });
      this.toggledRows.delete(e);
    });

  }

  onSelectAddress(obj): void {
  }

  topFunction(): void {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }



  onEvent($event: {event: string, value: any}): void {
    // tslint:disable-next-line:no-console
    if($event.event === 'onPagination' || $event.event === 'onSearch') {
      this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
      });
      this.toggledRows.clear();
    }
  }

  getBorderStyle(index): string {

    return index%2 == 0 ? "border:solid; border-width: 1px; border-color: lightgray" : "";

  }

  addDialog(): void {
    const dialogRef = this.dialog.open(EditLocationDialogComponent, {
      width: '750px',
      height: '864px',
      data: {
        usernamee: this.usernamee,
        mode: ADDING_MODE,
        socketid : this._socketID_
      },
      panelClass: 'edit-dialog-container'
    });

    //close all open rows
    this.toggledRows.forEach(e => {
      this.table.apiEvent({
            type: API.toggleRowIndex,
            value: e
          });
          this.toggledRows.delete(e);
        });
    this.toggledRows.clear();
    // const dialogRef = this.dialog.open();
  }

  hasElevationPhotos(row): boolean {

    return (row.elevback.length != null || row.elevfront.length != null || row.elevright.length != null || row.elevleft.length != null);

  }

  epoUpdated(job): void {

    this.locationService.updateEpo(job).subscribe(
      res => {
        this.messager.openSnackBar('EPO status updated!', '', 'successAlert');
      },err => {
        this.messager.openSnackBar('EPO update failed', '', 'errorAlert');
      }
    )

  }

  resetElevPhotos(): void {
    this.toggledRows.clear();
  }

  gotoGDrive(row): string {
    return 'https://drive.google.com/drive/u/0/folders/' + row.folderid;
  }


  gotoEko(row): string {
    return 'https://app.ekotrope.com/#project:' + row.ekotrope_id;
  }

  openHVAC(): void {

  }

  openViewForm(formid) : void {

  }

   onPhotosClick(job, row?): void {
    var Photos;
     this.messager.openSnackBar('[Legacy] Loading photos taken at this job...', '', 'successAlert');


     this.scheduleService.getRaterPicsOne(job.job_id).subscribe(
      res => {
        if(res.Error){
          if(res.Error.result.rowCount == 0){
              this.messager.openSnackBar('This job does not have photos yet.', '[close]', 'errorAlert');
          }else {
              this.messager.openSnackBar(res.Error, '[close]', 'errorAlert');
          }
        }else {
          if(res.Photos.length>0)

          var transformExif = res.Photos.map((item) => {
            if(item.exif){
              let exifParsed = item.exif.length > 0 ? JSON.parse(item.exif[0]) : {};
              const obj = { ...item, exif: exifParsed };
              return obj;
            }else {
              const obj = { ...item, exif: {} };
              return obj;
            }
        });
            {
              const dialogRef = this.dialog.open(RatingPhotosDialogComponent, {
                minWidth: '100vw',
                height: '100vh',
                panelClass: 'rating-photos-panel',
                data: {
                  photos: transformExif,
                  job: job,
                  // the per-location jobs query has no subdivision/lot/city, so they come from the parent row
                  location: row ? { street_address: row.street_address, subdivision_name: row.subdivision_name, lot: row.lot, city: row.city } : null,
                  locmain: false}
              });
            }
        }
      }, err => {
        this.messager.openSnackBar('An Error occured opening the pictures', '', 'errorAlert');
      })
  }


  copyJob(job, row){

    let dialogRef;
    if(job.customer_jobtype.trim().toLowerCase().includes('final') && job.job_status.trim().toLowerCase().includes('pass') && !(job.customer_name.toLowerCase().includes('gps')) && !(job.customer_jobtype.toLowerCase().includes('audit')) && this.ismultifamily == false){
      dialogRef =  this.dialog.open(WarningPopupComponent, {
        width: '500px',
        data: {
            warning_title: 'Duplicate Finals Warning',
            warning_description: '',
            warning_sub: 'You are attempting to create a duplicate final for a home in which the Final has already been marked Pass (and registered with Resnet). This is not recommended based upon our quality assurance standards.',
            confirmText: `Don't Copy`,
            cancelText: `Copy Anyway`,
            showCancelButton: true
        }
      });
    }else {
      dialogRef = this.dialog.open(GridDeleteComponent, {
        width: '500px',
        data: {
          delete_body_text: 'Are you sure you want to copy this ' + job.customer_jobtype.trim() + '?',
          delete_api_url: '',
          delete_header_text: 'Copying ' + job.customer_jobtype.trim()
        }
      });
    }

          dialogRef.afterClosed().subscribe(result => {
            if (result === 1) {

              if(row.track > 0){

                this.locationService.copyJobWithTrack(job.job_id).subscribe(
                  res => {
                    this.job$ = this.locationService.getJobs(job.location_id,this.filterOutGPSJobs).pipe();
                    this.messager.openSnackBar('Job copied!', '', 'successAlert');
                  }, err => {
                    this.messager.openSnackBar('Error copying job: ' + err, '', 'errorAlert');
                  }
                )


              }else {
                this.log.info(this.usernamee + ' copied the ' + job.customer_jobtype + ' with id: ' + job.job_id);

                this.locationService.copyJob(job.job_id).subscribe(
                  res => {
                    this.job$ = this.locationService.getJobs(job.location_id,this.filterOutGPSJobs).pipe();
                    this.messager.openSnackBar('Job copied!', '', 'successAlert');
                  }, err => {
                    this.messager.openSnackBar('Error copying job: ' + err, '', 'errorAlert');
                  }
                )

              }

            }
          });

  }

  onLogClick(job, all:boolean = false){

    this.messager.openSnackBar('Loading logs...', '', 'successAlert',10000)
    let dataAll = {
      formData: null,
      unfilteredData: null,
      applogData: null,
      all: all,
      street_address: job.street_address?.trim(),
      customer_jobtype: job.customer_jobtype?.trim() || '',
      customer_name: job.customer_name?.trim() || '',
      location_id: job.location_id
    };

    if(all)
    {
      console.log('getting all logs');
      this.locationService.getFormlogs(job.location_id).subscribe(
        res=>{
          dataAll.formData = res.FormData;
          dataAll.unfilteredData = res.Unfiltered;
          const dialogRef = this.dialog.open(FormLogsComponent, {
            minWidth: '65vw',
            height: '80vh',
            panelClass: 'no-padding',
            data: dataAll
          });
        },
        err=>{}
      )
    }else {
      this.locationService.getFormLogsSingle(job.form_id).subscribe(
        res=>{
          dataAll.formData = res.FormData;
          const dialogRef = this.dialog.open(FormLogsComponent, {
            minWidth: '65vw',
            height: '80vh',
            panelClass: 'no-padding',
            data: dataAll
          });
        })
    }

  }


  isVendorSuiteMethod(method = this.csvselected): boolean {
    return method == 'vendorsuite' || method == 'vendorsuite2';
  }

  vendorSuiteNeedsMarket(): boolean {
    return this.isVendorSuiteMethod() && !this.vendorSuiteCustomerId;
  }

  onCsvFunctionChange(): void {
    if (this.isVendorSuiteMethod() && this.uploaderCustomers.length == 0) {
      this.locationService.getUploaderCustomers().subscribe(res => {
        this.uploaderCustomers = (res && res.data) ? res.data : [];
      }, err => {
        this.messager.openSnackBar('Could not load the market list: ' + err, '[close]', 'errorAlert');
      });
    }
  }

  parseCSV(event, method) : void {

      if (this.isVendorSuiteMethod(method) && !this.vendorSuiteCustomerId) {
        this.messager.openSnackBar('Pick a market before uploading a Vendor Suite file.', '[close]', 'errorAlert');
        event.target.value = '';
        return;
      }

      const file:File = event.target.files[0];

      //capture date for exported csv
      var dated = new Date(Date.now());
      var dd = dated.getDate().toFixed(0);
      var mm = (dated.getMonth()+1).toFixed(0);

      var yyyy = dated.getFullYear();
      if(parseInt(dd)<10){
          dd='0' + dd;
      }
      if(parseInt(mm)<10){
          mm='0'+mm;
      }

      var today = mm+'-'+dd+'-'+yyyy;


      var reader = new FileReader();
      let content;
      var extension = (file.name.split('.').pop() || '').toLowerCase();

      // True Homes Permit Report accepts .xlsm/.xlsx (multi-sheet workbook);
      // handle it separately and return — everything below this block expects text CSV.
      if (method == 'truehomes') {
        if (extension != 'xlsm' && extension != 'xlsx') {
          this.messager.openSnackBar('True Homes Permit Report requires an .xlsm or .xlsx file.', '[close]', 'errorAlert');
          return;
        }
        this.handleTrueHomesPermitReport(file, today);
        return;
      }

      if (extension != "csv" ){
        return;
      }

      let service = this.locationService;
      let messager = this.messager;
      let log = this.log;
      let un = this.usernamee;

      reader.onload = ()=>{

        content = reader.result;


        var postJSON = {
          file : content
        }

        if(method == 'jobupdate'){ //update

            service.jobupdater(postJSON).subscribe(
              (res) => {

                log.info(un + ' successfully updated jobs via the csv updater.');
                messager.openSnackBar('Jobs updated!', '[close]', 'successAlert');
              }, err => {
                log.error(un + ' encountered an error using the csv updater: ' + err.toString());
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              }
            )

        }else if (method == 'jobimport'){ //import
            service.jobimporter(postJSON).subscribe(
              (res) => {
                log.info(un + ' successfully imported jobs via the csv importer.');
                messager.openSnackBar('Jobs imported!', '[close]', 'successAlert');

                //download spreadsheet
                let name = today + '_jobImport.csv'
                var encodedUri = encodeURI('data:text/csv;charset=utf-8,' + res.CSV);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", name);
                document.body.appendChild(link); // Required for FF

                link.click();

              }, err => {
                console.log(err);
                log.error(un + ' encountered an error using the csv importer: ' + err.toString());
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              }
            )

        }else if (method == 'locimport'){
            service.locimporter(postJSON).subscribe(
              (res) => {
                log.info(un + ' successfully imported locations via the csv importer.');
                messager.openSnackBar('Locations imported!', '[close]', 'successAlert');
                //alertify.success("Import completed");

                let name = today + '_locImport.csv'
                var encodedUri = encodeURI('data:text/csv;charset=utf-8,' + res.CSV);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", name);
                document.body.appendChild(link); // Required for FF

                link.click();

              }, err => {
                log.error(un + ' encountered an error importing locations using the csv importer: ' + err.toString());

                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'premiseno'){
            service.premiseno(postJSON).subscribe(
              (res) => {
                log.info(un + ' successfully updated locations via the csv updater.');
                messager.openSnackBar('Premise Numbers updated!', '[close]', 'successAlert');
                //alertify.success("Import completed");

                let name = today + '_premiseUpdate.csv'
                var encodedUri = encodeURI('data:text/csv;charset=utf-8,' + res.CSV);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", name);
                document.body.appendChild(link); // Required for FF
                link.click();
              }, err => {
                log.error(un + ' encountered an error updating locations using the csv updater: ' + err.toString());
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'vendorsuite' || method == 'vendorsuite2'){
          const vsType = method == 'vendorsuite2' ? 2 : 1;
          const vsCustomer = this.vendorSuiteCustomerId;
          this.snackbarComponent.openSnackBar()
            service.vendorSuite(postJSON, vsType, vsCustomer).subscribe(
              (res) => {
                this.snackbarComponent.dismissSnackbar()
                if (res && res.Error) {
                  messager.openSnackBar('Err: ' + res.Message, '[close]', 'errorAlert');
                  return;
                }
                log.info(un + ' successfully inserted locations via the csv updater (vendor suite, customer ' + vsCustomer + ').');
                messager.openSnackBar('Locations added, refresh to view additions', '[close]', 'successAlert');
                if (res && res.Summary) {
                  this.locationService.addCSVReport(res.Summary, vsCustomer).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, method);
                  }
                }
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                log.error(un + ' encountered an error updating locations using the csv updater: ' + err.toString());
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'drhsrdu'){
          this.snackbarComponent.openSnackBar()
            service.drhortonSouthRDU(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  this.openDataInNewTab(res.Summary);
                  this.locationService.addCSVReport(res.Summary,1458).subscribe();
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'drherdu'){
          this.snackbarComponent.openSnackBar()
            service.drhortonEastRDU(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  this.openDataInNewTab(res.Summary);
                  this.locationService.addCSVReport(res.Summary,1326).subscribe();
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'drhm'){
          this.snackbarComponent.openSnackBar()
            service.drhortonMyrtle(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  this.openDataInNewTab(res.Summary);
                  this.locationService.addCSVReport(res.Summary,1327).subscribe();
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'drhnoog'){
          this.snackbarComponent.openSnackBar()
            service.drhortonNOOG(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  this.openDataInNewTab(res.Summary);
                  this.locationService.addCSVReport(res.Summary,980).subscribe();
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhindy'){
          this.snackbarComponent.openSnackBar()
            service.drhortonINDY(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  let name = today + '_drhortonINDY.json'
                  this.downloadJSON(res.Summary, name);
                  this.locationService.addCSVReport(res.Summary,1937).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhindy');
                  }
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhlou'){
          this.snackbarComponent.openSnackBar()
            service.drhortonLOU(postJSON).subscribe(
              (res) => {
                if (res && res.Summary) {
                  let name = today + '_drhortonLOU.json'
                  this.downloadJSON(res.Summary, name);
                  this.locationService.addCSVReport(res.Summary,1113).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhlou');
                  }
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhgrv'){
          this.snackbarComponent.openSnackBar()
            service.drhortonGRV(postJSON).subscribe(
              (res) => {
                console.log(res);
                if (res && res.Summary) {
                  let name = today + '_drhortonGRV.json'
                  //this.downloadJSON(res.Summary, name);
                  this.locationService.addCSVReport(res.Summary,905).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhgrv');
                  }
                }

                if(res && res.Error){
                  this.handleCSVError(res.Error, 'drhgrv');
                }
                this.snackbarComponent.dismissSnackbar();
              }, err => {
                console.log(err);
                this.handleCSVError(err, 'drhgrv');
                this.snackbarComponent.dismissSnackbar();
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhclt'){
          let cltPayload = { file: postJSON.file, socketId: this._socketID_ };
          this.snackbarComponent.openSnackBar()
            service.drhortonCLT(cltPayload).subscribe(
              (res) => {
                console.log(res);
                if(res && res.Error){
                  this.handleCSVError(res.Error, 'drhclt');
                  this.snackbarComponent.dismissSnackbar();
                }
                // Summary will arrive via drHortonCLTComplete socket event
              }, err => {
                console.log(err);
                this.handleCSVError(err, 'drhclt');
                this.snackbarComponent.dismissSnackbar();
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhknx'){
          this.snackbarComponent.openSnackBar()
            service.drhortonKNX(postJSON, 'KNX').subscribe(
              (res) => {
                if (res && res.Summary) {
                  let name = today + '_drhortonKNX.json'
                  this.downloadJSON(res.Summary, name);
                  this.locationService.addCSVReport(res.Summary,908).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhknx');
                  }
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        
        else if (method == 'drhnetn'){
          this.snackbarComponent.openSnackBar()
            service.drhortonKNX(postJSON, 'NETN').subscribe(
              (res) => {
                if (res && res.Summary) {

                  let name = today + '_drhortonNETN.json'
                  this.downloadJSON(res.Summary, name);
                  this.locationService.addCSVReport(res.Summary,1400).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhnetn');
                  }
                }
                this.snackbarComponent.dismissSnackbar()
              }, err => {
                this.snackbarComponent.dismissSnackbar()
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'drhcinci'){
          this.snackbarComponent.openSnackBar()
            service.drhortonCinci(postJSON).subscribe(
              (res) => {
                console.log(res);
                if (res && res.Summary) {
                  let name = today + '_drhortonCinci.json'
                  this.locationService.addCSVReport(res.Summary,1764).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'drhcinci');
                  }
                }

                if(res && res.Error){
                  this.handleCSVError(res.Error, 'drhcinci');
                }
                this.snackbarComponent.dismissSnackbar();
              }, err => {
                console.log(err);
                this.handleCSVError(err, 'drhcinci');
                this.snackbarComponent.dismissSnackbar();
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
        else if (method == 'merchar'){
            messager.openSnackBar('Processing CSV, stanby...', '', 'successAlert',15000);
            service.meritageChaCompliance(postJSON, 254).subscribe(
              (res) => {
                if (res) {
                  let name = today + '_MeritageCHA.json'
                  this.downloadJSON(res.Summary, name);
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'merchar');
                  }
                }
              }, err => {
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }else if (method == 'mercstl'){
            messager.openSnackBar('Processing CSV, stanby...', '', 'successAlert',15000);
            service.meritageChaCompliance(postJSON, 1272).subscribe(
              (res) => {
                if (res) {
                  let name = today + '_MeritageCSTL.json'
                  this.downloadJSON(res.Summary, name);
                  //this.locationService.addCSVReport(res.Summary,1400).subscribe();
                  try{
                    this.openDataInNewTab(res.Summary);
                  }catch(e){
                    this.handleCSVError(e, 'mercstl');
                  }
                }
              }, err => {
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
              })
        }
      }
      reader.readAsText(file);

 }

    handleTrueHomesPermitReport(file: File, today: string) {
      const service = this.locationService;
      const messager = this.messager;
      const log = this.log;
      const un = this.usernamee;
      const reader = new FileReader();

      reader.onload = () => {
        try {
          const data = new Uint8Array(reader.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });

          const sheets: { name: string; rows: any[][] }[] = [];
          for (const sheetName of workbook.SheetNames) {
            if (sheetName.trim().toLowerCase() === 'mapping') continue;
            const sheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, raw: false, defval: '' }) as any[][];
            if (!rows || rows.length === 0) continue;
            sheets.push({ name: sheetName, rows });
          }

          if (sheets.length === 0) {
            messager.openSnackBar('No data sheets found in workbook (the "mapping" tab is skipped).', '[close]', 'errorAlert');
            return;
          }

          const postJSON = { sheets };
          this.snackbarComponent.openSnackBar();

          service.trueHomesPermitReport(postJSON).subscribe(
            (res) => {
              console.log(res);
              // Processing now runs in the background to avoid the 30s HTTP
              // timeout; the real summary arrives via the 'trueHomesComplete'
              // socket event. Handle only the immediate responses here.
              if (res && res.Error) {
                this.handleCSVError(res.Message || res.Error, 'truehomes');
                this.snackbarComponent.dismissSnackbar();
                return;
              }
              if (res && res.Summary) {
                // Synchronous completion (e.g. no data rows). Normal runs
                // complete asynchronously via 'trueHomesComplete'.
                log.info(un + ' uploaded True Homes Permit Report.');
                this.locationService.addCSVReport(res.Summary, 39).subscribe();
                try {
                  this.openDataInNewTab(res.Summary);
                } catch (e) {
                  this.handleCSVError(e, 'truehomes');
                }
                this.snackbarComponent.dismissSnackbar();
                return;
              }
              // Otherwise: background processing started; wait for the socket.
            },
            (err) => {
              console.log(err);
              this.handleCSVError(err, 'truehomes');
              this.snackbarComponent.dismissSnackbar();
              messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
            }
          );
        } catch (e) {
          this.handleCSVError(e, 'truehomes');
          messager.openSnackBar('Failed to parse workbook: ' + (e && e.message ? e.message : e), '[close]', 'errorAlert');
        }
      };

      reader.onerror = () => {
        messager.openSnackBar('Failed to read file.', '[close]', 'errorAlert');
      };

      reader.readAsArrayBuffer(file);
    }

    openDataInNewTab(data) {
      const newWindow = window.open('', '_blank');
      newWindow.document.title = "Detailed JSON Data View";
      let time = moment.now();

      // Start the HTML content
      let htmlContent = `<html><head><title>JSON Data</title></head><body style="font-family: sans-serif;
      color: #3f3f3f;
      padding: 20px;"><h1>Data Summary (${time})</h1>`;

      // Iterate through each key in the JSON object
      Object.keys(data).forEach(key => {
        htmlContent += `<h2>${key}</h2>`;
        if (Array.isArray(data[key])) {
          data[key].forEach(item => {
            htmlContent += `<div><p style="font-size: 15px;
            padding-left: 10px;">${JSON.stringify(item)}</p></div>`; // For objects, stringify might be needed
          });
        } else if (typeof data[key] === 'object') {
          // In case of an object, iterate through its properties
          Object.keys(data[key]).forEach(subKey => {
            htmlContent += `<div><p style="font-size: 15px;
            padding-left: 10px;">${subKey}: ${data[key][subKey]}</p></div>`;
          });
        } else {
          htmlContent += `<div><p style="font-size: 15px;
          padding-left: 10px;">${data[key]}</p></div>`;
        }
        htmlContent += ``;
      });

      htmlContent += `</body></html>`;

      // Write the content to the new window
      newWindow.document.write(htmlContent);
      newWindow.document.close();
    }


  onloadFunction(reader, content, changedetector): any {

    content = reader.result;
    changedetector.detectChanges();

    var postJSON = {
      file : content
    };

  }

  handleCSVError(err, name): void {

      if (err instanceof Error) {
        this.log.error(name + 'CSV uploader ERROR :\n' + err.stack);
      } else {
        this.log.error(name + 'CSV uploader ERROR (non-Error thrown): ' + this.log.safeStringify(err));
      }

  }


  downloadJSON(data, filename = 'data.json') {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }

  openHVACModal(row, theIndex) : void {

    ///get submitted data
    let hid = row.hvac_design_id;
    let lid = row.location_id;
    let sData: any;

    //see if there's a sbmt_dsn_id
    if(row.sbmt_dsn_id == null){

      let designEntity = {
        id : row.hvac_design_id
      }
      //let de = this.locationService.getDesignEntity(designEntity);

      let locService = this.locationService;
      let prom = new Promise(function(resolve, reject){
        locService.selectedDesignLocation(designEntity as DesignsEntity, row, false);
        setTimeout(() => resolve("This was added by an administrator, design stamp created now."), 2000);
      }).then(()=> {
        //this.getLocationList();

        console.log('THEN... getting submitted hvac now...');
        this.locationService.getSubmittedHVAC(lid).subscribe(

          (res)=>{

            console.log(res);
            if(res.Rows == 0){

              this.locationService.getHvacData(lid).subscribe(

                (res)=> {

                  if(res.Rows == 0){
                    this.locationService.getHVACdataLegacy(lid).subscribe(


                      (res)=> {
                        console.log('RES 2', res);
                        sData = res.hvacData;
                        sData.plan_id = row.plan;

                        const dialogRef = this.dialog.open( HVACreviewComponent, {
                          panelClass: 'hvacPopup',
                          data: {
                            submittedData : sData,
                            subdivision_name : row.subdivision_name,
                            lot : row.lot,
                            street_address : row.street_address,
                            location_id : lid
                          },

                        });
                        dialogRef.afterClosed().subscribe(result => {
                          if (result === 1) {
                          }
                        })
                      }, err => {
                        this.messager.openSnackBar('Failed', '', 'errorAlert');
                      });

                  } else {

                    sData = res.hvacData;
                    console.log('ELSE... got hvac data: ', sData);

                    sData.plan_id = row.plan;

                    const dialogRef = this.dialog.open( HVACreviewComponent, {
                      panelClass: 'hvacPopup',
                      data: {
                        submittedData : sData,
                        subdivision_name : row.subdivision_name,
                        lot : row.lot,
                        street_address : row.street_address,
                        location_id : lid
                      },

                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if (result === 1) {
                      }
                    })

                  }
                }, err => {

                });
            } else {
              sData = res.hvacData;
              console.log('ELSE... got submitted hvac data: ', sData);

              sData.forEach(function(e){
                e.condensermn = e.condmn;
                e.evapmn = e.evaporator;
                e.furnacemn = e.furnmn;
              })


              sData.plan_id = row.plan;

              const dialogRef = this.dialog.open( HVACreviewComponent, {
                panelClass: 'hvacPopup',
                data: {
                  submittedData : sData,
                  subdivision_name : row.subdivision_name,
                  lot : row.lot,
                  street_address : row.street_address,
                  location_id : lid
                },

              });
              dialogRef.afterClosed().subscribe(result => {
                if (result === 1) {
                  //this.locationService.deleteLocation(location.location_id);
                }
              })


            }


          }, err => {
            console.log(err);
              this.messager.openSnackBar('Failed', '', 'errorAlert');
          }


        )
      });



    }else{

      this.locationService.getSubmittedHVAC(lid).subscribe(

        (res)=>{

          if(res.Rows == 0){

            this.locationService.getHvacData(lid).subscribe(

              (res)=> {
                console.log('RES 2', res);

                if(res.Rows == 0){
                  this.locationService.getHVACdataLegacy(lid).subscribe(

                    (res)=> {
                      sData = res.hvacData;
                      sData.plan_id = row.plan;

                      const dialogRef = this.dialog.open( HVACreviewComponent, {
                        panelClass: 'hvacPopup',
                        data: {
                          submittedData : sData,
                          subdivision_name : row.subdivision_name,
                          lot : row.lot,
                          street_address : row.street_address,
                          location_id : lid
                        },

                      });
                      dialogRef.afterClosed().subscribe(result => {
                        if (result === 1) {
                        }
                      })
                    }, err => {
                      this.messager.openSnackBar('Failed', '', 'errorAlert');
                      console.log(err);
                    });

                } else {
                  sData = res.hvacData;
                  console.log('ELSE... got hvac data: ', sData);

                  sData.plan_id = row.plan;

                  const dialogRef = this.dialog.open( HVACreviewComponent, {
                    panelClass: 'hvacPopup',
                    data: {
                      submittedData : sData,
                      subdivision_name : row.subdivision_name,
                      lot : row.lot,
                      street_address : row.street_address,
                      location_id : lid
                    },

                  });
                  dialogRef.afterClosed().subscribe(result => {
                    if (result === 1) {
                    }
                  })

                }
              }, err => {

              });
          } else {
            sData = res.hvacData;
            console.log('ELSE... got submitted hvac data: ', sData);

            sData.forEach(function(e){
              e.condensermn = e.condmn;
              e.evapmn = e.evaporator;
              e.furnacemn = e.furnmn;
            })


            sData.plan_id = row.plan;

            const dialogRef = this.dialog.open( HVACreviewComponent, {
              panelClass: 'hvacPopup',
              data: {
                submittedData : sData,
                subdivision_name : row.subdivision_name,
                lot : row.lot,
                street_address : row.street_address,
                location_id : lid
              },

            });
            dialogRef.afterClosed().subscribe(result => {
              if (result === 1) {
                //this.locationService.deleteLocation(location.location_id);
              }
            })


          }


        }, err => {
          console.log(err);
            this.messager.openSnackBar('Failed', '', 'errorAlert');
        }


      )
    }



    //for now, open the form




  }


    addDriveFolder(row ,theIndex) : void {

    var locationID = row.location_id;
    var subdivisionN = row.subdivision_name;
    var lot = row.lot;
    var streetN = row.street_address;

    var createObject = {
      location_id : row.location_id,
      subdivision_name : row.subdivision_name,
      lot : row.lot,
      street_address : row.street_address
    }

    //$scope.gridOptions.data[index].folderid = 'www.google.com';

      this.locationService.createDriveFolder(createObject).subscribe(
        res => {
        let index = theIndex;
        this.messager.openSnackBar('Drive folder was created successfully.', '[Close]', 'successAlert');
        row.folderid = res.File.data.id;
        this.locationService.saveFolderID(row.location_id, row);
        },err => {
          this.messager.openSnackBar('Error creating drive folder.', '[Close]', 'errorAlert');
        });

  };

  openJobInNewTab(row): void {

    const sanitizedAddress = (row.street_address || '').replace(/\//g, '-');
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/viewJobs/${sanitizedAddress}/${row.location_id}`])
    );
    window.open(url, '_blank');
  }

// for photos
  onExpandPhotoEvent($event: MouseEvent, index: number, show: number, row): void {
    //$event.preventDefault();

    this.show = show;

    this.jobTags = [];
    this.tagService.getTagNames(row.l_tags).subscribe(
      res => {
        this.jobTags = res.data;

        ////console.log(row);

        this.tripsView = false;
        this.reloadJobsForLocation(row, true);

        this.locationService.getThermalRequired(row.location_id).subscribe(
          res => {
            if(res.Error){
              this.thermalRequired = false;
            }else {
              this.thermalRequired = res.Thermal.thermlreqd;
            }
          });


        this.locationService.getScope(row.subdivision).subscribe(
          res => {
            if(res.Error){
              //try to get the scope from the location (locmain has no scope2/pathway copy)
              this.displayScope = row.scope;
              this.displayScope2 = '';
              this.displayScope3 = '';
              this.displayPathway = '';
              this.displayPathway2 = '';
              this.displayPathway3 = '';
              this.displayStories = '';
              this.generator = false;
              this.ismultifamily = row.ismultifamily;
              return;
            }
            this.displayScope = res.Scope.scope;
            this.displayScope2 = res.Scope.scope2;
            this.displayScope3 = res.Scope.scope3;
            this.displayPathway = (res.Scope.scope1paths || []).join(', ');
            this.displayPathway2 = (res.Scope.scope2paths || []).join(', ');
            this.displayPathway3 = (res.Scope.scope3paths || []).join(', ');
            this.displayStories = res.Scope.story_type || '';
            this.generator = res.Scope.generator;
          }, err => {
            this.displayScope = row.scope;
            this.displayScope2 = '';
            this.displayScope3 = '';
            this.displayPathway = '';
            this.displayPathway2 = '';
            this.displayPathway3 = '';
            this.displayStories = '';
            this.generator = false;
          }
        )

      }
    )




      this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });

    this.toggledRows.clear();

    this.table.apiEvent({
      type: API.toggleRowIndex,
      value: index
    });

      this.toggledRows.add(index);

  }

  onExpandPhotoEventClear($event: MouseEvent, index: number, show: number, row): void {
    //$event.preventDefault();

    this.show = show;

    //this.job$ = this.locationService.getJobs(row.location_id).pipe();

      this.toggledRows.forEach(e => {
        this.table.apiEvent({
          type: API.toggleRowIndex,
          value: e
        });
        this.toggledRows.delete(e);
      });

    this.toggledRows.clear();

    this.jobTags = [];
  }

  // Single jobs fetch for an expanded location row, shared by the expand handler and the
  // Jobs/Trips toggle so the track branch's PlanRev-first sort can't drift between them.
  reloadJobsForLocation(row: any, autoSelectView = false): void {
    if (!row || !row.location_id) { return; }

    const isPlanRev = (job) => (job.customer_jobtype || '').trim().toLowerCase().includes('plan rev');
    this.loadingJobs = true;

    const withNamedTags = (source: Observable<any[]>, sortPlanRevsFirst: boolean) =>
      source.pipe(
        mergeMap(jobs => {
          const ordered = sortPlanRevsFirst
            ? jobs.sort((a, b) => {
                const aIsPlanRev = isPlanRev(a);
                const bIsPlanRev = isPlanRev(b);
                if (aIsPlanRev && !bIsPlanRev) { return -1; }
                if (!aIsPlanRev && bIsPlanRev) { return 1; }
                return 0;
              })
            : jobs;
          const updatedJobs$ = ordered.map(job =>
            this.locationService.getAllNamedTags(job.job_id).pipe(
              map(res => ({ ...job, namedTags: res.NamedTags })),
              catchError(err => of({ ...job, namedTags: [] }))
            )
          );
          return forkJoin(updatedJobs$);
        }),
        tap(jobs => {
          this.currentlyViewedJobs = jobs;
          if (autoSelectView) {
            this.tripsView = jobs.some(j => j.istrip == true);
            this.cd.detectChanges();
          }
        }),
        finalize(() => { this.loadingJobs = false; })
      );

    this.job$ = (row.track != null && row.track > 0)
      ? withNamedTags(this.locationService.getJobsSorted(row.location_id, this.filterOutGPSJobs), true)
      : withNamedTags(this.locationService.getJobs(row.location_id, this.filterOutGPSJobs), false);
  }

  // The view flip is only a [hidden] binding over the fetched list, so re-fetch on every
  // toggle (both directions) to pick up jobs changed elsewhere since the row was expanded.
  toggleTripsView(row: any): void {
    this.tripsView = !this.tripsView;
    this.reloadJobsForLocation(row);
    this.cd.detectChanges();
  }

  toggleGPSFilter(): void {
    this.filterOutGPSJobs = (this.filterOutGPSJobs + 1) % 2;
    ////console.log(this.filterOutGPSJobs);
  }

  // True when the grid row has at least one live Extra Notes post; the button is then
  // shown without hovering and painted edit-button green (see .notes-flag).
  hasExtraNotes(row): boolean {
    return this.notedLocationIds.has(Number(row?.location_id));
  }

  // Reloads the noted-location set. One in-flight request at a time: the grid subject
  // emits on every add/delete/search, and a stale second response must not win.
  refreshNotedLocations(): void {
    if (this.notedLocationsLoading) { return; }
    this.notedLocationsLoading = true;
    this.locationService.getLocationIdsWithExtraNotes().pipe(
      finalize(() => { this.notedLocationsLoading = false; })
    ).subscribe(
      (res: any) => {
        if (res?.Error || !Array.isArray(res?.LocationIds)) { return; }
        this.notedLocationIds = new Set<number>(res.LocationIds.map(Number));
        this.cd.markForCheck();
      },
      () => { /* indicator is best-effort; the button still opens the feed */ }
    );
  }

  // Opens the server-rendered Extra Notes feed (card arChhF4j) for a location row in a
  // new tab, attributing posts with the logged-in user's name + employee id.
  // URL construction lives in buildExtraNotesUrl so this and the /extra-notes/:id
  // deep-link bounce route (ExtraNotesRedirectComponent, used by external CSV
  // reports) can't drift on how `usernamee` is derived -- if they did, the same
  // person would be attributed under two different names on their posts.
  openExtraNotes(row): void {
    const url = buildExtraNotesUrl(
      environment.baseUrl,
      row.location_id,
      this.usernamee,
      this.auth.getEmployeeId()
    );
    window.open(url, '_blank');
  }

  addUtilityDialog(): void {
    this.dialog.open(AddUtilityDialogComponent, {
      width: '450px',
      data: { who: this.usernamee },
      panelClass: 'edit-dialog-container'
    });
  }

  reportErrorDialog(location): void {
    const dialogRef = this.dialog.open(ReportErrorComponent, {
      width: '500px',
      height: '720px',
      data: {
        location: location,
        who: this.usernamee
      },
      panelClass: 'edit-dialog-container'
    });
  }



  deleteLocationDialog(location): void {

    const dialogRef = this.dialog.open( GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete ' + location.street_address + '?',
        delete_api_url:  '/rhAPI/locations/delete/',
        delete_id: location.location_id,
        delete_header_text: 'Deleting '  + location.subdivision_name + ' - ' + location.lot
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.locationService.deleteLocation(location.location_id);


        this.toggledRows.forEach(e => {
          this.table.apiEvent({
            type: API.toggleRowIndex,
            value: e
          });
              this.toggledRows.delete(e);
            });
          this.toggledRows.clear();

      }
    })


  }

  openFailNotes(job: any): void {
    /*
    const dialogRef = this.dialog.open(ViewFailNotesComponent, {
      width: '60vw',
      height: '60vw',
      data: job,
      panelClass: 'edit-dialog-container'
    });
    */
  }

  additionalWork(job, row) {

      const dialogConfig = {
        data: {
          location_id: row.location_id,
          job_id: job.job_id,
          loadPrevious : true
        },
        width: '500px',
        height: '80vh'
      }

      const dialogRef = this.dialog.open(AdditionalworkComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
          //console.log(result);
          if (result === 1) {
            this.messager.openSnackBar('Additional work added!', '', 'successAlert');
          }else {
            //this.messager.openSnackBar('.', '', 'errorAlert');
          }
        });


  }

  //edit Job Stuff
  openEditJob(job: any, location: any, isAudit = false): void {


    this.locationService.getOneJob(job.job_id).subscribe(

      res => {

        let isMobile = this.bpo.isMatched('(max-width: 768px)');

        const dialogRef = this.dialog.open(EditJobDialogComponent, {
          disableClose: true,
          data: {
            location: location,
            job: job,
            fetchedJob: res.Job,
            cj : this.customerJobs,
            dd : this.customersDropdown,
            mode: EDITING_MODE,
            isAudit: isAudit,
            usernamee: this.usernamee || 'User',
            generator: this.generator,
            // When editing a trip, the Trip Details tab needs the location's other jobs to
            // offer as add-able tasks (openAddJob passes these; the edit path had omitted them,
            // so "Available Tasks" was always empty).
            // Exclude jobs already pointed at ANY trip (trip_id set) — a job can only belong
            // to one trip, so an already-tripped job must not be offered as addable here.
            availableJobs: this.currentlyViewedJobs?.filter(j => j.istrip != true && !j.trip_id),
            previousTrips: this.currentlyViewedJobs?.filter(j => j.istrip == true),
            // Editing a trip's own status/technician/schedule date cascades that field to
            // every child job (same flag on the truck view and schedule page edits).
            enableTripFieldCascade: true,
          },
          ...(isMobile ? { width: '100vw', height: '100vh' } : { width: '800px', height: '90vh' }),
          panelClass: 'edit-dialog-container',
          autoFocus : false
        });

        // const dialogRef = this.dialog.open();
          dialogRef.afterClosed().subscribe(result => {
            ////console.log('Closed');
            if (result?.tripModeUsed) { this.tripsView = true; }

            //wrap the following in a timeout to allow the dialog to close
            setTimeout(() => {
              this.job$ = this.locationService.getJobs(location.location_id,this.filterOutGPSJobs).pipe(
                mergeMap(jobs => {
                    // Transform each job into an observable that fetches named tags and appends them to the job
                    const updatedJobs$ = jobs.map(job =>
                        this.locationService.getAllNamedTags(job.job_id).pipe(
                            map(res => ({ ...job, namedTags: res.NamedTags })),
                            catchError(err => {
                                return of({ ...job, namedTags: [] });
                            })
                        )
                    );
                    return forkJoin(updatedJobs$);
                }),
                tap(jobs => { this.currentlyViewedJobs = jobs; }),
                finalize(() => {
                  this.loadingJobs = false;
                })
              );
              this.cd.detectChanges();

            }, 500);

          });
      }

    )


  }



  openAddJob(location: any, isAudit:boolean = false): void {
        console.log(this.currentlyViewedJobs);
        let isMobile = this.bpo.isMatched('(max-width: 768px)');
        const dialogRef = this.dialog.open(EditJobDialogComponent, {
          disableClose: true,
          data: {
            fetchedJob: {},
            location: location,
            job: {
              customer_name : 'Customer',
              customer_jobtype : 'Jobtype',
              job_status : 'Scheduled'
            },
            panelClass: 'edit-dialog-container',
            usernamee: this.usernamee || 'User',
            generator: this.generator,
            mode: ADDING_MODE,
            isAudit: isAudit,
            // Exclude jobs already pointed at ANY trip (trip_id set) — a job can only belong
            // to one trip, so an already-tripped job must not be offered as addable here.
            availableJobs: this.currentlyViewedJobs?.filter(j => j.istrip != true && !j.trip_id),
            previousTrips: this.currentlyViewedJobs?.filter(j => j.istrip == true),
          },
          ...(isMobile ?
            { width: '100%', height: '100%', maxWidth: '100vw' } :
            { width: '800px', height: '90vh', position: {left: '50%'} }),
          panelClass: 'edit-dialog-container',
          autoFocus : false
        });
          dialogRef.afterClosed().subscribe(result => {
            if (result?.tripModeUsed) { this.tripsView = true; }
            const reloadJobs = () => {
              this.job$ = this.locationService.getJobs(location.location_id,this.filterOutGPSJobs).pipe(
                mergeMap(jobs => {
                  const updatedJobs$ = jobs.map(job =>
                    this.locationService.getAllNamedTags(job.job_id).pipe(
                      map(res => ({ ...job, namedTags: res.NamedTags })),
                      catchError(err => of({ ...job, namedTags: [] }))
                    )
                  );
                  return forkJoin(updatedJobs$);
                }),
                tap(jobs => { this.currentlyViewedJobs = jobs; })
              );
              this.cd.detectChanges();
            };
            reloadJobs();
            // Reloads again once the job is on a trip, so the list never races the trip call.
            const deps = { dialog: this.dialog, service: this.locationService, messager: this.messager, log: this.log, usernamee: this.usernamee };
            promptTripChoiceForNewJob(deps, result, location.location_id, isAudit).subscribe(onTrip => {
              if (onTrip) {
                this.tripsView = true;
                reloadJobs();
              }
            });
          });
      }

  // ── Chat Widget ──
  @ViewChild('chatMessagesEl') chatMessagesEl: ElementRef<HTMLDivElement>;
  @ViewChild('chatInputEl') chatInputEl: ElementRef<HTMLTextAreaElement>;

  private readonly CHAT_WEBHOOK_URL = 'https://performancepoint.app.n8n.cloud/webhook/f94825a0-7110-4217-8263-a38714deb2f1';
  private readonly chatSessionId = 'session-' + Math.random().toString(36).substring(2, 10);

  chatOpen = false;
  chatLoading = false;
  chatInitialized = false;
  chatHasSentMessage = false;
  chatInputText = '';
  chatHistory: Array<{ id: number; role: 'user' | 'assistant'; content: string; feedback?: number }> = [];
  private chatMessageCount = 0;
  faThumbsUp = faThumbsUp;
  faThumbsDown = faThumbsDown;

  toggleChat() {
    this.chatOpen = !this.chatOpen;
    if (this.chatOpen && !this.chatInitialized) {
      this.addChatMessage('assistant', "Hi! I can help you explore Performance Point data — job trends, HERS scores, subdivision stats, customer volume, and more. What would you like to know?");
      this.chatInitialized = true;
    }
    if (this.chatOpen) {
      setTimeout(() => this.chatInputEl && this.chatInputEl.nativeElement.focus(), 0);
    }
  }

  private addChatMessage(role: 'user' | 'assistant', content: string) {
    this.chatHistory.push({ id: ++this.chatMessageCount, role, content });
    setTimeout(() => this.scrollChatToBottom(), 0);
  }

  private scrollChatToBottom() {
    const el = this.chatMessagesEl && this.chatMessagesEl.nativeElement;
    if (el) el.scrollTop = el.scrollHeight;
  }

  async sendChatMessage() {
    const text = this.chatInputText.trim();
    if (!text || this.chatLoading) return;

    this.addChatMessage('user', text);
    this.chatInputText = '';
    this.chatHasSentMessage = true;
    if (this.chatInputEl) this.chatInputEl.nativeElement.style.height = 'auto';
    this.chatLoading = true;
    setTimeout(() => this.scrollChatToBottom(), 0);

    try {
      const response = await fetch(this.CHAT_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, sessionId: this.chatSessionId, username: this.usernamee }),
      });

      if (!response.ok) throw new Error('HTTP ' + response.status);

      const data = await response.json();
      let reply = '';
      if (typeof data === 'string') reply = data;
      else if (data.output) reply = data.output;
      else if (data.text) reply = data.text;
      else if (data.message) reply = data.message;
      else reply = JSON.stringify(data, null, 2);

      this.addChatMessage('assistant', reply);
      this.cd.detectChanges();
    } catch (err) {
      console.error('Chat error:', err);
      this.addChatMessage('assistant', 'Sorry, something went wrong. Please make sure the n8n workflow is active and try again.');
      this.cd.detectChanges();
    } finally {
      this.chatLoading = false;
      this.cd.detectChanges();
      setTimeout(() => {
        if (this.chatInputEl) this.chatInputEl.nativeElement.focus();
        this.scrollChatToBottom();
      }, 0);
    }
  }

  sendChatSuggestion(text: string) {
    this.chatInputText = text;
    this.sendChatMessage();
  }

  handleChatKey(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendChatMessage();
    }
  }

  autoResizeChatInput() {
    const el = this.chatInputEl && this.chatInputEl.nativeElement;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 100) + 'px';
  }

  sendChatFeedback(msg: { feedback?: number; id: number; content: string }, value: number) {
    if (msg.feedback !== undefined) return;
    msg.feedback = value;
    const idx = this.chatHistory.findIndex(m => m.id === msg.id);
    let userMsg = '';
    for (let i = idx - 1; i >= 0; i--) {
      if (this.chatHistory[i].role === 'user') { userMsg = this.chatHistory[i].content; break; }
    }
    fetch(this.CHAT_WEBHOOK_URL.replace('f94825a0-7110-4217-8263-a38714deb2f1','pp-chatbot-feedback'), {
      method: 'POST',
      headers: {'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: this.chatSessionId,
        userMessage: userMsg,
        feedback: value,
        username: this.usernamee
      })
    }).catch(err => console.error('Feedback error:', err));
  }
  sendFeedbackNote(msg: any) {
    const note = msg.feedbackNote?.trim();
    if (!note) return;

    const idx = this.chatHistory.findIndex(m => m.id === msg.id);
    let userMsg = '';
    for (let i = idx - 1; i >= 0; i--) {
      if (this.chatHistory[i].role === 'user') { userMsg = this.chatHistory[i].content; break; }
    }

    fetch(this.CHAT_WEBHOOK_URL.replace('f94825a0-7110-4217-8263-a38714deb2f1', 'pp-chatbot-feedback'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: this.chatSessionId,
        userMessage: userMsg,
        feedback: msg.feedback,
        feedbackNote: note,
        username: this.usernamee
      })
    }).catch(err => console.error('Feedback note error:', err));

    msg.feedbackNoteSent = true;
    this.cd.detectChanges();
  }

  hasNoVisibleJobs(jobs: any[] | null, wantTrips: boolean): boolean {
    if (!jobs || jobs.length === 0) { return false; }
    return !jobs.some(j => wantTrips ? j.istrip == true : j.istrip != true);
  }

  // Each entry keeps the task's full getJobs row so the trip card can hand it to openEditJob.
  getTripDetails(tripJob: any): { job: any, jobType: string, completed: boolean, failed: boolean, status: string }[] {
    if (!this.currentlyViewedJobs || !Array.isArray(this.currentlyViewedJobs) || !tripJob) {
      return [];
    }

    return this.currentlyViewedJobs
      .filter(job => job.trip_id === tripJob.job_id && job.customer_jobtype != null)
      .map(job => {
        const status = job.job_status ? job.job_status.trim() : '';
        return {
          job,
          jobType: job.customer_jobtype,
          status,
          completed: status === 'Pass' || status === 'Complete',
          failed: status.toLowerCase().includes('fail')
        };
      });
  }
}


@Component({
  selector: 'app-job-trip-choice-dialog',
  template: `
    <h2 mat-dialog-title style="font-size:1.4em;">Add this job to a trip?</h2>
    <div mat-dialog-content>
      <mat-radio-group [(ngModel)]="action" style="display:flex;flex-direction:column;gap:12px;">
        <mat-radio-button value="newTrip">Turn this job into a new trip</mat-radio-button>
        <mat-radio-button value="addToTrip" [disabled]="!data.openTrips?.length">
          Add this job to an existing trip
          <span *ngIf="!data.openTrips?.length" style="opacity:0.7;">(no open trips at this location)</span>
        </mat-radio-button>
        <mat-radio-button value="none">Do neither</mat-radio-button>
      </mat-radio-group>

      <p *ngIf="action === 'newTrip' && !data.jobIsOpen" style="margin-top:16px;opacity:0.8;">
        This job is {{ data.jobStatus || 'not Scheduled' }}, so the new trip will be created as Complete. The job keeps its own status.
      </p>

      <div *ngIf="action === 'addToTrip'" style="margin-top:16px;">
        <p *ngIf="data.jobIsOpen" style="opacity:0.8;">The job will take the selected trip's date and status.</p>
        <p *ngIf="!data.jobIsOpen" style="opacity:0.8;">
          This job is {{ data.jobStatus || 'not Scheduled' }}, so it keeps its own date and status.
        </p>
        <mat-radio-group [(ngModel)]="selectedTripId" style="display:flex;flex-direction:column;gap:10px;margin-left:24px;">
          <mat-radio-button *ngFor="let trip of data.openTrips" [value]="trip.job_id">
            <span style="font-weight:500;">{{ trip.schedule_date | date:'MMM d, y' }}</span>
            <span style="margin:0 8px;">—</span>
            <span>{{ trip.customer_jobtype }}</span>
            <span style="margin-left:8px;font-size:0.85em;opacity:0.7;">({{ trip.job_status }})</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div mat-dialog-actions align="end" style="gap:8px;">
      <button mat-flat-button color="primary" [disabled]="action === 'addToTrip' && !selectedTripId" (click)="confirm()">OK</button>
    </div>
  `
})
export class JobTripChoiceDialogComponent {
  action: 'newTrip' | 'addToTrip' | 'none' = 'none';
  selectedTripId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<JobTripChoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { openTrips: any[], jobStatus: string, jobIsOpen: boolean }
  ) {}

  confirm(): void {
    if (this.action === 'newTrip') { this.dialogRef.close({ action: 'newTrip' }); }
    else if (this.action === 'addToTrip') { this.dialogRef.close({ action: 'addToTrip', tripId: this.selectedTripId }); }
    else { this.dialogRef.close(null); }
  }
}

// After the add-job dialog closes: offers to wrap the new job in a trip or put it on an open
// trip at the location. Emits true once the job is on a trip, false in every other case.
export function promptTripChoiceForNewJob(
  deps: { dialog: MatDialog, service: LocationService, messager: MessagerComponent, log: LoggingService, usernamee: any },
  result: any, locationId: any, isAudit: boolean
): Observable<boolean> {
  const jobId = result?.job?.job_id;
  if (!jobId || !locationId || isAudit || result.tripModeUsed || result.job.istrip === true) { return of(false); }

  const jobStatus = (result.job.job_status || '').toString().trim();
  return deps.service.getOpenTrips(locationId).pipe(
    catchError(() => of({ Trips: [] })),
    // Only ask when the location already has an open trip to add to. Without one the
    // dialog could only offer "turn this into a new trip", which the scheduling team
    // found to be noise on every job they created; the Trip? checkbox still covers that.
    switchMap((res: any) => {
      const openTrips = res?.Trips || [];
      if (!openTrips.length) { return of(null); }
      return deps.dialog.open(JobTripChoiceDialogComponent, {
        width: '520px',
        disableClose: true,
        data: { openTrips, jobStatus, jobIsOpen: ['Scheduled', 'Projected'].includes(jobStatus) }
      }).afterClosed();
    }),
    switchMap((choice: any) => {
      if (!choice) { return of(false); }
      const newTrip = choice.action === 'newTrip';
      const call$ = newTrip ? deps.service.createTripFromJob(jobId) : deps.service.addJobToTrip(jobId, choice.tripId);
      return call$.pipe(
        map((tripRes: any) => {
          if (tripRes?.Error) {
            deps.messager.openSnackBar('Job saved, but the trip was not updated: ' + tripRes.Message, '[close]', 'errorAlert');
            return false;
          }
          deps.messager.openSnackBar(newTrip ? 'Trip created.' : 'Job added to trip.', '', 'successAlert');
          deps.log.info(deps.usernamee + (newTrip ? ' turned job_id: ' + jobId + ' into' : ' added job_id: ' + jobId + ' to')
            + ' trip job_id: ' + tripRes.TripId + ' with location_id: ' + locationId);
          return true;
        }),
        catchError(() => {
          deps.messager.openSnackBar('Job saved, but there was an error updating the trip.', '[close]', 'errorAlert');
          return of(false);
        })
      );
    })
  );
}

@Component({
  selector: 'app-confirmation-selector',
  template: `
  <h1 mat-dialog-title> {{header}}</h1>
  <mat-dialog-content style="height:10vh">
    <h3><i>{{body}}</i></h3>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">NO</button>
    <button mat-button (click)="onYesClick()">YES</button>
  </div>
  `,
  styleUrls: ['./location.component.css']
})

export class ConfirmationComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<GridDeleteComponent>, private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any) { }

  header = this.data.header_text;
  body = this.data.body_text;

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close(2);
  }

  onYesClick(): void {
    this.dialogRef.close(1);
  }

}


@Component({
  selector: 'app-errorReport-selector',
  templateUrl: './errorReport.html',
  styleUrls: ['./location.component.css'],
  animations: [
    trigger(
      'fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
      ])
    ])
  ]
})

export class ReportErrorComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<ReportErrorComponent>, private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any, private locservice: LocationService, private employeeService: EmployeeService) { }

  location: any;
  errors:any = [];
  description: string = '';
  employees: any[] = [];
  errorType: string = '';
  selectedmodeler: string = '';

  ngOnInit(): void {

    this.location = this.data.location;
    this.employeeService.getEmployees().subscribe(
      res => {
        this.employees = res.Employees.filter(e => e.employeetype && e.employeetype.toLowerCase().includes('gps'));
      }
    );

    //get errors for this location
    this.locservice.getLocErrors(this.location.location_id).subscribe(
      res => {
        this.errors = res.Data;
        console.log(this.errors);
      }, err => {
        this.errors = [];
      });

  }

  addError(){
    const today = new Date();

    const resetValues = () => {
      this.description = '';
      this.selectedmodeler = '';
      this.errorType = '';
    } 
    const year: number = today.getFullYear();
    let month: number | string = today.getMonth() + 1;
    let day: number | string = today.getDate();

    month = month < 10 ? '0' + month.toString() : month.toString();
    day = day < 10 ? '0' + day.toString() : day.toString();

    let formattedDate: string = `${year}-${month}-${day}`;
    let newObj = ({
      description :this.description,
      committed_by: this.selectedmodeler, 
      errortype : this.errorType,
      employee_name : this.data.who,
      location_id : this.location.location_id,
      created_at: formattedDate
    });
    this.errors.push(newObj);
    this.locservice.insertLocError(newObj).subscribe(
      res => {
        resetValues();
      }, err => {
        resetValues();
      }
    )
  }

  close(): void {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'app-location-flags-component',
  templateUrl: './flags-location-dialog.html',
  styleUrls: ['./location.component.css']
})

export class FlagsDialogComponent implements OnInit {
  ekoIsLoading: boolean;

  faImport = faFileImport;
  faQaReview = faClipboardCheck;
  qaReviewLoading = false;
  qaReviewNote = this.data.qa_review || '';
  showQaReview = false;
  tiers: string[] = [];
  gasrebates: any[];
  elecrebates: any[];


  @ViewChild('ripple', { read: MatRipple}) ripple: MatRipple;
  @ViewChild('regripple', { read: MatRipple}) regripple: MatRipple;
  rebatedetailsdirty: boolean = false;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<GridDeleteComponent>, public log: LoggingService, private messager: MessagerComponent, private locationService:LocationService, private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any) { }



  flagsForm = new FormGroup({

    disclosuresent : new FormControl(this.data.disclosuresent || false),
    cfsent : new FormControl(this.data.cfsent || false),
    cert_printed : new FormControl(this.data.cert_printed || false),
    esmfnc : new FormControl(this.data.esmfnc || false),
    rem_done : new FormControl(this.data.rem_done),
    taxcred : new FormControl(this.data.taxcred || false),
    adminarchive : new FormControl(this.data.adminarchive || false),
    hvacovrd : new FormControl(this.data.hvacovrd || false),
    missinginfo : new FormControl(this.data.missinginfo || false),
    targetset: new FormControl(this.data.targetset || false),
    finalnotice : new FormControl(this.data.finalnotice || false),
    finalreport : new FormControl(this.data.finalreport || false),
    roughnotice : new FormControl(this.data.roughnotice || false),
    roughreport : new FormControl(this.data.roughreport || false),
    rebate1 : new FormControl(this.data.rebate1 || false),
    rebate2 : new FormControl(this.data.rebate2 || false),
    rebate2stat : new FormControl(this.data.rebate2stat || ''),
    rebate3 : new FormControl(this.data.rebate3 || false),
    registryid : new FormControl(this.data.registryid || ''),
    hers_index : new FormControl(this.data.hers_index || ''),
    ekotrope_id : new FormControl(this.data.ekotrope_id || ''),
    adminnotes : new FormControl(this.data.adminnotes || ''),
    gasrebate : new FormControl(this.data.gasrebatedetails?.gasrebate || null),
    gas_rebate1 : new FormControl(this.data.gasrebatedetails?.gas_rebate1 || false),
    gas_rebate2 : new FormControl(this.data.gasrebatedetails?.gas_rebate2 || false),
    gas_rebate_2_status : new FormControl(this.data.gasrebatedetails?.gas_rebate_2_status || null),
    gas_tier : new FormControl(this.data.gasrebatedetails?.gas_tier || null),
    elecrebate : new FormControl(this.data.electricrebatedetails?.elecrebate || null),
    electric_rebate1 : new FormControl(this.data.electricrebatedetails?.electric_rebate1 || false),
    electric_rebate2 : new FormControl(this.data.electricrebatedetails?.electric_rebate2 || false),
    electric_rebate_2_status : new FormControl(this.data.electricrebatedetails?.electric_rebate_2_status || null),
    electric_tier : new FormControl(this.data.electricrebatedetails?.electric_tier || null),
    threetenrep : new FormControl(this.data.threetenrep || ''),
    refrigpw : new FormControl(this.data.refrigpw || ''),
    hvac_dr_request : new FormControl(this.data.hvac_dr_request || false)

  });

  street_address;
  subdivision_name;
  lot;

  gasrebatedetails = {
    gasrebate : this.data.gasrebatedetails?.gasrebate || null,
    gas_rebate1 : this.data.gasrebatedetails?.gas_rebate1 || false,
    gas_rebate2 : this.data.gasrebatedetails?.gas_rebate2  || false,
    gas_rebate_2_status : this.data.gasrebatedetails?.gas_rebate_2_status || null,
    gas_tier : this.data.gasrebatedetails?.gas_tier || null
  };

  electricrebatedetails = {
    elecrebate : this.data.electricrebatedetails?.elecrebate || null,
    electric_rebate1 : this.data.electricrebatedetails?.electric_rebate1 || false,
    electric_rebate2 : this.data.electricrebatedetails?.electric_rebate2 || false,
    electric_rebate_2_status : this.data.electricrebatedetails?.electric_rebate_2_status || null,
    electric_tier : this.data.electricrebatedetails?.electric_tier || null
  };


  header = this.data.header_text;
  body = this.data.body_text;

  ngOnInit(): void {

    //console.log(this.data);
    this.street_address = this.data.street_address;
    this.subdivision_name = this.data.subdivision_name;
    this.lot = this.data.lot;

    if(this.data.electricrebatedetails?.electric_tier != null || this.data.electricrebatedetails?.elecrebate?.toLowerCase().includes('duke') ){
      this.tiers = ['Whole House', 'Whole House Plus', 'Equipment Only', 'ACE', 'ACE + HERS', ''];
    }

    this.getLatestSelections();

  }

  getLatestSelections() {

    this.locationService.getRebateSelections().subscribe(
      res => {
        ////console.log(res);
        this.gasrebates = res.Gas;
        this.elecrebates = res.Electric;
        //console.log(res);
        //console.log(this.gasrebates);
        //console.log(this.elecrebates);
      }, err => {
        //console.log(err);
      }
    )
  }


  onNoClick(): void {
    this.dialogRef.close(2);
  }

  onYesClick(): void {
    this.dialogRef.close(1);
  }

    setGasRebateDirty(): void {
      this.rebatedetailsdirty = true;
    }

  getEkotropeLink(projectID): string {
    return 'https://app.ekotrope.com/#project:' + projectID;
  }

  selectionChangeRebate(value){
    if(value.toLowerCase().includes('duke energy')){
      this.tiers = ['Whole House', 'Whole House Plus', 'Equipment Only', 'ACE', 'ACE + HERS', ''];
    }else {
      this.tiers.length = 0;
    }
  }



  openGasRebateModal(event): void {
    const modal = document.getElementById('gasModal');
    var input = document.getElementById('gasInput') as HTMLInputElement;
    input.value = '';

    if(modal){
      modal.style.display = 'block';
    }
  }

  openElecRebateModal(event): void {
    const modal = document.getElementById('elecModal');
    var input = document.getElementById('elecInput') as HTMLInputElement;
    input.value = '';
    if(modal){
      modal.style.display = 'block';
    }


  }

  handleElecResponse(response): void {

    var input = document.getElementById('elecInput') as HTMLInputElement;
    var inputValue = '';
    if(input) { var inputValue = input.value };

    const modal = document.getElementById('elecModal');
    if(modal){
      modal.style.display = 'none';
    }

    if(response == true){
      //console.log('user clicked save: ', inputValue);
      if(inputValue.length > 0){
        this.locationService.addRebate(inputValue, 'Electric').subscribe(
          res => {
            this.messager.openSnackBar('Added ' + inputValue + '!', '', 'successAlert');
            this.elecrebates.unshift({"rebate" : inputValue, "type" : "Electric"});
          });
      }
    }else {
    }
  }

  handleGasResponse(response): void {
    var input = document.getElementById('gasInput') as HTMLInputElement;
    var inputValue = '';
    if(input) { var inputValue = input.value };

    const modal = document.getElementById('gasModal');
    if(modal){
      modal.style.display = 'none';
    }


    if(response == true){
      if(inputValue.length > 0){
        this.locationService.addRebate(inputValue, 'Gas').subscribe(
          res => {
            this.messager.openSnackBar('Added ' + inputValue + '!', '', 'successAlert');
            this.gasrebates.unshift({"rebate" : inputValue, "type" : "Gas"});
          });
      }
    }else {
    }

  }


  missingInfoUpdate(): void {

    this.locationService.setMissingInfo(this.data.location_id).subscribe(
      res => {
        this.messager.openSnackBar('Missing info date set.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error updating missing info.', '', 'errorAlert');
      });

  }

  launchRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen'
    });
    ripRef.fadeOut();
  }

  // Colours the Import button: red until Ekotrope hands back a registry id, green once it has.
  // Modelers must re-import after registering, and a blank Registry ID is easy to overlook.
  get hasRegistryId(): boolean {
    const ctrl = this.flagsForm.get('registryid');
    const val = ctrl ? ctrl.value : null;
    return !!(val && val.toString().trim().length > 0);
  }

  // Pre-registration QA check against the live Ekotrope file. The backend prepends the
  // stamped findings to locmain.qa_review, so we just mirror the returned note locally.
  qaReview(): void {
    if (this.qaReviewLoading) { return; }
    this.qaReviewLoading = true;

    this.locationService.qaReview(this.data.location_id, { reviewer: this.data.usernamee }).subscribe(
      res => {
        this.qaReviewLoading = false;

        if (res.Error) {
          this.messager.openSnackBar(res.message || 'QA review failed', 'Close', 'errorAlert');
          this.log.error(`${this.data.usernamee} failed a QA review on location ${this.data.location_id} - ${res.message}`);
          return;
        }

        this.qaReviewNote = res.note;
        this.data.qa_review = res.note;
        this.showQaReview = true;

        this.dialog.open(QaReviewResultDialogComponent, {
          width: '640px',
          data: {
            checks: res.checks || [],
            findings: res.findings || [],
            naLines: res.naLines || [],
            logId: res.logId
          }
        });

        this.log.info(
          `${this.data.usernamee} ran a QA review on location ${this.data.location_id} - ` +
          `${(res.findings || []).length} finding(s) [qa_log: ${res.logId}]`
        );
      },
      err => {
        this.qaReviewLoading = false;
        this.messager.openSnackBar('Error running QA review, please try again..', 'Close', 'errorAlert');
        this.log.error(`${this.data.usernamee} failed a QA review on location ${this.data.location_id} - ${this.getErrorMessage(err)}`);
      }
    );
  }

  private getErrorMessage(err: any): string {
    if (err.error instanceof ErrorEvent) {
      return `Client error: ${err.error.message}`;
    } else if (err.error && typeof err.error === 'object') {
      return `Server error (${err.status} - ${err.statusText}): ${JSON.stringify(err.error)}`;
    } else if (err.message) {
      return `Error: ${err.message}`;
    }
    return 'Unknown error occurred';
  }


  ekoImport(importId: string): void {
    const ekoModel = {};
    this.ekoIsLoading = true;

    // load ekoproject from ekotrope api
    this.locationService.getEkotropeProject(importId).pipe(
      tap(res => {
        this.locationService.postEkoTropeProject(res.Response).subscribe(
          () => {
            const regid = res.Response.hersRatingDetails.registryId;
            this.data.registryid = regid;
            this.launchRipple(this.regripple);
            this.flagsForm.get('registryid').setValue(regid);

            // import utility rates
            res.Response.utilityRates.forEach(element => {
              this.locationService.postEkotropeUtilityRates(res.Response.id, element).subscribe(
                err => {
                  this.log.error(this.data.usernamee + ' failed to save ' + importId + ' to location ' + this.data.street_address.trim() );
                }
              );
            });
          },
          err => {
            this.log.error(this.data.usernamee + ' failed to save ' + importId + ' to location ' + this.data.street_address.trim() );
          }
        );
      }),
      mergeMap(res => {
         const plan = this.locationService.getEkotropePlan(res.Response.masterPlanId);
         const ana = this.locationService.getEkotropePlanAnalysis(res.Response.masterPlanId);
         return forkJoin([plan, ana]);
      }
      )
    ).subscribe(
      res => {
      this.locationService.postEkotropeHousePlan(importId, res[0].Response).subscribe(
        () => {
          this.locationService.postEkotropePlanAnalysis(importId, res[1].Response).subscribe(
            () => {
              this.log.info(this.data.usernamee + ' imported ekotrope project: ' + importId + ' to location ' + this.data.street_address.trim());

              this.messager.openSnackBar('Successfully imported Ekotrope project', '', 'successAlert');
            },
            err => {
              this.log.error(this.data.usernamee + ' failed to save ' + importId + ' to location ' + this.data.street_address.trim());
            }
          );
        },
        err => {
          this.log.error(this.data.usernamee + ' failed to save ' + importId + ' to location ' + this.data.street_address.trim() );
        }
      );

      this.ekoIsLoading = false;
      const hersindecks = res[1].Response.hersScore;
      this.data.hers_index = hersindecks;
      this.launchRipple(this.ripple);
      this.flagsForm.get('hers_index').setValue(hersindecks);
    },
    err => {
      this.log.error(this.data.usernamee + ' failed to save ' + importId + ' to location ' + this.data.street_address.trim());
      this.messager.openSnackBar('Error with Ekotrope import, please try again..', 'Close', 'errorAlert');
    }
    ); // subsc ribe

  }

  updateRebate3() {

    this.locationService.rebate3update(this.data.location_id)
    .subscribe(
      res => {
        this.messager.openSnackBar('Rebate date set.', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Error updating rebate date.', '', 'errorAlert');
      });

   }

   certPrintedDateUpdate() {
      //set missing info form control to false;
      this.flagsForm.controls['missinginfo'].setValue(false);
      //this.locationForm.controls['missinginfo']. = false;
      this.locationService.setCertPrintedDate(this.data.location_id).subscribe(
        res => {
          this.messager.openSnackBar('Certification printed date set.', '', 'successAlert');
        }, err => {
          this.messager.openSnackBar('Error updating certification printed date.', '', 'errorAlert');
        });
    }


  updateRebateObj(gas_or_electric,fieldname, value) {

    if(gas_or_electric == 'gas'){
      this.gasrebatedetails[fieldname] = value;
    }else {
      this.electricrebatedetails[fieldname] = value;
    }
    this.setGasRebateDirty();
  }


  save(): void {

    var locObj = this.flagsForm.value;
    locObj.gasrebatedetails = this.gasrebatedetails;
    locObj.electricrebatedetails = this.electricrebatedetails

    //console.log(locObj);
    locObj.plan = this.data.plan;
    locObj.hvac_contractor_id = this.data.hvac_contractor_id;
      if(this.gasrebatedetails.gasrebate != null){
        locObj.gasrebatedetails = this.gasrebatedetails;
        if(this.rebatedetailsdirty == true){
          if(this.gasrebatedetails.gas_rebate2 == true && this.gasrebatedetails.gas_rebate_2_status.toLowerCase().includes('pass')){
            this.locationService.sendGasRebateEmail(this.data.location_id).subscribe(
              res => {
              }, err => {
              }
            );
          }

        }
      }

    this.locationService.saveEdit(this.data.location_id, locObj,1).subscribe(
      (res) => {
        //this.dialogRef.close();

        if(this.flagsForm.get('esmfnc').value == true){
          //since we're editing, we'll have the location id
          this.locationService.insertESMFNC(res.LocationId).subscribe(
            res =>{
              this.messager.openSnackBar('ESMFNC date added!', '', 'successAlert');
            });

        }

         let changedProperties = [];
          Object.keys(this.flagsForm.controls).forEach((name) => {
              const currentControl = this.flagsForm.controls[name];

              if (currentControl.dirty) {
                changedProperties.push(name +': ' + this.flagsForm.controls[name].value);
              }
            });

          if(res.Error){

            let errMessage = res.Message;

            this.messager.openSnackBar('Error saving, an email with all data has been sent to support.', '[close]', 'errorAlert');

            this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.flagsForm.value.toString() + '} ' + res.Message );
          }else {
            this.log.info(this.data.usernamee + ' saved the following edits to location ' + this.data.street_address.trim() + ' {' + changedProperties.toString() + '}' + ' with location_id: ' + this.data.location_id );
          }

      },
      err => {

      this.log.error(this.data.usernamee + ' encountered an error creating a location: Submitted data: ' + '{' + this.flagsForm.value.toString() + '} ' + err.toString());
      }
    );

  }

}


@Component({
  selector: 'app-confirmation-selector',
  template: `
  <h1 mat-dialog-title>Single Family Track Settings</h1>

  <div [formGroup]="trackForm">
    <p>
      <mat-form-field>
        <mat-label>First Job Date</mat-label>
        <input matInput formControlName='firstjobdate' [matDatepicker]="firstjobdate">
        <mat-datepicker-toggle matSuffix [for]="firstjobdate"></mat-datepicker-toggle>
        <mat-datepicker #firstjobdate></mat-datepicker>
      </mat-form-field>
      <!-- Optional: Show error message if date is not selected -->
      <mat-error *ngIf="trackForm.get('firstjobdate').hasError('required')">
        First Job Date is required.
      </mat-error>
    </p>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="trackForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  `,
  styleUrls: ['./location.component.css']
})
export class TrackOptionsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TrackOptionsComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // Add Validators.required to the firstjobdate control
  trackForm = this.fb.group({
    firstjobdate: ['', Validators.required],
    path: ['']
  });

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close(2);
  }

  onYesClick(): void {
    ////console.log(this.trackForm.get('firstjobdate').value);
    ////console.log(this.trackForm.get('path').value);
    this.dialogRef.close({
      firstjobdate: this.trackForm.get('firstjobdate').value,
      path: ''
    });
  }
}

@Component({
  selector: 'app-builderselect-selector',
  template: `
  <h1 mat-dialog-title>Select Builder</h1>
  <div [formGroup]="builderForm">

    <mat-form-field style="width:80%">
    <mat-label>Customer:{{customer_name}} </mat-label>
    <input id='customerfield' #customername matInput placeholder="Type builder name here" formControlName = "customer_id" [matAutocomplete] = "custid">
    </mat-form-field>

    <mat-autocomplete #custid = "matAutocomplete" (optionSelected)="onSelectCustomer($event.option.value)" [displayWith]="displayFunctionCustomer">
      <mat-option *ngFor="let contractor of (customer$ | async)" [value]="contractor">
        <span>{{ contractor.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="builderForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  `,
  styleUrls: ['./location.component.css']
})
export class SelectBuilderComponent implements OnInit {
  paymenthold: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<TrackOptionsComponent>,
    private fb: FormBuilder,
    private locationService: LocationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // Add Validators.required to the firstjobdate control
  builderForm = this.fb.group({
    customer_id: ['', Validators.required],
  });

  public customer_name: string = '';
  public isLoading = false;
  public customer$: Observable<any[]>;

  ngOnInit(): void {

    this.customer$ = this.builderForm.get('customer_id').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
      }),
      switchMap(value =>
        value?.length > 0 ? this.locationService.getBuilderDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );


  }

  onNoClick(): void {
    this.dialogRef.close(2);
  }

  onSelectCustomer(customer){
    document.getElementById('customerfield').blur();
    ////console.log(customer);
    this.customer_name = customer.customer_name;
    this.paymenthold = customer.paymenthold;
    this.builderForm.get('customer_id').setValue(customer.customer_id);
  }

  displayFunctionCustomer(customer: Customer){
    if (customer) { return customer.customer_name; }
  }

  onYesClick(): void {
    this.dialogRef.close({
      customer_id: this.builderForm.get('customer_id').value,
      customer_name: this.customer_name,
      paymenthold : this.paymenthold
    });
  }
}

@Component({
  selector: 'app-select-hvac-contractor',
  template: `
  <h1 mat-dialog-title>Select HVAC Contractor</h1>
  <div [formGroup]="hvacForm">

    <mat-form-field style="width:80%">
    <mat-label>HVAC Contractor:{{customer_name}} </mat-label>
    <input id='hvaccontractorfield' matInput placeholder="Type contractor name here" formControlName="customer_id" [matAutocomplete]="hvacid">
    </mat-form-field>

    <mat-autocomplete #hvacid="matAutocomplete" (optionSelected)="onSelectContractor($event.option.value)" [displayWith]="displayContractor">
      <mat-option *ngFor="let contractor of (contractor$ | async)" [value]="contractor">
        <span>{{ contractor.customer_name }}</span>
      </mat-option>
    </mat-autocomplete>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="hvacForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  `,
  styleUrls: ['./location.component.css']
})
export class SelectHvacContractorComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SelectHvacContractorComponent>,
    private fb: FormBuilder,
    private locationService: LocationService
  ) {}

  hvacForm = this.fb.group({
    customer_id: ['', Validators.required],
  });

  public customer_name: string = '';
  public isLoading = false;
  public contractor$: Observable<any[]>;

  ngOnInit(): void {
    this.contractor$ = this.hvacForm.get('customer_id').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
      }),
      switchMap(value =>
        value?.length > 0 ? this.locationService.getHvacContractorDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
        )
      )
    );
  }

  onNoClick(): void {
    this.dialogRef.close(2);
  }

  onSelectContractor(contractor): void {
    document.getElementById('hvaccontractorfield').blur();
    this.customer_name = contractor.customer_name;
    this.hvacForm.get('customer_id').setValue(contractor.customer_id);
  }

  displayContractor(contractor): string {
    if (contractor) { return contractor.customer_name; }
  }

  onYesClick(): void {
    this.dialogRef.close({
      customer_id: this.hvacForm.get('customer_id').value,
      customer_name: this.customer_name
    });
  }
}

@Component({
  selector: 'app-add-utility-dialog',
  template: `
  <h1 mat-dialog-title style="color: #424242;">Add Utility</h1>

  <div [formGroup]="utilityForm">
    <mat-radio-group formControlName="type" style="display: flex; gap: 24px; margin-bottom: 16px;">
      <mat-radio-button value="gas">Gas</mat-radio-button>
      <mat-radio-button value="electric">Electric</mat-radio-button>
    </mat-radio-group>

    <mat-form-field style="width: 100%;">
      <mat-label>Utility Company</mat-label>
      <input matInput formControlName="company" maxlength="100" autocomplete="off">
    </mat-form-field>
    <div *ngIf="isDuplicate()" style="color: #d32f2f; font-size: 13px;">
      This {{ utilityForm.get('type').value === 'gas' ? 'gas' : 'electric' }} utility already exists.
    </div>

    <div mat-dialog-actions>
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-button [disabled]="utilityForm.invalid || isDuplicate() || saving" (click)="save()">Save</button>
    </div>
  </div>
  `,
  styleUrls: ['./location.component.css']
})
export class AddUtilityDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AddUtilityDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private locationService: LocationService,
    private _snackBar: MatSnackBar,
    public log: LoggingService
  ) {}

  utilityForm = this.fb.group({
    type: ['', Validators.required],
    company: ['', [Validators.required, Validators.pattern(/\S/)]]
  });

  existing = { gas: [] as string[], electric: [] as string[] };
  saving = false;

  ngOnInit(): void {
    this.locationService.getGasUtilities().subscribe(res => {
      this.existing.gas = (res.Data || []).map(u => this.normalize(u.company));
    });
    this.locationService.getElectricUtilities().subscribe(res => {
      this.existing.electric = (res.Data || []).map(u => this.normalize(u.company));
    });
  }

  normalize(name: string): string {
    return (name || '').trim().toLowerCase();
  }

  isDuplicate(): boolean {
    const type = this.utilityForm.get('type').value;
    const company = this.normalize(this.utilityForm.get('company').value);
    return !!type && !!company && this.existing[type].includes(company);
  }

  save(): void {
    const type = this.utilityForm.get('type').value;
    const company = this.utilityForm.get('company').value.trim();
    const typeLabel = type === 'gas' ? 'gas' : 'electric';
    this.saving = true;

    this.locationService.addUtility(type, company, this.data.who).subscribe(res => {
      this.saving = false;
      if (!res.Error) {
        const msg = res.EmailSent === false
          ? 'Added ' + company + ', but the notification email failed to send'
          : 'Added ' + company;
        this._snackBar.open(msg, 'close', { duration: 5000 });
        this.log.info(this.data.who + ' added a new ' + typeLabel + ' utility: ' + company + ' (id ' + res.Data.id + ')');
        this.dialogRef.close(res.Data);
      } else if (res.Duplicate) {
        this.existing[type].push(this.normalize(company));
        this._snackBar.open(company + ' already exists', 'close', { duration: 5000 });
      } else {
        this._snackBar.open('Error adding utility: ' + res.Message, 'close', { duration: 5000 });
        this.log.error(this.data.who + ' failed to add ' + typeLabel + ' utility ' + company + ': ' + res.Message);
      }
    }, err => {
      this.saving = false;
      this._snackBar.open('Error adding utility', 'close', { duration: 5000 });
      this.log.error(this.data.who + ' failed to add ' + typeLabel + ' utility ' + company + ': ' + (err.message || err));
    });
  }
}
